
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloudServerOutlined,
  NotificationOutlined,
  RocketOutlined,
  SendOutlined,
  ThunderboltOutlined,
  UserOutlined
} from '@ant-design/icons';


import njaFlag from "../../assets/flags/9ja.png";
import cdfFlag from "../../assets/flags/cdf.png";
import kesFlag from "../../assets/flags/kes.png";
import rwfFlag from "../../assets/flags/rwf.png";
import sspFlag from "../../assets/flags/ssp.png";
import tzsFlag from "../../assets/flags/tzs.png";
import ugxFlag from "../../assets/flags/ugx.png";

export const EntityTypes = {
  CLIENT: "Client",
  LOAN: "Loan",
  DEPOSIT: "Deposit",
  POLICY: "Policy",
  CLAIM: "Claim",
  PROCESS: "Process",
};

export const EntityTypeMap = {
  contact: EntityTypes.CLIENT,
  policy: EntityTypes.POLICY,
  claim: EntityTypes.CLAIM,
  deposit: EntityTypes.DEPOSIT,
  loan: EntityTypes.LOAN,
  process: EntityTypes.PROCESS,
};

export const EntityIdFieldMap = {
  [EntityTypes.CLIENT]: "clientId",
  [EntityTypes.LOAN]: "loanId",
  [EntityTypes.DEPOSIT]: "depositId",
  [EntityTypes.POLICY]: "policyId",
  [EntityTypes.CLAIM]: "claimId",
  [EntityTypes.PROCESS]: "processId",
};

export const EntityType = Object.freeze({
  NONE: 0,
  ENTITY: 1,
  CONTACT: 2,
  LOAN: 3,
  DEPOSIT: 4,
  TRANSACTION: 11,
  TELLER: 13,
  INWARD_TRANSACTION: 14,
  CUSTOMER: 100,
  LOAN_REQUEST: 101,
  TRANSFER: 102,
  BILLS_PAYMENT: 103,
  AIRTIME_RECHARGE: 104,
  DATA_RECHARGE: 105,
  RECONCILIATION: 200,
});

export const countryData = [
  {
    id: 1,
    name: "Nigeria",
    flag: njaFlag,
    phone: "+23470000367473",
    email: "info@empiretrustmfb.com",
    facebookLink: "http://facebook.com/empiretrustlag",
    // websiteLink: "https://www.banklingo.app/",

    twitterLink: "https://x.com/empiretrustlag",
  },
  // {
  //   id: 2,
  //   name: "South Sudan",
  //   flag: sspFlag,
  //   phone: "+211 916 986 000",
  //   email: "info-southsudan@banklingo.app",
  //   facebookLink: "https://www.facebook.com/banklingo/",
  //   websiteLink: "https://www.banklingo.app/",
  // },
  // {
  //   id: 3,
  //   name: "Congo (Democratic Republic of Congo)",
  //   flag: cdfFlag,
  //   phone: "+243 996 018 000",
  //   email: "mail@banklingo.app",
  //   twitterLink: "https://x.com/banklingo?lang=en",
  //   facebookLink: "https://www.facebook.com/banklingo/",
  //   linkedinLink: "https://www.linkedin.com/company/banklingo/",
  //   websiteLink: "https://banklingo.app/cd/",
  // },
  // {
  //   id: 4,
  //   name: "Rwanda",
  //   flag: rwfFlag,
  //   phone: "+250 788 190 000",
  //   email: "inforwanda@banklingo.app",
  //   twitterLink: "https://x.com/banklingo?lang=en",
  //   facebookLink: "https://www.facebook.com/banklingo/?ref=page_internal",
  //   websiteLink: "https://banklingo.app/rw/",
  // },
  // {
  //   id: 5,
  //   name: "Kenya",
  //   flag: kesFlag,
  //   phone: "+254 763 000 000",
  //   email: "info@banklingo.app",
  //   twitterLink: "https://x.com/banklingo?lang=en",
  //   facebookLink: "https://www.facebook.com/banklingo/?ref=page_internal",
  //   linkedinLink:
  //     "https://www.linkedin.com/company/banklingo/?originalSubdomain=ke",
  //   websiteLink: "https://banklingo.app/",
  // },
  // {
  //   id: 6,
  //   name: "Tanzania",
  //   flag: tzsFlag,
  //   phone: "+255 768 985 500",
  //   email: "infotz@banklingo.co.tz",
  //   twitterLink: "https://x.com/banklingo?lang=en",
  //   facebookLink: "https://www.facebook.com/banklingo/",
  //   websiteLink: "https://banklingo.app/tz/",
  // },
  // {
  //   id: 7,
  //   name: "Uganda",
  //   flag: ugxFlag,
  //   phone: "+256 312 327 000",
  //   email: "info@banklingo.co.ug",
  //   twitterLink: "https://x.com/banklingo?lang=en",
  //   facebookLink: "https://www.facebook.com/banklingo/",
  //   websiteLink: "https://banklingo.app/ug/",
  // },
];

export const PhoneAreas = [
  { code: "+234", flag: njaFlag, country: "Nigeria" },
  { code: "+211", flag: sspFlag, country: "South Sudan" },
  { code: "+243", flag: cdfFlag, country: "DRC" },
  { code: "+250", flag: rwfFlag, country: "Rwanda" },
  { code: "+254", flag: kesFlag, country: "Kenya" },
  { code: "+255", flag: tzsFlag, country: "Tanzania" },
  { code: "+256", flag: ugxFlag, country: "Uganda" },
];

export const productData = [
  {
    id: 1,
    name: "Payroll",
    code: "PR-1",
    interestRateCalculationPeriod: 1,
    interestRateCalculationDescription: "Weekly",
    interestRateCalculationsType: 0,
    interestRateCalculationsTypeDescription: "Flat",
    currencyCode: "NGN",
    interestRate: 23,
    disbursementFeeCalculation: 0,
    disbursementFeeCalculationDescription: "Flat",
    disbursementFee: 30000,
    minimumAmount: null,
    maximumAmount: null,
    maximumTenorInDays: 30,
    createdAt: "2024-10-23T13:13:32.8273173",
  },
  {
    id: 2,
    name: "Pay day",
    code: "PR-2",
    interestRateCalculationPeriod: 0,
    interestRateCalculationDescription: "Daily",
    interestRateCalculationsType: 0,
    interestRateCalculationsTypeDescription: "Flat",
    currencyCode: "NGN",
    interestRate: 0,
    disbursementFeeCalculation: 0,
    disbursementFeeCalculationDescription: "Flat",
    disbursementFee: 0,
    minimumAmount: null,
    maximumAmount: null,
    maximumTenorInDays: 30,
    createdAt: "2024-10-23T13:13:33.0474379",
  },
  {
    id: 3,
    name: "SME",
    code: "PR-3",
    interestRateCalculationPeriod: 0,
    interestRateCalculationDescription: "Daily",
    interestRateCalculationsType: 0,
    interestRateCalculationsTypeDescription: "Flat",
    currencyCode: "NGN",
    interestRate: 0,
    disbursementFeeCalculation: 0,
    disbursementFeeCalculationDescription: "Flat",
    disbursementFee: 0,
    minimumAmount: null,
    maximumAmount: null,
    maximumTenorInDays: 300,
    createdAt: "2024-10-23T13:38:47.250802",
  },
  {
    id: 4,
    name: "Assets Finance",
    code: "PR-4",
    interestRateCalculationPeriod: 0,
    interestRateCalculationDescription: "Daily",
    interestRateCalculationsType: 0,
    interestRateCalculationsTypeDescription: "Flat",
    currencyCode: "NGN",
    interestRate: 0,
    disbursementFeeCalculation: 0,
    disbursementFeeCalculationDescription: "Flat",
    disbursementFee: 0,
    minimumAmount: null,
    maximumAmount: null,
    maximumTenorInDays: 300,
    createdAt: "2024-10-23T13:38:47.2614081",
  },
  {
    id: 5,
    name: "Proof of funds",
    code: "PR-5",
    interestRateCalculationPeriod: 1,
    interestRateCalculationDescription: "Weekly",
    interestRateCalculationsType: 0,
    interestRateCalculationsTypeDescription: "Flat",
    currencyCode: "NGN",
    interestRate: 20,
    disbursementFeeCalculation: 0,
    disbursementFeeCalculationDescription: "Flat",
    disbursementFee: 34,
    minimumAmount: 12000,
    maximumAmount: 300000,
    maximumTenorInDays: 30,
    createdAt: "2024-10-24T18:38:48.6441462",
  },
];

export const documentTyps = [
  { name: "CUSTOM", key: 0 },
  { name: "NATIONAL ID", key: 1 },
  { name: "INTERNATIONAL PASSPORT", key: 2 },
  { name: "DRIVERS LICENCE", key: 3 },
  { name: "UTILITY BILL", key: 4 },
  { name: "BANK STATEMENT", key: 5 },
  { name: "COMPANY REGISTRATION", key: 6 },
  { name: "TAX CLEARANCE", key: 7 },
  { name: "CERTIFICATE OF INCORPORATION", key: 8 },
  { name: "MEMORANDUM OF ASSOCIATION", key: 9 },
  { name: "ARTICLES OF ASSOCIATION", key: 10 },
  { name: "BOARD RESOLUTION", key: 11 },
  { name: "IDENTITY CARD", key: 12 },
  { name: "SIGNATURE", key: 13 },
  { name: "PHOTOGRAPH", key: 14 },
  { name: "UNIVERISTY CERTIFICATE", key: 15 },
  { name: "BIRTH CERTIFICATE", key: 16 },
  { name: "MARRIAGE CERTIFICATE", key: 17 },
  { name: "DEATH CERTIFICATE", key: 18 },
  { name: "WILL", key: 19 },
  { name: "RESIDENCE PERMIT", key: 20 },
  { name: "WORK PERMIT", key: 21 },
  { name: "VISA", key: 22 },
  { name: "PERMANENT RESIDENCE", key: 23 },
];

export const accountDocumentTyps = [
  { name: "NATIONAL ID", key: 1 },
  { name: "INTERNATIONAL PASSPORT", key: 2 },
  { name: "DRIVERS LICENCE", key: 3 },
];

export const adminUserTypes = {
  roles: {
    customers: [
      {
        id: 1,
        name: "CUSTOMER",
        description: "General customer role.",
      },
    ],
    corporateProfileUsers: [
      {
        id: 3,
        name: "CORPORATE ADMINISTRATOR",
        description: "Administrator for corporate profiles.",
      },
      {
        id: 4,
        name: "INITIATOR",
        description: "Initiates actions in workflows.",
      },
      {
        id: 5,
        name: "REVIEWER",
        description: "Reviews actions in workflows.",
      },
      {
        id: 6,
        name: "APPROVER",
        description: "Approves actions in workflows.",
      },
      {
        id: 7,
        name: "VIEWER ANALYST",
        description: "Views and analyzes workflows.",
      },
    ],
    backOfficeAdministrators: [
      {
        id: 30,
        name: "Super Administrator",
        description: "Manages customer relationships.",
      },
      {
        id: 12,
        name: "Relationship manager",
        description: "Manages customer relationships.",
      },
      {
        id: 13,
        name: "Control officer",
        description: "Manages compliance and control.",
      },
      {
        id: 14,
        name: "Branch manager",
        description: "Oversees branch operations.",
      },
      {
        id: 15,
        name: "Area manager",
        description: "Oversees area operations.",
      },
      {
        id: 16,
        name: "Division manager",
        description: "Oversees division-level operations.",
      },
      {
        id: 17,
        name: "Credit admin",
        description: "Manages credit operations.",
      },
      {
        id: 170,
        name: "Head of credit admin",
        description: "Manages credit operations.",
      },
      {
        id: 171,
        name: "Finance",
        description: "Manages finance operations.",
      },
      {
        id: 18,
        name: "Managing director",
        description: "Managing Director.",
      },
      {
        id: 19,
        name: "GMD (BOARD)",
        description: "Board-level role.",
      },
      {
        id: 20,
        name: "Mandate Administrator",
        description: "Manages mandates.",
      },
      {
        id: 21,
        name: "Mandate Initiator",
        description: "Initiates mandates.",
      },
      {
        id: 22,
        name: "Mandate Reviewer",
        description: "Reviews mandates.",
      },
      {
        id: 23,
        name: "Mandate Collection Initiator",
        description: "Initiates mandate collection.",
      },
      {
        id: 24,
        name: "Mandate Collection Authorizer",
        description: "Authorize mandate collection.",
      },
      {
        id: 25,
        name: "Mandate Collection Reviewer",
        description: "Review mandate collection.",
      },
      {
        id: 26,
        name: "Mandate Auhorizer",
        description: "Authorize mandate.",
      },
    ],
    systemAndApiRoles: [
      {
        id: 30,
        name: "Super admin",
        description: "Full administrative access.",
      },
      {
        id: 31,
        name: "API DEVELOPER CUSTOMER PORTAL",
        description: "Developer for customer-facing APIs.",
      },
      {
        id: 32,
        name: "API DEVELOPER ADMIN PORTAL",
        description: "Developer for admin-facing APIs.",
      },
      {
        id: 33,
        name: "CUSTOM ROLES",
        description: "Custom role for specialized operations.",
      },
    ],
  },
};

export const schemaTypeOptions = [
  {
    label: "Schema",
    value: 0,
  },
  {
    label: "Language",
    value: 1,
  },
  {
    label: "Loan Config",
    value: 2,
  },
  {
    label: "Insurance Config",
    value: 3,
  },
  {
    label: "Deposit Config",
    value: 4,
  },
  {
    label: "Feature Toggle",
    value: 5,
  },
  {
    label: "Platform Config",
    value: 6,
  },

  {
    label: "Default Config",
    value: 7,
  },
  {
    label: "Native Commands",
    value: 8,
  },
  {
    label: "Adverts Config",
    value: 9,
  },
  {
    label: "FAQ Config",
    value: 10,
  },
];

export const contextMenu = {
  items: {
    row_above: { name: "Insert row above" },
    row_below: { name: "Insert row below" },
    col_left: { name: "Insert column left" },
    col_right: { name: "Insert column right" },
    remove_row: { name: "Remove row" },
    remove_col: { name: "Remove column" },
    "---------": { name: "---------", disabled: true },
    undo: { name: "Undo" },
    redo: { name: "Redo" },
    "---------": { name: "---------", disabled: true },
    make_read_only: { name: "Read only" },
    alignment: { name: "Alignment" },
    "---------": { name: "---------", disabled: true },
    copy: { name: "Copy" },
    cut: { name: "Cut" },
  },
};



export const TEMPLATE_BPMN_CONTENT = {
  // Simple Approval Template
  'simple-approval': `<?xml version="1.0" encoding="UTF-8"?>
<bpmn:definitions xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:camunda="http://camunda.org/schema/1.0/bpmn" id="Definitions_1" targetNamespace="http://bpmn.io/schema/bpmn">
  <bpmn:process id="Process_1" isExecutable="true">
    <bpmn:startEvent id="StartEvent_1">
      <bpmn:outgoing>Flow_1</bpmn:outgoing>
    </bpmn:startEvent>
    <bpmn:userTask id="UserTask_1" name="Submit Request" camunda:assignee="\${initiator}">
      <bpmn:incoming>Flow_1</bpmn:incoming>
      <bpmn:outgoing>Flow_2</bpmn:outgoing>
    </bpmn:userTask>
    <bpmn:userTask id="UserTask_2" name="Review Request" camunda:candidateGroups="managers">
      <bpmn:incoming>Flow_2</bpmn:incoming>
      <bpmn:outgoing>Flow_3</bpmn:outgoing>
    </bpmn:userTask>
    <bpmn:exclusiveGateway id="Gateway_1" default="Flow_4">
      <bpmn:incoming>Flow_3</bpmn:incoming>
      <bpmn:outgoing>Flow_5</bpmn:outgoing>
      <bpmn:outgoing>Flow_4</bpmn:outgoing>
    </bpmn:exclusiveGateway>
    <bpmn:endEvent id="EndEvent_1" name="Request Approved">
      <bpmn:incoming>Flow_5</bpmn:incoming>
    </bpmn:endEvent>
    <bpmn:endEvent id="EndEvent_2" name="Request Rejected">
      <bpmn:incoming>Flow_4</bpmn:incoming>
    </bpmn:endEvent>
    <bpmn:sequenceFlow id="Flow_1" sourceRef="StartEvent_1" targetRef="UserTask_1" />
    <bpmn:sequenceFlow id="Flow_2" sourceRef="UserTask_1" targetRef="UserTask_2" />
    <bpmn:sequenceFlow id="Flow_3" sourceRef="UserTask_2" targetRef="Gateway_1" />
    <bpmn:sequenceFlow id="Flow_4" sourceRef="Gateway_1" targetRef="EndEvent_2" name="Rejected">
      <bpmn:conditionExpression xsi:type="bpmn:tFormalExpression">\${outcome == "reject"}</bpmn:conditionExpression>
    </bpmn:sequenceFlow>
    <bpmn:sequenceFlow id="Flow_5" sourceRef="Gateway_1" targetRef="EndEvent_1" name="Approved">
      <bpmn:conditionExpression xsi:type="bpmn:tFormalExpression">\${outcome == "approve"}</bpmn:conditionExpression>
    </bpmn:sequenceFlow>
  </bpmn:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1">
      <bpmndi:BPMNShape id="_BPMNShape_StartEvent_2" bpmnElement="StartEvent_1">
        <dc:Bounds x="173" y="102" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="UserTask_1_di" bpmnElement="UserTask_1">
        <dc:Bounds x="260" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="UserTask_2_di" bpmnElement="UserTask_2">
        <dc:Bounds x="420" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="Gateway_1_di" bpmnElement="Gateway_1" isMarkerVisible="true">
        <dc:Bounds x="580" y="95" width="50" height="50" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="EndEvent_1_di" bpmnElement="EndEvent_1">
        <dc:Bounds x="692" y="102" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="EndEvent_2_di" bpmnElement="EndEvent_2">
        <dc:Bounds x="692" y="202" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="Flow_1_di" bpmnElement="Flow_1">
        <di:waypoint x="209" y="120" />
        <di:waypoint x="260" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_2_di" bpmnElement="Flow_2">
        <di:waypoint x="360" y="120" />
        <di:waypoint x="420" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_3_di" bpmnElement="Flow_3">
        <di:waypoint x="520" y="120" />
        <di:waypoint x="580" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_4_di" bpmnElement="Flow_4">
        <di:waypoint x="605" y="145" />
        <di:waypoint x="605" y="220" />
        <di:waypoint x="692" y="220" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_5_di" bpmnElement="Flow_5">
        <di:waypoint x="630" y="120" />
        <di:waypoint x="692" y="120" />
      </bpmndi:BPMNEdge>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn:definitions>`,

  // Notification System Template
  'notification-system': `<?xml version="1.0" encoding="UTF-8"?>
<bpmn:definitions xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:camunda="http://camunda.org/schema/1.0/bpmn" id="Definitions_1" targetNamespace="http://bpmn.io/schema/bpmn">
  <bpmn:process id="Process_1" isExecutable="true">
    <bpmn:startEvent id="StartEvent_1">
      <bpmn:outgoing>Flow_1</bpmn:outgoing>
    </bpmn:startEvent>
    <bpmn:serviceTask id="ServiceTask_1" name="Prepare Notification">
      <bpmn:incoming>Flow_1</bpmn:incoming>
      <bpmn:outgoing>Flow_2</bpmn:outgoing>
    </bpmn:serviceTask>
    <bpmn:parallelGateway id="Gateway_1">
      <bpmn:incoming>Flow_2</bpmn:incoming>
      <bpmn:outgoing>Flow_3</bpmn:outgoing>
      <bpmn:outgoing>Flow_4</bpmn:outgoing>
    </bpmn:parallelGateway>
    <bpmn:serviceTask id="ServiceTask_2" name="Send Email">
      <bpmn:incoming>Flow_3</bpmn:incoming>
      <bpmn:outgoing>Flow_5</bpmn:outgoing>
    </bpmn:serviceTask>
    <bpmn:serviceTask id="ServiceTask_3" name="Send SMS">
      <bpmn:incoming>Flow_4</bpmn:incoming>
      <bpmn:outgoing>Flow_6</bpmn:outgoing>
    </bpmn:serviceTask>
    <bpmn:parallelGateway id="Gateway_2">
      <bpmn:incoming>Flow_5</bpmn:incoming>
      <bpmn:incoming>Flow_6</bpmn:incoming>
      <bpmn:outgoing>Flow_7</bpmn:outgoing>
    </bpmn:parallelGateway>
    <bpmn:endEvent id="EndEvent_1" name="Notifications Sent">
      <bpmn:incoming>Flow_7</bpmn:incoming>
    </bpmn:endEvent>
    <bpmn:sequenceFlow id="Flow_1" sourceRef="StartEvent_1" targetRef="ServiceTask_1" />
    <bpmn:sequenceFlow id="Flow_2" sourceRef="ServiceTask_1" targetRef="Gateway_1" />
    <bpmn:sequenceFlow id="Flow_3" sourceRef="Gateway_1" targetRef="ServiceTask_2" />
    <bpmn:sequenceFlow id="Flow_4" sourceRef="Gateway_1" targetRef="ServiceTask_3" />
    <bpmn:sequenceFlow id="Flow_5" sourceRef="ServiceTask_2" targetRef="Gateway_2" />
    <bpmn:sequenceFlow id="Flow_6" sourceRef="ServiceTask_3" targetRef="Gateway_2" />
    <bpmn:sequenceFlow id="Flow_7" sourceRef="Gateway_2" targetRef="EndEvent_1" />
  </bpmn:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1">
      <bpmndi:BPMNShape id="_BPMNShape_StartEvent_2" bpmnElement="StartEvent_1">
        <dc:Bounds x="173" y="102" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="ServiceTask_1_di" bpmnElement="ServiceTask_1">
        <dc:Bounds x="260" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="Gateway_1_di" bpmnElement="Gateway_1" isMarkerVisible="true">
        <dc:Bounds x="420" y="95" width="50" height="50" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="ServiceTask_2_di" bpmnElement="ServiceTask_2">
        <dc:Bounds x="530" y="40" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="ServiceTask_3_di" bpmnElement="ServiceTask_3">
        <dc:Bounds x="530" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="Gateway_2_di" bpmnElement="Gateway_2" isMarkerVisible="true">
        <dc:Bounds x="690" y="95" width="50" height="50" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="EndEvent_1_di" bpmnElement="EndEvent_1">
        <dc:Bounds x="792" y="102" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="Flow_1_di" bpmnElement="Flow_1">
        <di:waypoint x="209" y="120" />
        <di:waypoint x="260" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_2_di" bpmnElement="Flow_2">
        <di:waypoint x="360" y="120" />
        <di:waypoint x="420" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_3_di" bpmnElement="Flow_3">
        <di:waypoint x="445" y="95" />
        <di:waypoint x="445" y="80" />
        <di:waypoint x="530" y="80" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_4_di" bpmnElement="Flow_4">
        <di:waypoint x="445" y="145" />
        <di:waypoint x="445" y="180" />
        <di:waypoint x="530" y="180" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_5_di" bpmnElement="Flow_5">
        <di:waypoint x="630" y="80" />
        <di:waypoint x="690" y="95" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_6_di" bpmnElement="Flow_6">
        <di:waypoint x="630" y="180" />
        <di:waypoint x="690" y="145" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_7_di" bpmnElement="Flow_7">
        <di:waypoint x="740" y="120" />
        <di:waypoint x="792" y="120" />
      </bpmndi:BPMNEdge>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn:definitions>`,

  // Data Synchronization Template
  'data-sync': `<?xml version="1.0" encoding="UTF-8"?>
<bpmn:definitions xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:camunda="http://camunda.org/schema/1.0/bpmn" id="Definitions_1" targetNamespace="http://bpmn.io/schema/bpmn">
  <bpmn:process id="Process_1" isExecutable="true">
    <bpmn:startEvent id="StartEvent_1">
      <bpmn:outgoing>Flow_1</bpmn:outgoing>
    </bpmn:startEvent>
    <bpmn:serviceTask id="ServiceTask_1" name="Extract Data">
      <bpmn:incoming>Flow_1</bpmn:incoming>
      <bpmn:outgoing>Flow_2</bpmn:outgoing>
    </bpmn:serviceTask>
    <bpmn:scriptTask id="ScriptTask_1" name="Transform Data">
      <bpmn:incoming>Flow_2</bpmn:incoming>
      <bpmn:outgoing>Flow_3</bpmn:outgoing>
    </bpmn:scriptTask>
    <bpmn:serviceTask id="ServiceTask_2" name="Load Data">
      <bpmn:incoming>Flow_3</bpmn:incoming>
      <bpmn:outgoing>Flow_4</bpmn:outgoing>
    </bpmn:serviceTask>
    <bpmn:serviceTask id="ServiceTask_3" name="Send Report">
      <bpmn:incoming>Flow_4</bpmn:incoming>
      <bpmn:outgoing>Flow_5</bpmn:outgoing>
    </bpmn:serviceTask>
    <bpmn:endEvent id="EndEvent_1" name="Sync Completed">
      <bpmn:incoming>Flow_5</bpmn:incoming>
    </bpmn:endEvent>
    <bpmn:sequenceFlow id="Flow_1" sourceRef="StartEvent_1" targetRef="ServiceTask_1" />
    <bpmn:sequenceFlow id="Flow_2" sourceRef="ServiceTask_1" targetRef="ScriptTask_1" />
    <bpmn:sequenceFlow id="Flow_3" sourceRef="ScriptTask_1" targetRef="ServiceTask_2" />
    <bpmn:sequenceFlow id="Flow_4" sourceRef="ServiceTask_2" targetRef="ServiceTask_3" />
    <bpmn:sequenceFlow id="Flow_5" sourceRef="ServiceTask_3" targetRef="EndEvent_1" />
  </bpmn:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1">
      <bpmndi:BPMNShape id="_BPMNShape_StartEvent_2" bpmnElement="StartEvent_1">
        <dc:Bounds x="173" y="102" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="ServiceTask_1_di" bpmnElement="ServiceTask_1">
        <dc:Bounds x="260" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="ScriptTask_1_di" bpmnElement="ScriptTask_1">
        <dc:Bounds x="420" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="ServiceTask_2_di" bpmnElement="ServiceTask_2">
        <dc:Bounds x="580" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="ServiceTask_3_di" bpmnElement="ServiceTask_3">
        <dc:Bounds x="740" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="EndEvent_1_di" bpmnElement="EndEvent_1">
        <dc:Bounds x="892" y="102" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="Flow_1_di" bpmnElement="Flow_1">
        <di:waypoint x="209" y="120" />
        <di:waypoint x="260" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_2_di" bpmnElement="Flow_2">
        <di:waypoint x="360" y="120" />
        <di:waypoint x="420" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_3_di" bpmnElement="Flow_3">
        <di:waypoint x="520" y="120" />
        <di:waypoint x="580" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_4_di" bpmnElement="Flow_4">
        <di:waypoint x="680" y="120" />
        <di:waypoint x="740" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_5_di" bpmnElement="Flow_5">
        <di:waypoint x="840" y="120" />
        <di:waypoint x="892" y="120" />
      </bpmndi:BPMNEdge>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn:definitions>`,

  // Multi-level Approval Template
  'multi-level-approval': `<?xml version="1.0" encoding="UTF-8"?>
<bpmn:definitions xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:camunda="http://camunda.org/schema/1.0/bpmn" id="Definitions_1" targetNamespace="http://bpmn.io/schema/bpmn">
  <bpmn:process id="Process_1" isExecutable="true">
    <bpmn:startEvent id="StartEvent_1">
      <bpmn:outgoing>Flow_1</bpmn:outgoing>
    </bpmn:startEvent>
    <bpmn:userTask id="UserTask_1" name="Submit Request">
      <bpmn:incoming>Flow_1</bpmn:incoming>
      <bpmn:outgoing>Flow_2</bpmn:outgoing>
    </bpmn:userTask>
    <bpmn:userTask id="UserTask_2" name="Team Lead Approval">
      <bpmn:incoming>Flow_2</bpmn:incoming>
      <bpmn:outgoing>Flow_3</bpmn:outgoing>
    </bpmn:userTask>
    <bpmn:exclusiveGateway id="Gateway_1">
      <bpmn:incoming>Flow_3</bpmn:incoming>
      <bpmn:outgoing>Flow_4</bpmn:outgoing>
      <bpmn:outgoing>Flow_5</bpmn:outgoing>
    </bpmn:exclusiveGateway>
    <bpmn:userTask id="UserTask_3" name="Department Head Approval">
      <bpmn:incoming>Flow_4</bpmn:incoming>
      <bpmn:outgoing>Flow_6</bpmn:outgoing>
    </bpmn:userTask>
    <bpmn:exclusiveGateway id="Gateway_2">
      <bpmn:incoming>Flow_6</bpmn:incoming>
      <bpmn:outgoing>Flow_7</bpmn:outgoing>
      <bpmn:outgoing>Flow_8</bpmn:outgoing>
    </bpmn:exclusiveGateway>
    <bpmn:userTask id="UserTask_4" name="Final Executive Approval">
      <bpmn:incoming>Flow_7</bpmn:incoming>
      <bpmn:outgoing>Flow_9</bpmn:outgoing>
    </bpmn:userTask>
    <bpmn:endEvent id="EndEvent_1" name="Approved">
      <bpmn:incoming>Flow_9</bpmn:incoming>
    </bpmn:endEvent>
    <bpmn:endEvent id="EndEvent_2" name="Rejected">
      <bpmn:incoming>Flow_5</bpmn:incoming>
      <bpmn:incoming>Flow_8</bpmn:incoming>
    </bpmn:endEvent>
    <bpmn:sequenceFlow id="Flow_1" sourceRef="StartEvent_1" targetRef="UserTask_1" />
    <bpmn:sequenceFlow id="Flow_2" sourceRef="UserTask_1" targetRef="UserTask_2" />
    <bpmn:sequenceFlow id="Flow_3" sourceRef="UserTask_2" targetRef="Gateway_1" />
    <bpmn:sequenceFlow id="Flow_4" sourceRef="Gateway_1" targetRef="UserTask_3" name="Approved">
      <bpmn:conditionExpression xsi:type="bpmn:tFormalExpression">\${outcome == "approve"}</bpmn:conditionExpression>
    </bpmn:sequenceFlow>
    <bpmn:sequenceFlow id="Flow_5" sourceRef="Gateway_1" targetRef="EndEvent_2" name="Rejected">
      <bpmn:conditionExpression xsi:type="bpmn:tFormalExpression">\${outcome == "reject"}</bpmn:conditionExpression>
    </bpmn:sequenceFlow>
    <bpmn:sequenceFlow id="Flow_6" sourceRef="UserTask_3" targetRef="Gateway_2" />
    <bpmn:sequenceFlow id="Flow_7" sourceRef="Gateway_2" targetRef="UserTask_4" name="Approved">
      <bpmn:conditionExpression xsi:type="bpmn:tFormalExpression">\${outcome == "approve"}</bpmn:conditionExpression>
    </bpmn:sequenceFlow>
    <bpmn:sequenceFlow id="Flow_8" sourceRef="Gateway_2" targetRef="EndEvent_2" name="Rejected">
      <bpmn:conditionExpression xsi:type="bpmn:tFormalExpression">\${outcome == "reject"}</bpmn:conditionExpression>
    </bpmn:sequenceFlow>
    <bpmn:sequenceFlow id="Flow_9" sourceRef="UserTask_4" targetRef="EndEvent_1" />
  </bpmn:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1">
      <bpmndi:BPMNShape id="_BPMNShape_StartEvent_2" bpmnElement="StartEvent_1">
        <dc:Bounds x="173" y="102" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="UserTask_1_di" bpmnElement="UserTask_1">
        <dc:Bounds x="260" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="UserTask_2_di" bpmnElement="UserTask_2">
        <dc:Bounds x="420" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="Gateway_1_di" bpmnElement="Gateway_1" isMarkerVisible="true">
        <dc:Bounds x="580" y="95" width="50" height="50" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="UserTask_3_di" bpmnElement="UserTask_3">
        <dc:Bounds x="690" y="40" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="Gateway_2_di" bpmnElement="Gateway_2" isMarkerVisible="true">
        <dc:Bounds x="850" y="95" width="50" height="50" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="UserTask_4_di" bpmnElement="UserTask_4">
        <dc:Bounds x="960" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="EndEvent_1_di" bpmnElement="EndEvent_1">
        <dc:Bounds x="1120" y="102" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="EndEvent_2_di" bpmnElement="EndEvent_2">
        <dc:Bounds x="1120" y="202" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="Flow_1_di" bpmnElement="Flow_1">
        <di:waypoint x="209" y="120" />
        <di:waypoint x="260" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_2_di" bpmnElement="Flow_2">
        <di:waypoint x="360" y="120" />
        <di:waypoint x="420" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_3_di" bpmnElement="Flow_3">
        <di:waypoint x="520" y="120" />
        <di:waypoint x="580" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_4_di" bpmnElement="Flow_4">
        <di:waypoint x="605" y="95" />
        <di:waypoint x="605" y="80" />
        <di:waypoint x="690" y="80" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_5_di" bpmnElement="Flow_5">
        <di:waypoint x="605" y="145" />
        <di:waypoint x="605" y="220" />
        <di:waypoint x="1120" y="220" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_6_di" bpmnElement="Flow_6">
        <di:waypoint x="790" y="80" />
        <di:waypoint x="850" y="95" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_7_di" bpmnElement="Flow_7">
        <di:waypoint x="875" y="95" />
        <di:waypoint x="875" y="120" />
        <di:waypoint x="960" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_8_di" bpmnElement="Flow_8">
        <di:waypoint x="875" y="145" />
        <di:waypoint x="875" y="220" />
        <di:waypoint x="1120" y="220" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_9_di" bpmnElement="Flow_9">
        <di:waypoint x="1060" y="120" />
        <di:waypoint x="1120" y="120" />
      </bpmndi:BPMNEdge>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn:definitions>`,

  // Employee Onboarding Template
  'employee-onboarding': `<?xml version="1.0" encoding="UTF-8"?>
<bpmn:definitions xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:camunda="http://camunda.org/schema/1.0/bpmn" id="Definitions_1" targetNamespace="http://bpmn.io/schema/bpmn">
  <bpmn:process id="Process_1" isExecutable="true">
    <bpmn:startEvent id="StartEvent_1">
      <bpmn:outgoing>Flow_1</bpmn:outgoing>
    </bpmn:startEvent>
    <bpmn:userTask id="UserTask_1" name="HR Documentation">
      <bpmn:incoming>Flow_1</bpmn:incoming>
      <bpmn:outgoing>Flow_2</bpmn:outgoing>
    </bpmn:userTask>
    <bpmn:parallelGateway id="Gateway_1">
      <bpmn:incoming>Flow_2</bpmn:incoming>
      <bpmn:outgoing>Flow_3</bpmn:outgoing>
      <bpmn:outgoing>Flow_4</bpmn:outgoing>
      <bpmn:outgoing>Flow_5</bpmn:outgoing>
    </bpmn:parallelGateway>
    <bpmn:userTask id="UserTask_2" name="IT Setup">
      <bpmn:incoming>Flow_3</bpmn:incoming>
      <bpmn:outgoing>Flow_6</bpmn:outgoing>
    </bpmn:userTask>
    <bpmn:userTask id="UserTask_3" name="Facilities Access">
      <bpmn:incoming>Flow_4</bpmn:incoming>
      <bpmn:outgoing>Flow_7</bpmn:outgoing>
    </bpmn:userTask>
    <bpmn:userTask id="UserTask_4" name="Team Introduction">
      <bpmn:incoming>Flow_5</bpmn:incoming>
      <bpmn:outgoing>Flow_8</bpmn:outgoing>
    </bpmn:userTask>
    <bpmn:parallelGateway id="Gateway_2">
      <bpmn:incoming>Flow_6</bpmn:incoming>
      <bpmn:incoming>Flow_7</bpmn:incoming>
      <bpmn:incoming>Flow_8</bpmn:incoming>
      <bpmn:outgoing>Flow_9</bpmn:outgoing>
    </bpmn:parallelGateway>
    <bpmn:userTask id="UserTask_5" name="Final Welcome">
      <bpmn:incoming>Flow_9</bpmn:incoming>
      <bpmn:outgoing>Flow_10</bpmn:outgoing>
    </bpmn:userTask>
    <bpmn:endEvent id="EndEvent_1" name="Onboarding Complete">
      <bpmn:incoming>Flow_10</bpmn:incoming>
    </bpmn:endEvent>
    <bpmn:sequenceFlow id="Flow_1" sourceRef="StartEvent_1" targetRef="UserTask_1" />
    <bpmn:sequenceFlow id="Flow_2" sourceRef="UserTask_1" targetRef="Gateway_1" />
    <bpmn:sequenceFlow id="Flow_3" sourceRef="Gateway_1" targetRef="UserTask_2" />
    <bpmn:sequenceFlow id="Flow_4" sourceRef="Gateway_1" targetRef="UserTask_3" />
    <bpmn:sequenceFlow id="Flow_5" sourceRef="Gateway_1" targetRef="UserTask_4" />
    <bpmn:sequenceFlow id="Flow_6" sourceRef="UserTask_2" targetRef="Gateway_2" />
    <bpmn:sequenceFlow id="Flow_7" sourceRef="UserTask_3" targetRef="Gateway_2" />
    <bpmn:sequenceFlow id="Flow_8" sourceRef="UserTask_4" targetRef="Gateway_2" />
    <bpmn:sequenceFlow id="Flow_9" sourceRef="Gateway_2" targetRef="UserTask_5" />
    <bpmn:sequenceFlow id="Flow_10" sourceRef="UserTask_5" targetRef="EndEvent_1" />
  </bpmn:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1">
      <bpmndi:BPMNShape id="_BPMNShape_StartEvent_2" bpmnElement="StartEvent_1">
        <dc:Bounds x="173" y="102" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="UserTask_1_di" bpmnElement="UserTask_1">
        <dc:Bounds x="260" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="Gateway_1_di" bpmnElement="Gateway_1" isMarkerVisible="true">
        <dc:Bounds x="420" y="95" width="50" height="50" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="UserTask_2_di" bpmnElement="UserTask_2">
        <dc:Bounds x="530" y="40" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="UserTask_3_di" bpmnElement="UserTask_3">
        <dc:Bounds x="530" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="UserTask_4_di" bpmnElement="UserTask_4">
        <dc:Bounds x="530" y="240" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="Gateway_2_di" bpmnElement="Gateway_2" isMarkerVisible="true">
        <dc:Bounds x="690" y="95" width="50" height="50" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="UserTask_5_di" bpmnElement="UserTask_5">
        <dc:Bounds x="800" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="EndEvent_1_di" bpmnElement="EndEvent_1">
        <dc:Bounds x="952" y="102" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="Flow_1_di" bpmnElement="Flow_1">
        <di:waypoint x="209" y="120" />
        <di:waypoint x="260" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_2_di" bpmnElement="Flow_2">
        <di:waypoint x="360" y="120" />
        <di:waypoint x="420" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_3_di" bpmnElement="Flow_3">
        <di:waypoint x="445" y="95" />
        <di:waypoint x="445" y="80" />
        <di:waypoint x="530" y="80" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_4_di" bpmnElement="Flow_4">
        <di:waypoint x="445" y="120" />
        <di:waypoint x="530" y="180" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_5_di" bpmnElement="Flow_5">
        <di:waypoint x="445" y="145" />
        <di:waypoint x="445" y="280" />
        <di:waypoint x="530" y="280" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_6_di" bpmnElement="Flow_6">
        <di:waypoint x="630" y="80" />
        <di:waypoint x="690" y="95" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_7_di" bpmnElement="Flow_7">
        <di:waypoint x="630" y="180" />
        <di:waypoint x="690" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_8_di" bpmnElement="Flow_8">
        <di:waypoint x="630" y="280" />
        <di:waypoint x="690" y="145" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_9_di" bpmnElement="Flow_9">
        <di:waypoint x="740" y="120" />
        <di:waypoint x="800" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_10_di" bpmnElement="Flow_10">
        <di:waypoint x="900" y="120" />
        <di:waypoint x="952" y="120" />
      </bpmndi:BPMNEdge>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn:definitions>`,

  // Incident Management Template
  'incident-management': `<?xml version="1.0" encoding="UTF-8"?>
<bpmn:definitions xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:camunda="http://camunda.org/schema/1.0/bpmn" id="Definitions_1" targetNamespace="http://bpmn.io/schema/bpmn">
  <bpmn:process id="Process_1" isExecutable="true">
    <bpmn:startEvent id="StartEvent_1">
      <bpmn:outgoing>Flow_1</bpmn:outgoing>
    </bpmn:startEvent>
    <bpmn:userTask id="UserTask_1" name="Log Incident">
      <bpmn:incoming>Flow_1</bpmn:incoming>
      <bpmn:outgoing>Flow_2</bpmn:outgoing>
    </bpmn:userTask>
    <bpmn:exclusiveGateway id="Gateway_1">
      <bpmn:incoming>Flow_2</bpmn:incoming>
      <bpmn:outgoing>Flow_3</bpmn:outgoing>
      <bpmn:outgoing>Flow_4</bpmn:outgoing>
    </bpmn:exclusiveGateway>
    <bpmn:userTask id="UserTask_2" name="Tier 1 Support">
      <bpmn:incoming>Flow_3</bpmn:incoming>
      <bpmn:outgoing>Flow_5</bpmn:outgoing>
    </bpmn:userTask>
    <bpmn:userTask id="UserTask_3" name="Tier 2 Support">
      <bpmn:incoming>Flow_4</bpmn:incoming>
      <bpmn:outgoing>Flow_6</bpmn:outgoing>
    </bpmn:userTask>
    <bpmn:serviceTask id="ServiceTask_1" name="Send Resolution">
      <bpmn:incoming>Flow_5</bpmn:incoming>
      <bpmn:incoming>Flow_6</bpmn:incoming>
      <bpmn:outgoing>Flow_7</bpmn:outgoing>
    </bpmn:serviceTask>
    <bpmn:userTask id="UserTask_4" name="Customer Confirmation">
      <bpmn:incoming>Flow_7</bpmn:incoming>
      <bpmn:outgoing>Flow_8</bpmn:outgoing>
    </bpmn:userTask>
    <bpmn:endEvent id="EndEvent_1" name="Incident Resolved">
      <bpmn:incoming>Flow_8</bpmn:incoming>
    </bpmn:endEvent>
    <bpmn:sequenceFlow id="Flow_1" sourceRef="StartEvent_1" targetRef="UserTask_1" />
    <bpmn:sequenceFlow id="Flow_2" sourceRef="UserTask_1" targetRef="Gateway_1" />
    <bpmn:sequenceFlow id="Flow_3" sourceRef="Gateway_1" targetRef="UserTask_2" name="Low Priority">
      <bpmn:conditionExpression xsi:type="bpmn:tFormalExpression">\${priority == "low"}</bpmn:conditionExpression>
    </bpmn:sequenceFlow>
    <bpmn:sequenceFlow id="Flow_4" sourceRef="Gateway_1" targetRef="UserTask_3" name="High Priority">
      <bpmn:conditionExpression xsi:type="bpmn:tFormalExpression">\${priority == "high"}</bpmn:conditionExpression>
    </bpmn:sequenceFlow>
    <bpmn:sequenceFlow id="Flow_5" sourceRef="UserTask_2" targetRef="ServiceTask_1" />
    <bpmn:sequenceFlow id="Flow_6" sourceRef="UserTask_3" targetRef="ServiceTask_1" />
    <bpmn:sequenceFlow id="Flow_7" sourceRef="ServiceTask_1" targetRef="UserTask_4" />
    <bpmn:sequenceFlow id="Flow_8" sourceRef="UserTask_4" targetRef="EndEvent_1" />
  </bpmn:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1">
      <bpmndi:BPMNShape id="_BPMNShape_StartEvent_2" bpmnElement="StartEvent_1">
        <dc:Bounds x="173" y="102" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="UserTask_1_di" bpmnElement="UserTask_1">
        <dc:Bounds x="260" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="Gateway_1_di" bpmnElement="Gateway_1" isMarkerVisible="true">
        <dc:Bounds x="420" y="95" width="50" height="50" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="UserTask_2_di" bpmnElement="UserTask_2">
        <dc:Bounds x="530" y="40" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="UserTask_3_di" bpmnElement="UserTask_3">
        <dc:Bounds x="530" y="140" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="ServiceTask_1_di" bpmnElement="ServiceTask_1">
        <dc:Bounds x="690" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="UserTask_4_di" bpmnElement="UserTask_4">
        <dc:Bounds x="850" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="EndEvent_1_di" bpmnElement="EndEvent_1">
        <dc:Bounds x="1002" y="102" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="Flow_1_di" bpmnElement="Flow_1">
        <di:waypoint x="209" y="120" />
        <di:waypoint x="260" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_2_di" bpmnElement="Flow_2">
        <di:waypoint x="360" y="120" />
        <di:waypoint x="420" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_3_di" bpmnElement="Flow_3">
        <di:waypoint x="445" y="95" />
        <di:waypoint x="445" y="80" />
        <di:waypoint x="530" y="80" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_4_di" bpmnElement="Flow_4">
        <di:waypoint x="445" y="145" />
        <di:waypoint x="445" y="180" />
        <di:waypoint x="530" y="180" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_5_di" bpmnElement="Flow_5">
        <di:waypoint x="630" y="80" />
        <di:waypoint x="690" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_6_di" bpmnElement="Flow_6">
        <di:waypoint x="630" y="180" />
        <di:waypoint x="690" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_7_di" bpmnElement="Flow_7">
        <di:waypoint x="790" y="120" />
        <di:waypoint x="850" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_8_di" bpmnElement="Flow_8">
        <di:waypoint x="950" y="120" />
        <di:waypoint x="1002" y="120" />
      </bpmndi:BPMNEdge>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn:definitions>`,

  // Batch Disbursement - Sequential (Template 1)
  'batch-disbursement-sequential': `<?xml version="1.0" encoding="UTF-8"?>
<bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:custom="http://custom-bpmn-schema" id="Definitions_BatchDisbursementSeq" targetNamespace="http://bpmn.io/schema/bpmn">
  <bpmn:process id="Process_BatchDisbursementSeq" name="Batch Disbursement - Sequential" isExecutable="true">
    
    <!-- Start Event -->
    <bpmn:startEvent id="StartEvent_1" name="Start Batch">
      <bpmn:outgoing>Flow_Start_To_PrepareData</bpmn:outgoing>
    </bpmn:startEvent>
    
    <!-- Script Task: Prepare Mock Disbursement Data -->
    <bpmn:scriptTask id="ScriptTask_PrepareData" name="Prepare Disbursement Batch" scriptFormat="javascript">
      <bpmn:extensionElements>
        <custom:properties>
          <custom:property name="script" value="// Generate 50 mock disbursement records&#xA;console.log('📦 Preparing batch disbursement data...');&#xA;&#xA;var disbursements = [];&#xA;for (var i = 1; i &lt;= 50; i++) {&#xA;  disbursements.push({&#xA;    id: 'DISB-' + String(i).padStart(4, '0'),&#xA;    accountNumber: '100000' + String(i).padStart(4, '0'),&#xA;    accountName: 'Customer ' + i,&#xA;    amount: Math.floor(Math.random() * 90000) + 10000, // 10k-100k&#xA;    currency: 'NGN',&#xA;    narration: 'Salary Payment - ' + new Date().toISOString().split('T')[0],&#xA;    bankCode: i % 2 === 0 ? '058' : '044', // Alternate between banks&#xA;    status: 'pending'&#xA;  });&#xA;}&#xA;&#xA;// Store in context&#xA;context.disbursements = disbursements;&#xA;context.totalCount = disbursements.length;&#xA;context.batchId = 'BATCH-' + Date.now();&#xA;context.startTime = new Date().toISOString();&#xA;&#xA;console.log('✅ Prepared ' + disbursements.length + ' disbursements');&#xA;console.log('📊 Batch ID: ' + context.batchId);" />
          <custom:property name="scriptLanguage" value="javascript" />
          <custom:property name="resultVariable" value="batchInfo" />
        </custom:properties>
      </bpmn:extensionElements>
      <bpmn:incoming>Flow_Start_To_PrepareData</bpmn:incoming>
      <bpmn:outgoing>Flow_PrepareData_To_SubProcess</bpmn:outgoing>
    </bpmn:scriptTask>
    
    <!-- Multi-Instance Subprocess: Process Each Disbursement SEQUENTIALLY -->
    <bpmn:subProcess id="SubProcess_ProcessDisbursements" name="Process Each Disbursement (Sequential)">
      <bpmn:extensionElements>
        <custom:properties>
          <custom:property name="isMultiInstance" value="true" />
          <custom:property name="collectionVariable" value="disbursements" />
          <custom:property name="elementVariable" value="currentDisbursement" />
          <custom:property name="multiInstanceMode" value="sequential" />
          <custom:property name="resultVariable" value="disbursementResults" />
        </custom:properties>
      </bpmn:extensionElements>
      <bpmn:incoming>Flow_PrepareData_To_SubProcess</bpmn:incoming>
      <bpmn:outgoing>Flow_SubProcess_To_GenerateReport</bpmn:outgoing>
      
      <!-- Subprocess Start -->
      <bpmn:startEvent id="SubProcess_Start">
        <bpmn:outgoing>Flow_SubStart_To_Validate</bpmn:outgoing>
      </bpmn:startEvent>
      
      <!-- Validate Disbursement -->
      <bpmn:scriptTask id="ScriptTask_Validate" name="Validate" scriptFormat="javascript">
        <bpmn:extensionElements>
          <custom:properties>
            <custom:property name="script" value="// Validate disbursement record&#xA;var disb = context.currentDisbursement;&#xA;console.log('🔍 Validating: ' + disb.id + ' - ' + disb.accountName);&#xA;&#xA;// Simple validation&#xA;var isValid = disb.accountNumber &amp;&amp; disb.amount &gt; 0 &amp;&amp; disb.bankCode;&#xA;&#xA;if (isValid) {&#xA;  disb.validationStatus = 'passed';&#xA;  console.log('✅ Validation passed');&#xA;} else {&#xA;  disb.validationStatus = 'failed';&#xA;  disb.status = 'validation_failed';&#xA;  console.log('❌ Validation failed');&#xA;}&#xA;&#xA;context.currentDisbursement = disb;" />
            <custom:property name="scriptLanguage" value="javascript" />
          </custom:properties>
        </bpmn:extensionElements>
        <bpmn:incoming>Flow_SubStart_To_Validate</bpmn:incoming>
        <bpmn:outgoing>Flow_Validate_To_Gateway</bpmn:outgoing>
      </bpmn:scriptTask>
      
      <!-- Gateway: Check Validation -->
      <bpmn:exclusiveGateway id="Gateway_CheckValidation" name="Valid?">
        <bpmn:incoming>Flow_Validate_To_Gateway</bpmn:incoming>
        <bpmn:outgoing>Flow_Valid_To_ProcessPayment</bpmn:outgoing>
        <bpmn:outgoing>Flow_Invalid_To_End</bpmn:outgoing>
      </bpmn:exclusiveGateway>
      
      <!-- Process Payment -->
      <bpmn:scriptTask id="ScriptTask_ProcessPayment" name="Process Payment" scriptFormat="javascript">
        <bpmn:extensionElements>
          <custom:properties>
            <custom:property name="script" value="// Simulate payment processing&#xA;var disb = context.currentDisbursement;&#xA;console.log('💰 Processing payment: ' + disb.id + ' - NGN ' + disb.amount.toLocaleString());&#xA;&#xA;// Simulate API call to bank (90% success rate)&#xA;var success = Math.random() &gt; 0.1;&#xA;&#xA;if (success) {&#xA;  disb.status = 'success';&#xA;  disb.transactionRef = 'TXN' + Date.now() + Math.floor(Math.random() * 1000);&#xA;  disb.processedAt = new Date().toISOString();&#xA;  console.log('✅ Payment successful - Ref: ' + disb.transactionRef);&#xA;} else {&#xA;  disb.status = 'failed';&#xA;  disb.errorMessage = 'Insufficient funds in pooling account';&#xA;  console.log('❌ Payment failed: ' + disb.errorMessage);&#xA;}&#xA;&#xA;context.currentDisbursement = disb;" />
            <custom:property name="scriptLanguage" value="javascript" />
          </custom:properties>
        </bpmn:extensionElements>
        <bpmn:incoming>Flow_Valid_To_ProcessPayment</bpmn:incoming>
        <bpmn:outgoing>Flow_ProcessPayment_To_SendNotification</bpmn:outgoing>
      </bpmn:scriptTask>
      
      <!-- Send Notification -->
      <bpmn:scriptTask id="ScriptTask_SendNotification" name="Send Notification" scriptFormat="javascript">
        <bpmn:extensionElements>
          <custom:properties>
            <custom:property name="script" value="// Send SMS notification to recipient&#xA;var disb = context.currentDisbursement;&#xA;console.log('📧 Sending notification for: ' + disb.id);&#xA;&#xA;if (disb.status === 'success') {&#xA;  console.log('✉️ SMS sent to customer: Payment of NGN ' + disb.amount.toLocaleString() + ' credited');&#xA;  disb.notificationSent = true;&#xA;} else {&#xA;  console.log('⚠️ No notification sent (payment failed)');&#xA;  disb.notificationSent = false;&#xA;}&#xA;&#xA;context.currentDisbursement = disb;" />
            <custom:property name="scriptLanguage" value="javascript" />
          </custom:properties>
        </bpmn:extensionElements>
        <bpmn:incoming>Flow_ProcessPayment_To_SendNotification</bpmn:incoming>
        <bpmn:outgoing>Flow_SendNotification_To_End</bpmn:outgoing>
      </bpmn:scriptTask>
      
      <!-- Subprocess End -->
      <bpmn:endEvent id="SubProcess_End">
        <bpmn:incoming>Flow_SendNotification_To_End</bpmn:incoming>
        <bpmn:incoming>Flow_Invalid_To_End</bpmn:incoming>
      </bpmn:endEvent>
      
      <!-- Subprocess Flows -->
      <bpmn:sequenceFlow id="Flow_SubStart_To_Validate" sourceRef="SubProcess_Start" targetRef="ScriptTask_Validate" />
      <bpmn:sequenceFlow id="Flow_Validate_To_Gateway" sourceRef="ScriptTask_Validate" targetRef="Gateway_CheckValidation" />
      <bpmn:sequenceFlow id="Flow_Valid_To_ProcessPayment" name="Yes" sourceRef="Gateway_CheckValidation" targetRef="ScriptTask_ProcessPayment">
        <bpmn:extensionElements>
          <custom:properties>
            <custom:property name="scriptLanguage" value="javascript" />
            <custom:property name="conditionalScript" value="return context.currentDisbursement.validationStatus === 'passed' ? 'true' : 'false';" />
          </custom:properties>
        </bpmn:extensionElements>
      </bpmn:sequenceFlow>
      <bpmn:sequenceFlow id="Flow_Invalid_To_End" name="No" sourceRef="Gateway_CheckValidation" targetRef="SubProcess_End">
        <bpmn:extensionElements>
          <custom:properties>
            <custom:property name="scriptLanguage" value="javascript" />
            <custom:property name="conditionalScript" value="return context.currentDisbursement.validationStatus !== 'passed' ? 'true' : 'false';" />
          </custom:properties>
        </bpmn:extensionElements>
      </bpmn:sequenceFlow>
      <bpmn:sequenceFlow id="Flow_ProcessPayment_To_SendNotification" sourceRef="ScriptTask_ProcessPayment" targetRef="ScriptTask_SendNotification" />
      <bpmn:sequenceFlow id="Flow_SendNotification_To_End" sourceRef="ScriptTask_SendNotification" targetRef="SubProcess_End" />
    </bpmn:subProcess>
    
    <!-- Generate Report -->
    <bpmn:scriptTask id="ScriptTask_GenerateReport" name="Generate Report" scriptFormat="javascript">
      <bpmn:extensionElements>
        <custom:properties>
          <custom:property name="script" value="// Generate batch processing report&#xA;console.log('📊 Generating batch report...');&#xA;&#xA;var results = context.disbursementResults || [];&#xA;var successCount = 0;&#xA;var failedCount = 0;&#xA;var validationFailedCount = 0;&#xA;var totalAmount = 0;&#xA;&#xA;for (var i = 0; i &lt; results.length; i++) {&#xA;  var disb = results[i].currentDisbursement;&#xA;  if (disb.status === 'success') {&#xA;    successCount++;&#xA;    totalAmount += disb.amount;&#xA;  } else if (disb.status === 'validation_failed') {&#xA;    validationFailedCount++;&#xA;  } else {&#xA;    failedCount++;&#xA;  }&#xA;}&#xA;&#xA;var report = {&#xA;  batchId: context.batchId,&#xA;  totalRecords: context.totalCount,&#xA;  successCount: successCount,&#xA;  failedCount: failedCount,&#xA;  validationFailedCount: validationFailedCount,&#xA;  totalAmountDisbursed: totalAmount,&#xA;  successRate: ((successCount / context.totalCount) * 100).toFixed(2) + '%',&#xA;  startTime: context.startTime,&#xA;  endTime: new Date().toISOString(),&#xA;  duration: ((new Date() - new Date(context.startTime)) / 1000).toFixed(2) + ' seconds'&#xA;};&#xA;&#xA;context.batchReport = report;&#xA;&#xA;console.log('📈 Report Generated:');&#xA;console.log('   Total: ' + report.totalRecords);&#xA;console.log('   Success: ' + report.successCount + ' (' + report.successRate + ')');&#xA;console.log('   Failed: ' + report.failedCount);&#xA;console.log('   Validation Failed: ' + report.validationFailedCount);&#xA;console.log('   Total Amount: NGN ' + report.totalAmountDisbursed.toLocaleString());&#xA;console.log('   Duration: ' + report.duration);" />
          <custom:property name="scriptLanguage" value="javascript" />
          <custom:property name="resultVariable" value="reportData" />
        </custom:properties>
      </bpmn:extensionElements>
      <bpmn:incoming>Flow_SubProcess_To_GenerateReport</bpmn:incoming>
      <bpmn:outgoing>Flow_GenerateReport_To_SendEmail</bpmn:outgoing>
    </bpmn:scriptTask>
    
    <!-- Send Email Report -->
    <bpmn:scriptTask id="ScriptTask_SendEmailReport" name="Send Report via Email" scriptFormat="javascript">
      <bpmn:extensionElements>
        <custom:properties>
          <custom:property name="script" value="// Send email report using SendMailCommand&#xA;console.log('📧 Sending batch report via email...');&#xA;&#xA;var report = context.batchReport;&#xA;&#xA;var emailBody = '&lt;html&gt;&lt;body&gt;' +&#xA;  '&lt;h2&gt;Batch Disbursement Report&lt;/h2&gt;' +&#xA;  '&lt;p&gt;&lt;strong&gt;Batch ID:&lt;/strong&gt; ' + report.batchId + '&lt;/p&gt;' +&#xA;  '&lt;table border=&quot;1&quot; cellpadding=&quot;10&quot;&gt;' +&#xA;  '&lt;tr&gt;&lt;td&gt;Total Records&lt;/td&gt;&lt;td&gt;' + report.totalRecords + '&lt;/td&gt;&lt;/tr&gt;' +&#xA;  '&lt;tr&gt;&lt;td&gt;Successful&lt;/td&gt;&lt;td style=&quot;color:green;&quot;&gt;' + report.successCount + '&lt;/td&gt;&lt;/tr&gt;' +&#xA;  '&lt;tr&gt;&lt;td&gt;Failed&lt;/td&gt;&lt;td style=&quot;color:red;&quot;&gt;' + report.failedCount + '&lt;/td&gt;&lt;/tr&gt;' +&#xA;  '&lt;tr&gt;&lt;td&gt;Validation Failed&lt;/td&gt;&lt;td style=&quot;color:orange;&quot;&gt;' + report.validationFailedCount + '&lt;/td&gt;&lt;/tr&gt;' +&#xA;  '&lt;tr&gt;&lt;td&gt;Success Rate&lt;/td&gt;&lt;td&gt;' + report.successRate + '&lt;/td&gt;&lt;/tr&gt;' +&#xA;  '&lt;tr&gt;&lt;td&gt;Total Amount&lt;/td&gt;&lt;td&gt;NGN ' + report.totalAmountDisbursed.toLocaleString() + '&lt;/td&gt;&lt;/tr&gt;' +&#xA;  '&lt;tr&gt;&lt;td&gt;Duration&lt;/td&gt;&lt;td&gt;' + report.duration + '&lt;/td&gt;&lt;/tr&gt;' +&#xA;  '&lt;/table&gt;' +&#xA;  '&lt;p&gt;&lt;small&gt;Started: ' + report.startTime + '&lt;br/&gt;Completed: ' + report.endTime + '&lt;/small&gt;&lt;/p&gt;' +&#xA;  '&lt;/body&gt;&lt;/html&gt;';&#xA;&#xA;var emailResult = doCmd('SendMailCommand', {&#xA;  emmail: ['finance@company.com', 'operations@company.com'],&#xA;  subject: 'Batch Disbursement Report - ' + report.batchId,&#xA;  message: emailBody,&#xA;  sender: 'noreply@banklingo.app'&#xA;});&#xA;&#xA;if (emailResult &amp;&amp; emailResult.Success) {&#xA;  console.log('✅ Email report sent successfully');&#xA;  context.emailSent = true;&#xA;} else {&#xA;  console.log('❌ Failed to send email report');&#xA;  context.emailSent = false;&#xA;}" />
          <custom:property name="scriptLanguage" value="javascript" />
        </custom:properties>
      </bpmn:extensionElements>
      <bpmn:incoming>Flow_GenerateReport_To_SendEmail</bpmn:incoming>
      <bpmn:outgoing>Flow_SendEmail_To_End</bpmn:outgoing>
    </bpmn:scriptTask>
    
    <!-- End Event -->
    <bpmn:endEvent id="EndEvent_1" name="Batch Complete">
      <bpmn:incoming>Flow_SendEmail_To_End</bpmn:incoming>
    </bpmn:endEvent>
    
    <!-- Main Process Flows -->
    <bpmn:sequenceFlow id="Flow_Start_To_PrepareData" sourceRef="StartEvent_1" targetRef="ScriptTask_PrepareData" />
    <bpmn:sequenceFlow id="Flow_PrepareData_To_SubProcess" sourceRef="ScriptTask_PrepareData" targetRef="SubProcess_ProcessDisbursements" />
    <bpmn:sequenceFlow id="Flow_SubProcess_To_GenerateReport" sourceRef="SubProcess_ProcessDisbursements" targetRef="ScriptTask_GenerateReport" />
    <bpmn:sequenceFlow id="Flow_GenerateReport_To_SendEmail" sourceRef="ScriptTask_GenerateReport" targetRef="ScriptTask_SendEmailReport" />
    <bpmn:sequenceFlow id="Flow_SendEmail_To_End" sourceRef="ScriptTask_SendEmailReport" targetRef="EndEvent_1" />
    
  </bpmn:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_BatchDisbursementSeq">
      <bpmndi:BPMNShape id="StartEvent_1_di" bpmnElement="StartEvent_1">
        <dc:Bounds x="173" y="102" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="ScriptTask_PrepareData_di" bpmnElement="ScriptTask_PrepareData">
        <dc:Bounds x="260" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="SubProcess_ProcessDisbursements_di" bpmnElement="SubProcess_ProcessDisbursements" isExpanded="true">
        <dc:Bounds x="420" y="30" width="700" height="220" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="SubProcess_Start_di" bpmnElement="SubProcess_Start">
        <dc:Bounds x="445" y="112" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="ScriptTask_Validate_di" bpmnElement="ScriptTask_Validate">
        <dc:Bounds x="520" y="90" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="Gateway_CheckValidation_di" bpmnElement="Gateway_CheckValidation" isMarkerVisible="true">
        <dc:Bounds x="665" y="105" width="50" height="50" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="ScriptTask_ProcessPayment_di" bpmnElement="ScriptTask_ProcessPayment">
        <dc:Bounds x="760" y="90" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="ScriptTask_SendNotification_di" bpmnElement="ScriptTask_SendNotification">
        <dc:Bounds x="905" y="90" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="SubProcess_End_di" bpmnElement="SubProcess_End">
        <dc:Bounds x="1062" y="112" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="Flow_SubStart_To_Validate_di" bpmnElement="Flow_SubStart_To_Validate">
        <di:waypoint x="481" y="130" />
        <di:waypoint x="520" y="130" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_Validate_To_Gateway_di" bpmnElement="Flow_Validate_To_Gateway">
        <di:waypoint x="620" y="130" />
        <di:waypoint x="665" y="130" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_Valid_To_ProcessPayment_di" bpmnElement="Flow_Valid_To_ProcessPayment">
        <di:waypoint x="715" y="130" />
        <di:waypoint x="760" y="130" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_Invalid_To_End_di" bpmnElement="Flow_Invalid_To_End">
        <di:waypoint x="690" y="155" />
        <di:waypoint x="690" y="200" />
        <di:waypoint x="1080" y="200" />
        <di:waypoint x="1080" y="148" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_ProcessPayment_To_SendNotification_di" bpmnElement="Flow_ProcessPayment_To_SendNotification">
        <di:waypoint x="860" y="130" />
        <di:waypoint x="905" y="130" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_SendNotification_To_End_di" bpmnElement="Flow_SendNotification_To_End">
        <di:waypoint x="1005" y="130" />
        <di:waypoint x="1062" y="130" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNShape id="ScriptTask_GenerateReport_di" bpmnElement="ScriptTask_GenerateReport">
        <dc:Bounds x="1170" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="ScriptTask_SendEmailReport_di" bpmnElement="ScriptTask_SendEmailReport">
        <dc:Bounds x="1320" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="EndEvent_1_di" bpmnElement="EndEvent_1">
        <dc:Bounds x="1472" y="102" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="Flow_Start_To_PrepareData_di" bpmnElement="Flow_Start_To_PrepareData">
        <di:waypoint x="209" y="120" />
        <di:waypoint x="260" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_PrepareData_To_SubProcess_di" bpmnElement="Flow_PrepareData_To_SubProcess">
        <di:waypoint x="360" y="120" />
        <di:waypoint x="390" y="120" />
        <di:waypoint x="390" y="140" />
        <di:waypoint x="420" y="140" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_SubProcess_To_GenerateReport_di" bpmnElement="Flow_SubProcess_To_GenerateReport">
        <di:waypoint x="1120" y="140" />
        <di:waypoint x="1145" y="140" />
        <di:waypoint x="1145" y="120" />
        <di:waypoint x="1170" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_GenerateReport_To_SendEmail_di" bpmnElement="Flow_GenerateReport_To_SendEmail">
        <di:waypoint x="1270" y="120" />
        <di:waypoint x="1320" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_SendEmail_To_End_di" bpmnElement="Flow_SendEmail_To_End">
        <di:waypoint x="1420" y="120" />
        <di:waypoint x="1472" y="120" />
      </bpmndi:BPMNEdge>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn:definitions>`,

  // Batch Disbursement - Parallel (Template 2)
  'batch-disbursement-parallel': `<?xml version="1.0" encoding="UTF-8"?>
<bpmn:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:custom="http://custom-bpmn-schema" id="Definitions_BatchDisbursementParallel" targetNamespace="http://bpmn.io/schema/bpmn">
  <bpmn:process id="Process_BatchDisbursementParallel" name="Batch Disbursement - Parallel (10 per batch)" isExecutable="true">
    
    <!-- Start Event -->
    <bpmn:startEvent id="StartEvent_1" name="Start Batch">
      <bpmn:outgoing>Flow_Start_To_PrepareData</bpmn:outgoing>
    </bpmn:startEvent>
    
    <!-- Script Task: Prepare Mock Disbursement Data -->
    <bpmn:scriptTask id="ScriptTask_PrepareData" name="Prepare Disbursement Batch" scriptFormat="javascript">
      <bpmn:extensionElements>
        <custom:properties>
          <custom:property name="script" value="// Generate 50 mock disbursement records&#xA;console.log('📦 Preparing batch disbursement data (PARALLEL MODE)...');&#xA;&#xA;var disbursements = [];&#xA;for (var i = 1; i &lt;= 50; i++) {&#xA;  disbursements.push({&#xA;    id: 'DISB-' + String(i).padStart(4, '0'),&#xA;    accountNumber: '100000' + String(i).padStart(4, '0'),&#xA;    accountName: 'Customer ' + i,&#xA;    amount: Math.floor(Math.random() * 90000) + 10000,&#xA;    currency: 'NGN',&#xA;    narration: 'Salary Payment - ' + new Date().toISOString().split('T')[0],&#xA;    bankCode: i % 2 === 0 ? '058' : '044',&#xA;    status: 'pending',&#xA;    batchNumber: Math.ceil(i / 10) // Group into batches of 10&#xA;  });&#xA;}&#xA;&#xA;// Store in context&#xA;context.disbursements = disbursements;&#xA;context.totalCount = disbursements.length;&#xA;context.batchSize = 10;&#xA;context.numberOfBatches = Math.ceil(disbursements.length / 10);&#xA;context.batchId = 'BATCH-PARALLEL-' + Date.now();&#xA;context.startTime = new Date().toISOString();&#xA;&#xA;console.log('✅ Prepared ' + disbursements.length + ' disbursements');&#xA;console.log('📊 Batch ID: ' + context.batchId);&#xA;console.log('🔢 Will process in ' + context.numberOfBatches + ' parallel batches of ' + context.batchSize);" />
          <custom:property name="scriptLanguage" value="javascript" />
          <custom:property name="resultVariable" value="batchInfo" />
        </custom:properties>
      </bpmn:extensionElements>
      <bpmn:incoming>Flow_Start_To_PrepareData</bpmn:incoming>
      <bpmn:outgoing>Flow_PrepareData_To_SubProcess</bpmn:outgoing>
    </bpmn:scriptTask>
    
    <!-- Multi-Instance Subprocess: Process Each Disbursement IN PARALLEL -->
    <bpmn:subProcess id="SubProcess_ProcessDisbursements" name="Process Each Disbursement (Parallel - 10 concurrent)">
      <bpmn:extensionElements>
        <custom:properties>
          <custom:property name="isMultiInstance" value="true" />
          <custom:property name="collectionVariable" value="disbursements" />
          <custom:property name="elementVariable" value="currentDisbursement" />
          <custom:property name="multiInstanceMode" value="parallel" />
          <custom:property name="resultVariable" value="disbursementResults" />
          <custom:property name="description" value="Processes disbursements in parallel. Engine handles concurrency control. Max 10 items processed simultaneously for optimal performance." />
        </custom:properties>
      </bpmn:extensionElements>
      <bpmn:incoming>Flow_PrepareData_To_SubProcess</bpmn:incoming>
      <bpmn:outgoing>Flow_SubProcess_To_GenerateReport</bpmn:outgoing>
      
      <!-- Subprocess Start -->
      <bpmn:startEvent id="SubProcess_Start">
        <bpmn:outgoing>Flow_SubStart_To_Validate</bpmn:outgoing>
      </bpmn:startEvent>
      
      <!-- Validate Disbursement -->
      <bpmn:scriptTask id="ScriptTask_Validate" name="Validate" scriptFormat="javascript">
        <bpmn:extensionElements>
          <custom:properties>
            <custom:property name="script" value="// Validate disbursement record&#xA;var disb = context.currentDisbursement;&#xA;console.log('🔍 [Batch ' + disb.batchNumber + '] Validating: ' + disb.id + ' - ' + disb.accountName);&#xA;&#xA;// Simple validation&#xA;var isValid = disb.accountNumber &amp;&amp; disb.amount &gt; 0 &amp;&amp; disb.bankCode;&#xA;&#xA;if (isValid) {&#xA;  disb.validationStatus = 'passed';&#xA;  console.log('✅ [' + disb.id + '] Validation passed');&#xA;} else {&#xA;  disb.validationStatus = 'failed';&#xA;  disb.status = 'validation_failed';&#xA;  console.log('❌ [' + disb.id + '] Validation failed');&#xA;}&#xA;&#xA;context.currentDisbursement = disb;" />
            <custom:property name="scriptLanguage" value="javascript" />
          </custom:properties>
        </bpmn:extensionElements>
        <bpmn:incoming>Flow_SubStart_To_Validate</bpmn:incoming>
        <bpmn:outgoing>Flow_Validate_To_Gateway</bpmn:outgoing>
      </bpmn:scriptTask>
      
      <!-- Gateway: Check Validation -->
      <bpmn:exclusiveGateway id="Gateway_CheckValidation" name="Valid?">
        <bpmn:incoming>Flow_Validate_To_Gateway</bpmn:incoming>
        <bpmn:outgoing>Flow_Valid_To_ProcessPayment</bpmn:outgoing>
        <bpmn:outgoing>Flow_Invalid_To_End</bpmn:outgoing>
      </bpmn:exclusiveGateway>
      
      <!-- Process Payment -->
      <bpmn:scriptTask id="ScriptTask_ProcessPayment" name="Process Payment" scriptFormat="javascript">
        <bpmn:extensionElements>
          <custom:properties>
            <custom:property name="script" value="// Simulate payment processing&#xA;var disb = context.currentDisbursement;&#xA;console.log('💰 [' + disb.id + '] Processing payment: NGN ' + disb.amount.toLocaleString() + ' [Batch ' + disb.batchNumber + ']');&#xA;&#xA;// Simulate async API call delay (50-200ms)&#xA;var delay = Math.floor(Math.random() * 150) + 50;&#xA;// Note: In real implementation, this would be actual async bank API call&#xA;&#xA;// Simulate API call to bank (92% success rate)&#xA;var success = Math.random() &gt; 0.08;&#xA;&#xA;if (success) {&#xA;  disb.status = 'success';&#xA;  disb.transactionRef = 'TXN' + Date.now() + Math.floor(Math.random() * 10000);&#xA;  disb.processedAt = new Date().toISOString();&#xA;  console.log('✅ [' + disb.id + '] Payment successful - Ref: ' + disb.transactionRef);&#xA;} else {&#xA;  disb.status = 'failed';&#xA;  var errors = [&#xA;    'Insufficient funds in pooling account',&#xA;    'Invalid account number',&#xA;    'Bank service temporarily unavailable',&#xA;    'Transaction timeout'&#xA;  ];&#xA;  disb.errorMessage = errors[Math.floor(Math.random() * errors.length)];&#xA;  console.log('❌ [' + disb.id + '] Payment failed: ' + disb.errorMessage);&#xA;}&#xA;&#xA;context.currentDisbursement = disb;" />
            <custom:property name="scriptLanguage" value="javascript" />
          </custom:properties>
        </bpmn:extensionElements>
        <bpmn:incoming>Flow_Valid_To_ProcessPayment</bpmn:incoming>
        <bpmn:outgoing>Flow_ProcessPayment_To_SendNotification</bpmn:outgoing>
      </bpmn:scriptTask>
      
      <!-- Send Notification -->
      <bpmn:scriptTask id="ScriptTask_SendNotification" name="Send Notification" scriptFormat="javascript">
        <bpmn:extensionElements>
          <custom:properties>
            <custom:property name="script" value="// Send SMS notification to recipient&#xA;var disb = context.currentDisbursement;&#xA;console.log('📧 [' + disb.id + '] Sending notification...');&#xA;&#xA;if (disb.status === 'success') {&#xA;  // In real implementation, use SendNotificationCommand or SendSMSCommand&#xA;  console.log('✉️ [' + disb.id + '] SMS sent: Payment of NGN ' + disb.amount.toLocaleString() + ' credited to ' + disb.accountNumber);&#xA;  disb.notificationSent = true;&#xA;  disb.notificationTime = new Date().toISOString();&#xA;} else {&#xA;  console.log('⚠️ [' + disb.id + '] No notification sent (payment failed)');&#xA;  disb.notificationSent = false;&#xA;}&#xA;&#xA;context.currentDisbursement = disb;" />
            <custom:property name="scriptLanguage" value="javascript" />
          </custom:properties>
        </bpmn:extensionElements>
        <bpmn:incoming>Flow_ProcessPayment_To_SendNotification</bpmn:incoming>
        <bpmn:outgoing>Flow_SendNotification_To_End</bpmn:outgoing>
      </bpmn:scriptTask>
      
      <!-- Subprocess End -->
      <bpmn:endEvent id="SubProcess_End">
        <bpmn:incoming>Flow_SendNotification_To_End</bpmn:incoming>
        <bpmn:incoming>Flow_Invalid_To_End</bpmn:incoming>
      </bpmn:endEvent>
      
      <!-- Subprocess Flows -->
      <bpmn:sequenceFlow id="Flow_SubStart_To_Validate" sourceRef="SubProcess_Start" targetRef="ScriptTask_Validate" />
      <bpmn:sequenceFlow id="Flow_Validate_To_Gateway" sourceRef="ScriptTask_Validate" targetRef="Gateway_CheckValidation" />
      <bpmn:sequenceFlow id="Flow_Valid_To_ProcessPayment" name="Yes" sourceRef="Gateway_CheckValidation" targetRef="ScriptTask_ProcessPayment">
        <bpmn:extensionElements>
          <custom:properties>
            <custom:property name="scriptLanguage" value="javascript" />
            <custom:property name="conditionalScript" value="return context.currentDisbursement.validationStatus === 'passed' ? 'true' : 'false';" />
          </custom:properties>
        </bpmn:extensionElements>
      </bpmn:sequenceFlow>
      <bpmn:sequenceFlow id="Flow_Invalid_To_End" name="No" sourceRef="Gateway_CheckValidation" targetRef="SubProcess_End">
        <bpmn:extensionElements>
          <custom:properties>
            <custom:property name="scriptLanguage" value="javascript" />
            <custom:property name="conditionalScript" value="return context.currentDisbursement.validationStatus !== 'passed' ? 'true' : 'false';" />
          </custom:properties>
        </bpmn:extensionElements>
      </bpmn:sequenceFlow>
      <bpmn:sequenceFlow id="Flow_ProcessPayment_To_SendNotification" sourceRef="ScriptTask_ProcessPayment" targetRef="ScriptTask_SendNotification" />
      <bpmn:sequenceFlow id="Flow_SendNotification_To_End" sourceRef="ScriptTask_SendNotification" targetRef="SubProcess_End" />
    </bpmn:subProcess>
    
    <!-- Generate Report -->
    <bpmn:scriptTask id="ScriptTask_GenerateReport" name="Generate Report" scriptFormat="javascript">
      <bpmn:extensionElements>
        <custom:properties>
          <custom:property name="script" value="// Generate batch processing report&#xA;console.log('📊 Generating parallel batch report...');&#xA;&#xA;var results = context.disbursementResults || [];&#xA;var successCount = 0;&#xA;var failedCount = 0;&#xA;var validationFailedCount = 0;&#xA;var totalAmount = 0;&#xA;var notificationsSent = 0;&#xA;&#xA;// Analyze results by batch&#xA;var batchStats = {};&#xA;&#xA;for (var i = 0; i &lt; results.length; i++) {&#xA;  var disb = results[i].currentDisbursement;&#xA;  var batchNum = disb.batchNumber;&#xA;  &#xA;  if (!batchStats[batchNum]) {&#xA;    batchStats[batchNum] = { success: 0, failed: 0, total: 0 };&#xA;  }&#xA;  batchStats[batchNum].total++;&#xA;  &#xA;  if (disb.status === 'success') {&#xA;    successCount++;&#xA;    totalAmount += disb.amount;&#xA;    batchStats[batchNum].success++;&#xA;    if (disb.notificationSent) notificationsSent++;&#xA;  } else if (disb.status === 'validation_failed') {&#xA;    validationFailedCount++;&#xA;    batchStats[batchNum].failed++;&#xA;  } else {&#xA;    failedCount++;&#xA;    batchStats[batchNum].failed++;&#xA;  }&#xA;}&#xA;&#xA;var endTime = new Date();&#xA;var startTime = new Date(context.startTime);&#xA;var durationMs = endTime - startTime;&#xA;var durationSec = (durationMs / 1000).toFixed(2);&#xA;&#xA;var report = {&#xA;  batchId: context.batchId,&#xA;  processingMode: 'PARALLEL',&#xA;  batchSize: context.batchSize,&#xA;  numberOfBatches: context.numberOfBatches,&#xA;  totalRecords: context.totalCount,&#xA;  successCount: successCount,&#xA;  failedCount: failedCount,&#xA;  validationFailedCount: validationFailedCount,&#xA;  notificationsSent: notificationsSent,&#xA;  totalAmountDisbursed: totalAmount,&#xA;  successRate: ((successCount / context.totalCount) * 100).toFixed(2) + '%',&#xA;  averagePerSecond: (context.totalCount / (durationMs / 1000)).toFixed(2),&#xA;  batchStats: batchStats,&#xA;  startTime: context.startTime,&#xA;  endTime: endTime.toISOString(),&#xA;  durationMs: durationMs,&#xA;  duration: durationSec + ' seconds'&#xA;};&#xA;&#xA;context.batchReport = report;&#xA;&#xA;console.log('📈 Parallel Batch Report Generated:');&#xA;console.log('   Mode: PARALLEL (' + report.batchSize + ' concurrent per batch)');&#xA;console.log('   Total: ' + report.totalRecords + ' records');&#xA;console.log('   Success: ' + report.successCount + ' (' + report.successRate + ')');&#xA;console.log('   Failed: ' + report.failedCount);&#xA;console.log('   Validation Failed: ' + report.validationFailedCount);&#xA;console.log('   Notifications Sent: ' + report.notificationsSent);&#xA;console.log('   Total Amount: NGN ' + report.totalAmountDisbursed.toLocaleString());&#xA;console.log('   Duration: ' + report.duration);&#xA;console.log('   Throughput: ' + report.averagePerSecond + ' records/sec');&#xA;console.log('   Batches Processed: ' + Object.keys(batchStats).length);" />
          <custom:property name="scriptLanguage" value="javascript" />
          <custom:property name="resultVariable" value="reportData" />
        </custom:properties>
      </bpmn:extensionElements>
      <bpmn:incoming>Flow_SubProcess_To_GenerateReport</bpmn:incoming>
      <bpmn:outgoing>Flow_GenerateReport_To_SendEmail</bpmn:outgoing>
    </bpmn:scriptTask>
    
    <!-- Send Email Report -->
    <bpmn:scriptTask id="ScriptTask_SendEmailReport" name="Send Report via Email" scriptFormat="javascript">
      <bpmn:extensionElements>
        <custom:properties>
          <custom:property name="script" value="// Send email report using SendMailCommand&#xA;console.log('📧 Sending parallel batch report via email...');&#xA;&#xA;var report = context.batchReport;&#xA;&#xA;// Build batch stats table&#xA;var batchStatsHtml = '&lt;h3&gt;Batch Statistics&lt;/h3&gt;&lt;table border=&quot;1&quot; cellpadding=&quot;5&quot;&gt;' +&#xA;  '&lt;tr&gt;&lt;th&gt;Batch #&lt;/th&gt;&lt;th&gt;Total&lt;/th&gt;&lt;th&gt;Success&lt;/th&gt;&lt;th&gt;Failed&lt;/th&gt;&lt;th&gt;Rate&lt;/th&gt;&lt;/tr&gt;';&#xA;&#xA;for (var batchNum in report.batchStats) {&#xA;  var stats = report.batchStats[batchNum];&#xA;  var rate = ((stats.success / stats.total) * 100).toFixed(1);&#xA;  batchStatsHtml += '&lt;tr&gt;' +&#xA;    '&lt;td&gt;' + batchNum + '&lt;/td&gt;' +&#xA;    '&lt;td&gt;' + stats.total + '&lt;/td&gt;' +&#xA;    '&lt;td style=&quot;color:green;&quot;&gt;' + stats.success + '&lt;/td&gt;' +&#xA;    '&lt;td style=&quot;color:red;&quot;&gt;' + stats.failed + '&lt;/td&gt;' +&#xA;    '&lt;td&gt;' + rate + '%&lt;/td&gt;' +&#xA;    '&lt;/tr&gt;';&#xA;}&#xA;batchStatsHtml += '&lt;/table&gt;';&#xA;&#xA;var emailBody = '&lt;html&gt;&lt;body&gt;' +&#xA;  '&lt;h2&gt;🚀 Parallel Batch Disbursement Report&lt;/h2&gt;' +&#xA;  '&lt;p&gt;&lt;strong&gt;Batch ID:&lt;/strong&gt; ' + report.batchId + '&lt;/p&gt;' +&#xA;  '&lt;p&gt;&lt;strong&gt;Processing Mode:&lt;/strong&gt; &lt;span style=&quot;color:blue;&quot;&gt;PARALLEL&lt;/span&gt; (' + report.batchSize + ' concurrent instances per batch)&lt;/p&gt;' +&#xA;  '&lt;h3&gt;Summary&lt;/h3&gt;' +&#xA;  '&lt;table border=&quot;1&quot; cellpadding=&quot;10&quot;&gt;' +&#xA;  '&lt;tr&gt;&lt;td&gt;Total Records&lt;/td&gt;&lt;td&gt;' + report.totalRecords + '&lt;/td&gt;&lt;/tr&gt;' +&#xA;  '&lt;tr&gt;&lt;td&gt;Successful&lt;/td&gt;&lt;td style=&quot;color:green;&quot;&gt;' + report.successCount + '&lt;/td&gt;&lt;/tr&gt;' +&#xA;  '&lt;tr&gt;&lt;td&gt;Failed&lt;/td&gt;&lt;td style=&quot;color:red;&quot;&gt;' + report.failedCount + '&lt;/td&gt;&lt;/tr&gt;' +&#xA;  '&lt;tr&gt;&lt;td&gt;Validation Failed&lt;/td&gt;&lt;td style=&quot;color:orange;&quot;&gt;' + report.validationFailedCount + '&lt;/td&gt;&lt;/tr&gt;' +&#xA;  '&lt;tr&gt;&lt;td&gt;Success Rate&lt;/td&gt;&lt;td&gt;&lt;strong&gt;' + report.successRate + '&lt;/strong&gt;&lt;/td&gt;&lt;/tr&gt;' +&#xA;  '&lt;tr&gt;&lt;td&gt;Notifications Sent&lt;/td&gt;&lt;td&gt;' + report.notificationsSent + '&lt;/td&gt;&lt;/tr&gt;' +&#xA;  '&lt;tr&gt;&lt;td&gt;Total Amount&lt;/td&gt;&lt;td&gt;&lt;strong&gt;NGN ' + report.totalAmountDisbursed.toLocaleString() + '&lt;/strong&gt;&lt;/td&gt;&lt;/tr&gt;' +&#xA;  '&lt;tr&gt;&lt;td&gt;Duration&lt;/td&gt;&lt;td&gt;' + report.duration + '&lt;/td&gt;&lt;/tr&gt;' +&#xA;  '&lt;tr&gt;&lt;td&gt;Throughput&lt;/td&gt;&lt;td&gt;&lt;strong&gt;' + report.averagePerSecond + ' records/sec&lt;/strong&gt;&lt;/td&gt;&lt;/tr&gt;' +&#xA;  '&lt;/table&gt;' +&#xA;  batchStatsHtml +&#xA;  '&lt;p&gt;&lt;small&gt;Started: ' + report.startTime + '&lt;br/&gt;Completed: ' + report.endTime + '&lt;/small&gt;&lt;/p&gt;' +&#xA;  '&lt;p style=&quot;color:gray;&quot;&gt;&lt;em&gt;Note: Parallel processing provides faster throughput compared to sequential mode.&lt;/em&gt;&lt;/p&gt;' +&#xA;  '&lt;/body&gt;&lt;/html&gt;';&#xA;&#xA;var emailResult = doCmd('SendMailCommand', {&#xA;  emmail: ['finance@company.com', 'operations@company.com', 'cto@company.com'],&#xA;  subject: '🚀 Parallel Batch Disbursement Report - ' + report.batchId + ' (' + report.successRate + ' success)',&#xA;  message: emailBody,&#xA;  sender: 'noreply@banklingo.app'&#xA;});&#xA;&#xA;if (emailResult &amp;&amp; emailResult.Success) {&#xA;  console.log('✅ Email report sent successfully');&#xA;  context.emailSent = true;&#xA;} else {&#xA;  console.log('❌ Failed to send email report');&#xA;  context.emailSent = false;&#xA;}" />
          <custom:property name="scriptLanguage" value="javascript" />
        </custom:properties>
      </bpmn:extensionElements>
      <bpmn:incoming>Flow_GenerateReport_To_SendEmail</bpmn:incoming>
      <bpmn:outgoing>Flow_SendEmail_To_End</bpmn:outgoing>
    </bpmn:scriptTask>
    
    <!-- End Event -->
    <bpmn:endEvent id="EndEvent_1" name="Batch Complete">
      <bpmn:incoming>Flow_SendEmail_To_End</bpmn:incoming>
    </bpmn:endEvent>
    
    <!-- Main Process Flows -->
    <bpmn:sequenceFlow id="Flow_Start_To_PrepareData" sourceRef="StartEvent_1" targetRef="ScriptTask_PrepareData" />
    <bpmn:sequenceFlow id="Flow_PrepareData_To_SubProcess" sourceRef="ScriptTask_PrepareData" targetRef="SubProcess_ProcessDisbursements" />
    <bpmn:sequenceFlow id="Flow_SubProcess_To_GenerateReport" sourceRef="SubProcess_ProcessDisbursements" targetRef="ScriptTask_GenerateReport" />
    <bpmn:sequenceFlow id="Flow_GenerateReport_To_SendEmail" sourceRef="ScriptTask_GenerateReport" targetRef="ScriptTask_SendEmailReport" />
    <bpmn:sequenceFlow id="Flow_SendEmail_To_End" sourceRef="ScriptTask_SendEmailReport" targetRef="EndEvent_1" />
    
  </bpmn:process>
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_BatchDisbursementParallel">
      <bpmndi:BPMNShape id="StartEvent_1_di" bpmnElement="StartEvent_1">
        <dc:Bounds x="173" y="102" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="ScriptTask_PrepareData_di" bpmnElement="ScriptTask_PrepareData">
        <dc:Bounds x="260" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="SubProcess_ProcessDisbursements_di" bpmnElement="SubProcess_ProcessDisbursements" isExpanded="true">
        <dc:Bounds x="420" y="30" width="700" height="220" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="SubProcess_Start_di" bpmnElement="SubProcess_Start">
        <dc:Bounds x="445" y="112" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="ScriptTask_Validate_di" bpmnElement="ScriptTask_Validate">
        <dc:Bounds x="520" y="90" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="Gateway_CheckValidation_di" bpmnElement="Gateway_CheckValidation" isMarkerVisible="true">
        <dc:Bounds x="665" y="105" width="50" height="50" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="ScriptTask_ProcessPayment_di" bpmnElement="ScriptTask_ProcessPayment">
        <dc:Bounds x="760" y="90" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="ScriptTask_SendNotification_di" bpmnElement="ScriptTask_SendNotification">
        <dc:Bounds x="905" y="90" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="SubProcess_End_di" bpmnElement="SubProcess_End">
        <dc:Bounds x="1062" y="112" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="Flow_SubStart_To_Validate_di" bpmnElement="Flow_SubStart_To_Validate">
        <di:waypoint x="481" y="130" />
        <di:waypoint x="520" y="130" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_Validate_To_Gateway_di" bpmnElement="Flow_Validate_To_Gateway">
        <di:waypoint x="620" y="130" />
        <di:waypoint x="665" y="130" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_Valid_To_ProcessPayment_di" bpmnElement="Flow_Valid_To_ProcessPayment">
        <di:waypoint x="715" y="130" />
        <di:waypoint x="760" y="130" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_Invalid_To_End_di" bpmnElement="Flow_Invalid_To_End">
        <di:waypoint x="690" y="155" />
        <di:waypoint x="690" y="200" />
        <di:waypoint x="1080" y="200" />
        <di:waypoint x="1080" y="148" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_ProcessPayment_To_SendNotification_di" bpmnElement="Flow_ProcessPayment_To_SendNotification">
        <di:waypoint x="860" y="130" />
        <di:waypoint x="905" y="130" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_SendNotification_To_End_di" bpmnElement="Flow_SendNotification_To_End">
        <di:waypoint x="1005" y="130" />
        <di:waypoint x="1062" y="130" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNShape id="ScriptTask_GenerateReport_di" bpmnElement="ScriptTask_GenerateReport">
        <dc:Bounds x="1170" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="ScriptTask_SendEmailReport_di" bpmnElement="ScriptTask_SendEmailReport">
        <dc:Bounds x="1320" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNShape id="EndEvent_1_di" bpmnElement="EndEvent_1">
        <dc:Bounds x="1472" y="102" width="36" height="36" />
      </bpmndi:BPMNShape>
      <bpmndi:BPMNEdge id="Flow_Start_To_PrepareData_di" bpmnElement="Flow_Start_To_PrepareData">
        <di:waypoint x="209" y="120" />
        <di:waypoint x="260" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_PrepareData_To_SubProcess_di" bpmnElement="Flow_PrepareData_To_SubProcess">
        <di:waypoint x="360" y="120" />
        <di:waypoint x="390" y="120" />
        <di:waypoint x="390" y="140" />
        <di:waypoint x="420" y="140" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_SubProcess_To_GenerateReport_di" bpmnElement="Flow_SubProcess_To_GenerateReport">
        <di:waypoint x="1120" y="140" />
        <di:waypoint x="1145" y="140" />
        <di:waypoint x="1145" y="120" />
        <di:waypoint x="1170" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_GenerateReport_To_SendEmail_di" bpmnElement="Flow_GenerateReport_To_SendEmail">
        <di:waypoint x="1270" y="120" />
        <di:waypoint x="1320" y="120" />
      </bpmndi:BPMNEdge>
      <bpmndi:BPMNEdge id="Flow_SendEmail_To_End_di" bpmnElement="Flow_SendEmail_To_End">
        <di:waypoint x="1420" y="120" />
        <di:waypoint x="1472" y="120" />
      </bpmndi:BPMNEdge>
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
</bpmn:definitions>`,

  // ============================================
  // WORKING VERSION: Batch Disbursement - Single Script Loop
  // ============================================
  // This version uses a single script task with internal loop
  // because multi-instance subprocesses are not yet supported
  'batch-disbursement-working': `<?xml version="1.0" encoding="UTF-8"?>
<bpmn:definitions 
  xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
  xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL"
  xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI"
  xmlns:dc="http://www.omg.org/spec/DD/20100524/DC"
  xmlns:di="http://www.omg.org/spec/DD/20100524/DI"
  xmlns:custom="http://custom-bpmn-schema"
  id="Definitions_BatchDisbursementWorking"
  targetNamespace="http://bpmn.io/schema/bpmn"
  xmlns:bl="http://banklingo/schema/bpmn">

  <bpmn:process id="Process_BatchDisbursementWorking" name="Batch Disbursement - Working Version" isExecutable="true">
    
    <!-- Start Event -->
    <bpmn:startEvent id="StartEvent_1" name="Start Batch">
      <bpmn:outgoing>Flow_Start_To_ProcessBatch</bpmn:outgoing>
    </bpmn:startEvent>
    
    <!-- Single Script Task - Processes All Items in Loop -->
    <bpmn:scriptTask id="ScriptTask_ProcessBatch" name="Process Batch (50 Items)" scriptFormat="javascript">
      <bpmn:extensionElements>
        <custom:properties>
          <custom:property name="script" value="// ============================================
// BATCH DISBURSEMENT PROCESSOR - ALL IN ONE
// ============================================
console.log('📦 Starting batch disbursement process...');

// ===== STEP 1: PREPARE DATA =====
console.log('\\n🔧 STEP 1: Preparing disbursement data');
var disbursements = [];
for (var i = 1; i &lt;= 50; i++) {
  disbursements.push({
    id: 'DISB-' + String(i).padStart(4, '0'),
    accountNumber: '100000' + String(i).padStart(4, '0'),
    accountName: 'Customer ' + i,
    amount: Math.floor(Math.random() * 90000) + 10000,
    currency: 'NGN',
    narration: 'Salary Payment - ' + new Date().toISOString().split('T')[0],
    bankCode: i % 2 === 0 ? '058' : '044',
    status: 'pending',
    validationStatus: null,
    transactionRef: null,
    processedAt: null,
    notificationSent: false,
    errorMessage: null
  });
}

var batchId = 'BATCH-' + Date.now();
var startTime = new Date();
console.log('✅ Prepared ' + disbursements.length + ' disbursements');
console.log('📊 Batch ID: ' + batchId);

// ===== STEP 2: PROCESS EACH ITEM =====
console.log('\\n🔄 STEP 2: Processing each disbursement');
var successCount = 0;
var failedCount = 0;
var validationFailedCount = 0;
var totalAmountDisbursed = 0;

for (var i = 0; i &lt; disbursements.length; i++) {
  var disb = disbursements[i];
  var itemNum = i + 1;
  
  // Progress indicator every 10 items
  if (itemNum % 10 === 0 || itemNum === 1) {
    console.log('\\n--- Processing item ' + itemNum + ' of ' + disbursements.length + ' ---');
  }
  
  // A. VALIDATE
  console.log('🔍 [' + disb.id + '] Validating: ' + disb.accountName);
  var isValid = disb.accountNumber &amp;&amp; disb.amount > 0 &amp;&amp; disb.bankCode;
  
  if (!isValid) {
    disb.validationStatus = 'failed';
    disb.status = 'validation_failed';
    disb.errorMessage = 'Missing required fields';
    validationFailedCount++;
    console.log('❌ [' + disb.id + '] Validation failed');
    continue; // Skip to next item
  }
  
  disb.validationStatus = 'passed';
  console.log('✅ [' + disb.id + '] Validation passed');
  
  // B. PROCESS PAYMENT
  console.log('💰 [' + disb.id + '] Processing payment: NGN ' + disb.amount.toLocaleString());
  
  // Simulate API call to bank (90% success rate)
  var paymentSuccess = Math.random() > 0.1;
  
  if (paymentSuccess) {
    disb.status = 'success';
    disb.transactionRef = 'TXN' + Date.now() + '-' + String(i).padStart(4, '0');
    disb.processedAt = new Date().toISOString();
    successCount++;
    totalAmountDisbursed += disb.amount;
    console.log('✅ [' + disb.id + '] Payment successful - Ref: ' + disb.transactionRef);
    
    // C. SEND NOTIFICATION
    console.log('📧 [' + disb.id + '] Sending SMS notification');
    console.log('✉️ [' + disb.id + '] SMS: Payment of NGN ' + disb.amount.toLocaleString() + ' credited');
    disb.notificationSent = true;
    
  } else {
    disb.status = 'failed';
    disb.errorMessage = 'Insufficient funds in pooling account';
    failedCount++;
    console.log('❌ [' + disb.id + '] Payment failed: ' + disb.errorMessage);
  }
}

// ===== STEP 3: GENERATE REPORT =====
console.log('\\n📊 STEP 3: Generating batch report');
var endTime = new Date();
var durationSeconds = ((endTime - startTime) / 1000).toFixed(2);
var successRate = ((successCount / disbursements.length) * 100).toFixed(2);

var report = {
  batchId: batchId,
  totalRecords: disbursements.length,
  successCount: successCount,
  failedCount: failedCount,
  validationFailedCount: validationFailedCount,
  totalAmountDisbursed: totalAmountDisbursed,
  successRate: successRate + '%',
  startTime: startTime.toISOString(),
  endTime: endTime.toISOString(),
  duration: durationSeconds + ' seconds'
};

console.log('\\n📈 BATCH REPORT:');
console.log('═══════════════════════════════════════');
console.log('   Batch ID:          ' + report.batchId);
console.log('   Total Records:     ' + report.totalRecords);
console.log('   Successful:        ' + report.successCount + ' (' + report.successRate + ')');
console.log('   Failed (Payment):  ' + report.failedCount);
console.log('   Failed (Validation): ' + report.validationFailedCount);
console.log('   Total Disbursed:   NGN ' + report.totalAmountDisbursed.toLocaleString());
console.log('   Duration:          ' + report.duration);
console.log('═══════════════════════════════════════');

// Store results in context for next task
context.disbursements = disbursements;
context.batchReport = report;
context.batchId = batchId;

console.log('\\n✅ Batch processing complete!');" />
          <custom:property name="scriptLanguage" value="javascript" />
        </custom:properties>
      </bpmn:extensionElements>
      <bpmn:incoming>Flow_Start_To_ProcessBatch</bpmn:incoming>
      <bpmn:outgoing>Flow_ProcessBatch_To_SendEmail</bpmn:outgoing>
    </bpmn:scriptTask>
    
    <!-- Send Email Report -->
    <bpmn:scriptTask id="ScriptTask_SendEmailReport" name="Send Report via Email" scriptFormat="javascript">
      <bpmn:extensionElements>
        <custom:properties>
          <custom:property name="script" value="// Send email report using SendMailCommand
console.log('📧 Sending batch report via email...');

var report = context.batchReport;

var emailBody = '&lt;html&gt;&lt;body&gt;' +
  '&lt;h2&gt;Batch Disbursement Report&lt;/h2&gt;' +
  '&lt;p&gt;&lt;strong&gt;Batch ID:&lt;/strong&gt; ' + report.batchId + '&lt;/p&gt;' +
  '&lt;table border=&quot;1&quot; cellpadding=&quot;10&quot; style=&quot;border-collapse:collapse;&quot;&gt;' +
  '&lt;tr&gt;&lt;td&gt;&lt;strong&gt;Total Records&lt;/strong&gt;&lt;/td&gt;&lt;td&gt;' + report.totalRecords + '&lt;/td&gt;&lt;/tr&gt;' +
  '&lt;tr&gt;&lt;td&gt;&lt;strong&gt;Successful&lt;/strong&gt;&lt;/td&gt;&lt;td style=&quot;color:green;&quot;&gt;' + report.successCount + '&lt;/td&gt;&lt;/tr&gt;' +
  '&lt;tr&gt;&lt;td&gt;&lt;strong&gt;Failed (Payment)&lt;/strong&gt;&lt;/td&gt;&lt;td style=&quot;color:red;&quot;&gt;' + report.failedCount + '&lt;/td&gt;&lt;/tr&gt;' +
  '&lt;tr&gt;&lt;td&gt;&lt;strong&gt;Failed (Validation)&lt;/strong&gt;&lt;/td&gt;&lt;td style=&quot;color:orange;&quot;&gt;' + report.validationFailedCount + '&lt;/td&gt;&lt;/tr&gt;' +
  '&lt;tr&gt;&lt;td&gt;&lt;strong&gt;Success Rate&lt;/strong&gt;&lt;/td&gt;&lt;td&gt;' + report.successRate + '&lt;/td&gt;&lt;/tr&gt;' +
  '&lt;tr&gt;&lt;td&gt;&lt;strong&gt;Total Amount&lt;/strong&gt;&lt;/td&gt;&lt;td&gt;&lt;strong&gt;NGN ' + report.totalAmountDisbursed.toLocaleString() + '&lt;/strong&gt;&lt;/td&gt;&lt;/tr&gt;' +
  '&lt;tr&gt;&lt;td&gt;&lt;strong&gt;Duration&lt;/strong&gt;&lt;/td&gt;&lt;td&gt;' + report.duration + '&lt;/td&gt;&lt;/tr&gt;' +
  '&lt;/table&gt;' +
  '&lt;p&gt;&lt;small&gt;Started: ' + report.startTime + '&lt;br/&gt;Completed: ' + report.endTime + '&lt;/small&gt;&lt;/p&gt;' +
  '&lt;/body&gt;&lt;/html&gt;';

var emailResult = doCmd('SendMailCommand', {
  emmail: ['finance@company.com', 'operations@company.com'],
  subject: 'Batch Disbursement Report - ' + report.batchId,
  message: emailBody,
  sender: 'noreply@banklingo.app'
});

if (emailResult &amp;&amp; emailResult.Success) {
  console.log('✅ Email report sent successfully');
  context.emailSent = true;
} else {
  console.log('⚠️ Email send attempted (SendMailCommand may need configuration)');
  context.emailSent = false;
}" />
          <custom:property name="scriptLanguage" value="javascript" />
        </custom:properties>
      </bpmn:extensionElements>
      <bpmn:incoming>Flow_ProcessBatch_To_SendEmail</bpmn:incoming>
      <bpmn:outgoing>Flow_SendEmail_To_End</bpmn:outgoing>
    </bpmn:scriptTask>
    
    <!-- End Event -->
    <bpmn:endEvent id="EndEvent_1" name="Batch Complete">
      <bpmn:incoming>Flow_SendEmail_To_End</bpmn:incoming>
    </bpmn:endEvent>
    
    <!-- Sequence Flows -->
    <bpmn:sequenceFlow id="Flow_Start_To_ProcessBatch" sourceRef="StartEvent_1" targetRef="ScriptTask_ProcessBatch" />
    <bpmn:sequenceFlow id="Flow_ProcessBatch_To_SendEmail" sourceRef="ScriptTask_ProcessBatch" targetRef="ScriptTask_SendEmailReport" />
    <bpmn:sequenceFlow id="Flow_SendEmail_To_End" sourceRef="ScriptTask_SendEmailReport" targetRef="EndEvent_1" />
    
  </bpmn:process>
  
  <!-- BPMN Diagram -->
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_BatchDisbursementWorking">
      
      <bpmndi:BPMNShape id="StartEvent_1_di" bpmnElement="StartEvent_1">
        <dc:Bounds x="173" y="102" width="36" height="36" />
        <bpmndi:BPMNLabel>
          <dc:Bounds x="163" y="145" width="56" height="14" />
        </bpmndi:BPMNLabel>
      </bpmndi:BPMNShape>
      
      <bpmndi:BPMNShape id="ScriptTask_ProcessBatch_di" bpmnElement="ScriptTask_ProcessBatch">
        <dc:Bounds x="280" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      
      <bpmndi:BPMNShape id="ScriptTask_SendEmailReport_di" bpmnElement="ScriptTask_SendEmailReport">
        <dc:Bounds x="450" y="80" width="100" height="80" />
      </bpmndi:BPMNShape>
      
      <bpmndi:BPMNShape id="EndEvent_1_di" bpmnElement="EndEvent_1">
        <dc:Bounds x="622" y="102" width="36" height="36" />
        <bpmndi:BPMNLabel>
          <dc:Bounds x="600" y="145" width="80" height="14" />
        </bpmndi:BPMNLabel>
      </bpmndi:BPMNShape>
      
      <bpmndi:BPMNEdge id="Flow_Start_To_ProcessBatch_di" bpmnElement="Flow_Start_To_ProcessBatch">
        <di:waypoint x="209" y="120" />
        <di:waypoint x="280" y="120" />
      </bpmndi:BPMNEdge>
      
      <bpmndi:BPMNEdge id="Flow_ProcessBatch_To_SendEmail_di" bpmnElement="Flow_ProcessBatch_To_SendEmail">
        <di:waypoint x="380" y="120" />
        <di:waypoint x="450" y="120" />
      </bpmndi:BPMNEdge>
      
      <bpmndi:BPMNEdge id="Flow_SendEmail_To_End_di" bpmnElement="Flow_SendEmail_To_End">
        <di:waypoint x="550" y="120" />
        <di:waypoint x="622" y="120" />
      </bpmndi:BPMNEdge>
      
    </bpmndi:BPMNPlane>
  </bpmndi:BPMNDiagram>
  
</bpmn:definitions>`
};




// Template categories and examples
export const PROCESS_TEMPLATES = {
  popular: [
    {
      id: 'simple-approval',
      name: 'Simple Approval',
      description: 'Basic single-level approval process with submit and review steps',
      icon: <UserOutlined />,
      color: '#1890ff',
      category: 'Approval',
      complexity: 'Beginner',
      duration: '1 week',
      usage: 'Very High',
      tags: ['simple', 'approval', 'quick'],
      preview: '/templates/simple-approval.png'
    },
    {
      id: 'notification-system',
      name: 'Notification System',
      description: 'Send notifications via multiple channels including email and SMS',
      icon: <NotificationOutlined />,
      color: '#722ed1',
      category: 'Communication',
      complexity: 'Beginner',
      duration: '1 week',
      usage: 'High',
      tags: ['notification', 'communication', 'alert'],
      preview: '/templates/notification.png'
    },
    {
      id: 'employee-onboarding',
      name: 'Employee Onboarding',
      description: 'Complete employee onboarding process with parallel tasks',
      icon: <UserOutlined />,
      color: '#52c41a',
      category: 'HR',
      complexity: 'Intermediate',
      duration: '2-3 weeks',
      usage: 'High',
      tags: ['hr', 'onboarding', 'employee'],
      preview: '/templates/onboarding.png'
    }
  ],
  quickStart: [
    {
      id: 'data-sync',
      name: 'Data Synchronization',
      description: 'Extract, transform and load data between different systems',
      icon: <CloudServerOutlined />,
      color: '#13c2c2',
      category: 'Integration',
      complexity: 'Intermediate',
      duration: '2-3 weeks',
      usage: 'Medium',
      tags: ['data', 'sync', 'integration', 'etl'],
      preview: '/templates/data-sync.png'
    },
    {
      id: 'multi-level-approval',
      name: 'Multi-level Approval',
      description: 'Complex approval chain with multiple stakeholders and escalation',
      icon: <UserOutlined />,
      color: '#1890ff',
      category: 'Approval',
      complexity: 'Advanced',
      duration: '3-4 weeks',
      usage: 'High',
      tags: ['approval', 'workflow', 'escalation', 'multi-stage'],
      preview: '/templates/multi-approval.png'
    },
    {
      id: 'incident-management',
      name: 'Incident Management',
      description: 'IT incident management with priority-based routing',
      icon: <CheckCircleOutlined />,
      color: '#fa8c16',
      category: 'IT',
      complexity: 'Intermediate',
      duration: '2 weeks',
      usage: 'Medium',
      tags: ['incident', 'support', 'it'],
      preview: '/templates/incident.png'
    },
    {
      id: 'batch-disbursement-sequential',
      name: 'Batch Disbursement - Sequential',
      description: 'Process 50 disbursements one at a time in sequence',
      icon: <SendOutlined />,
      color: '#52c41a',
      category: 'Finance',
      complexity: 'Advanced',
      duration: '2-3 weeks',
      usage: 'High',
      tags: ['disbursement', 'payment', 'batch', 'sequential'],
      preview: '/templates/disbursement-seq.png'
    },
    {
      id: 'batch-disbursement-parallel',
      name: 'Batch Disbursement - Parallel',
      description: 'Process 50 disbursements in parallel batches of 10',
      icon: <ThunderboltOutlined />,
      color: '#1890ff',
      category: 'Finance',
      complexity: 'Advanced',
      duration: '2-3 weeks',
      usage: 'High',
      tags: ['disbursement', 'payment', 'batch', 'parallel', 'fast'],
      preview: '/templates/disbursement-parallel.png'
    },
    {
      id: 'batch-disbursement-working',
      name: 'Batch Disbursement - Working',
      description: 'Working implementation of batch disbursement process',
      icon: <RocketOutlined />,
      color: '#eb2f96',
      category: 'Finance',
      complexity: 'Advanced',
      duration: '2-3 weeks',
      usage: 'High',
      tags: ['disbursement', 'payment', 'batch', 'working'],
      preview: '/templates/disbursement-working.png'
    }
  ]
};
export
  const LEARN_LINKS = {
    fresh: 'https://docs.example.com/creating-processes-from-scratch',
    template: 'https://docs.example.com/using-process-templates',
    automated: 'https://docs.example.com/automated-process-flows',
    event: 'https://docs.example.com/event-based-processes',
    manual: 'https://docs.example.com/manual-process-flows',
    general: 'https://docs.example.com/process-design-guide',
    approval: 'https://docs.example.com/approval-processes',
    notification: 'https://docs.example.com/notification-workflows',
    dataSync: 'https://docs.example.com/data-synchronization',
    scheduled: 'https://docs.example.com/scheduled-processes'
  };


// Flow type configurations with detailed descriptions
export const FLOW_TYPES = [

  {
    id: 'manual',
    value: 0,
    name: 'Manual/Human Workflow',
    description: 'Processes requiring human interaction, decisions, and approvals',
    icon: <UserOutlined />,
    color: '#52c41a',
    useCases: [
      'Approval workflows',
      'Review and validation processes',
      'Case management',
      'Collaborative decision making'
    ],
    bestFor: 'Processes involving human judgment, review, or decision points',
    examples: ['Employee onboarding', 'Expense approvals', 'Content review']
  },
  {
    id: 'automated',
    value: 1,
    name: 'Automated Workflow',
    description: 'Fully automated processes that run without manual intervention',
    icon: <RocketOutlined />,
    color: '#1890ff',
    useCases: [
      'Data processing and synchronization',
      'Automated report generation',
      'System-to-system integration',
      'Scheduled batch operations'
    ],
    bestFor: 'Repetitive, rule-based processes that require consistency and speed',
    examples: ['Invoice processing', 'Alert systems', 'Monitoring workflows', 'Real-time updates', 'Data migration', 'Report generation']
  },
  {
    id: 'scheduled',
    value: 2,
    name: 'Scheduled Process',
    description: 'Processes that run on a specific schedule or time-based triggers',
    icon: <ClockCircleOutlined />,
    color: '#faad14',
    useCases: [
      'Daily, weekly, or monthly reports',
      'Regular data maintenance',
      'Scheduled backups',
      'Periodic notifications'
    ],
    bestFor: 'Regular, time-based operations that need to run automatically',
    examples: ['Monthly reporting', 'Daily data cleanup', 'Weekly notifications']
  }
];


export  const BACKEND_DROPDOWN_CONFIG = {
  responsibleUser: {
    endpoint: 'LookUpUsersQuery',
    valueField: 'id',
    textField: 'name',
  },
  responsibleTeam: {
    endpoint: 'LookUpRolesQuery',
    valueField: 'id',
    textField: 'roleName',
  },
  form: {
    endpoint: 'LookUpFormsQuery',
    valueField: 'id',
    textField: 'name',
  }
};


export  const BACKEND_NEW_DROP_DOWN = {

  eventTrigger: {
    endpoint: 'GetProcessBundleQuery',
    valueField: 'value',
    textField: 'name',
    detail: 'description',
  },
  contextLoader: {
    endpoint: 'GetContextLoadersQuery',
    valueField: 'code',
    textField: 'name',
    detailField: 'description',
  },
}

// Static dropdown items (these don't change)
export  const STATIC_DROPDOWN_ITEMS = {
  userAction: [
    // Approval Actions
    { value: 'approve', text: 'Approve', category: 'Approval' },
    { value: 'reject', text: 'Reject', category: 'Approval' },
    { value: 'request_approval', text: 'Request Approval', category: 'Approval' },
    
    // Submission Actions
    { value: 'submit', text: 'Submit', category: 'Submission' },
    { value: 'complete', text: 'Complete', category: 'Submission' },
    { value: 'send', text: 'Send', category: 'Submission' },
    
    // Save Actions
    { value: 'save', text: 'Save Draft', category: 'Save' },
    { value: 'save_draft', text: 'Save Draft', category: 'Save' },
    { value: 'save_and_continue', text: 'Save & Continue', category: 'Save' },
    
    // Review Actions
    { value: 'review', text: 'Review', category: 'Review' },
    { value: 'verify', text: 'Verify', category: 'Review' },
    { value: 'validate', text: 'Validate', category: 'Review' },
    
    // Cancel/Decline Actions
    { value: 'cancel', text: 'Cancel', category: 'Cancel' },
    { value: 'decline', text: 'Decline', category: 'Cancel' },
    { value: 'deny', text: 'Deny', category: 'Cancel' },
    
    // Escalation Actions
    { value: 'escalate', text: 'Escalate', category: 'Escalation' },
    { value: 'reassign', text: 'Reassign', category: 'Escalation' },
    { value: 'delegate', text: 'Delegate', category: 'Escalation' },
    
    // Hold/Pause Actions
    { value: 'hold', text: 'Hold', category: 'Hold' },
    { value: 'pause', text: 'Pause', category: 'Hold' },
    { value: 'resume', text: 'Resume', category: 'Hold' },
    
    // Edit Actions
    { value: 'edit', text: 'Edit', category: 'Edit' },
    { value: 'update', text: 'Update', category: 'Edit' },
    { value: 'revise', text: 'Revise', category: 'Edit' },
    
    // Delete Actions
    { value: 'delete', text: 'Delete', category: 'Delete' },
    { value: 'remove', text: 'Remove', category: 'Delete' },
    
    // Forward Actions
    { value: 'forward', text: 'Forward', category: 'Forward' },
    { value: 'proceed', text: 'Proceed', category: 'Forward' },
    { value: 'continue', text: 'Continue', category: 'Forward' },
    
    // Close Actions
    { value: 'close', text: 'Close', category: 'Close' },
    { value: 'finalize', text: 'Finalize', category: 'Close' },
    { value: 'finish', text: 'Finish', category: 'Close' }
  ],
  httpMethod: [
    { value: 'GET', text: 'GET' },
    { value: 'POST', text: 'POST' },
    { value: 'PUT', text: 'PUT' },
    { value: 'PATCH', text: 'PATCH' },
    { value: 'DELETE', text: 'DELETE' }
  ],
  serviceType: [
    { value: 'Command Execution', text: 'Command Execution' },
    { value: 'Rest Call', text: 'Rest Call' },
    { value: 'AI Model', text: 'AI Model' }
  ],
  channel: [
    { value: 'internal', text: 'Internal Service' },
    { value: 'http', text: 'HTTP' },
    { value: 'webhook', text: 'Webhook' },
    { value: 'email', text: 'Email' },
    { value: 'sms', text: 'SMS' },
    { value: 'slack', text: 'Slack' },
    { value: 'push', text: 'Push' },
    { value: 'kafka', text: 'Kafka' },
    { value: 'sqs', text: 'Amazon SQS' }
  ],
  decisionBinding: [
    { value: 'latest', text: 'latest' },
    { value: 'deployment', text: 'deployment' },
    { value: 'version', text: 'version' }
  ],
  scriptLanguage: [
    { value: 'javascript', text: 'JavaScript' },
  ],
  multiInstanceMode: [
    { value: 'parallel', text: 'Parallel (Execute all at once)' },
    { value: 'sequential', text: 'Sequential (Execute one by one)' }
  ],
  aiFallbackStrategy: [
    { value: 'default-value', text: 'Default Value – Use a fallback JSON value' },
    { value: 'continue', text: 'Continue – Proceed without AI result' },
    { value: 'fail', text: 'Fail – Mark task as failed' },
    { value: 'retry', text: 'Retry – Retry with backoff' },
    { value: 'skip', text: 'Skip – Skip this step entirely' }
  ],
  // permission: loaded from backend via RetrievePermissionsListQuery (grouped response)
  permission: [],
  // aiCapability: loaded from backend via GetAIModelCapabilitiesQuery (grouped by category)
  aiCapability: []
};


// User Action = what decision the human is allowed to make at this task
// Entity State = what business state the entity must enter as a result of certain actions
// which property keys belong to each task type

// CODE SNIPPETS LIBRARY - Categorized examples for quick reference
// ⭐ MOST IMPORTANT CATEGORIES FIRST: Commands, Context, Examples
export  const CODE_SNIPPETS = {
  // BPMCORE Commands (doCmd) - Send Email, SMS, Query DB, etc.
  'commands': {
    category: '� Send Email/SMS & Commands (doCmd)',
    snippets: [
      {
        title: 'sha256 - SHA-256 Hash',
        syntax: 'sha256(input: string): string',
        description: 'Computes SHA-256 hash of a string and returns hex (lowercase)',
        code: `return sha256("hello world");
// Returns: "b94d27b9934d3e08a52e52d7da7dabfa..."`
      },
      {
        title: 'sha512 - SHA-512 Hash',
        syntax: 'sha512(input: string): string',
        description: 'Computes SHA-512 hash of a string',
        code: `return sha512("secret|INV001|1500.00|20250911");
// Returns: "7d0a84641d06eeb65e49b0b3c6d70e8d..."`
      },
      {
        title: 'hmacSha256 - HMAC-SHA256',
        syntax: 'hmacSha256(key: string, data: string): string',
        description: 'Computes HMAC-SHA256 with a secret key (common for API signing)',
        code: `return hmacSha256("my-secret", "payload-data");
// Returns: "6bb4837eb74329105ee4568dd..."`
      },
      {
        title: 'base64Encode - Encode to Base64',
        syntax: 'base64Encode(input: string): string',
        description: 'Encodes string to Base64',
        code: `return base64Encode("BankLingo");
// Returns: "QmFua0xpbmdv"`
      },
      {
        title: 'base64Decode - Decode from Base64',
        syntax: 'base64Decode(input: string): string',
        description: 'Decodes Base64 back to string',
        code: `return base64Decode("QmFua0xpbmdv");
// Returns: "BankLingo"`
      },
      {
        title: 'Payment Hash Example',
        description: 'Generate secure payment verification hash',
        code: `return sha512(context.secretKey + "|" + context.reference + "|" + context.amount + "|" + context.date);`
      },
      {
        title: 'Basic Auth Header',
        description: 'Create Basic Authentication header',
        code: `var userName = $.secure.get("CORE_BANKING_USERNAME");
var password = $.secure.get("CORE_BANKING_PASSWORD");
return { 
  authHeader: "Basic " + base64Encode(userName + ":" + password) 
};`
      }
    ]
  },

  // Date & Time Functions
  'datetime': {
    category: '🕒 Date & Time Functions',
    snippets: [
      {
        title: 'now - Current UTC Time',
        syntax: 'now(): string',
        description: 'Returns current UTC time in ISO 8601 format',
        code: `return now();
// Returns: "2025-09-11T15:21:00.123Z"`
      },
      {
        title: 'addDays - Add Days to Date',
        syntax: 'addDays(dateStr: string, days: number): string',
        description: 'Adds N days to a given date string',
        code: `return addDays("2025-09-11", 10);
// Returns: "2025-09-21T00:00:00.000Z"`
      },
      {
        title: 'diffDays - Days Between Dates',
        syntax: 'diffDays(dateStr1: string, dateStr2: string): number',
        description: 'Returns number of days between two dates',
        code: `return diffDays("2025-09-01", "2025-09-11");
// Returns: 10`
      },
      {
        title: 'formatDate - Format Date String',
        syntax: 'formatDate(dateStr: string, format: string): string',
        description: 'Formats date to pattern: "YYYY-MM-DD", "DD/MM/YYYY", "YYYYMMDDHHmmss"',
        code: `return formatDate("2025-09-11T15:00:00Z", "DD/MM/YYYY");
// Returns: "11/09/2025"`
      },
      {
        title: 'SLA Check Example',
        description: 'Check if request has exceeded 30-day SLA',
        code: `return diffDays(context.createdAt, now()) > 30 ? "Expired" : "Active";`
      }
    ]
  },

  // String Functions
  'strings': {
    category: '📦 String Functions',
    snippets: [
      {
        title: 'toUpper - Uppercase String',
        syntax: 'toUpper(str: string): string',
        description: 'Converts string to uppercase',
        code: `return toUpper("bank");
// Returns: "BANK"`
      },
      {
        title: 'toLower - Lowercase String',
        syntax: 'toLower(str: string): string',
        description: 'Converts string to lowercase',
        code: `return toLower("HELLO");
// Returns: "hello"`
      },
      {
        title: 'trim - Remove Whitespace',
        syntax: 'trim(str: string): string',
        description: 'Removes whitespace around string',
        code: `return trim(" hello ");
// Returns: "hello"`
      },
      {
        title: 'contains - Check Substring',
        syntax: 'contains(str: string, substring: string): boolean',
        description: 'Checks if string contains substring',
        code: `return contains("BankLingo", "Lingo");
// Returns: true`
      },
      {
        title: 'replaceAll - Replace All Occurrences',
        syntax: 'replaceAll(str: string, search: string, replace: string): string',
        description: 'Replaces all occurrences of a substring',
        code: `return replaceAll("111-222-111", "111", "XXX");
// Returns: "XXX-222-XXX"`
      },
      {
        title: 'slugify - URL-Friendly Slug',
        syntax: 'slugify(str: string): string',
        description: 'Converts string to URL-friendly slug',
        code: `return slugify("Bank Lingo 2025!");
// Returns: "bank-lingo-2025"`
      }
    ]
  },

  // Numeric Functions
  'numeric': {
    category: '💳 Numeric Functions',
    snippets: [
      {
        title: 'round - Round Number',
        syntax: 'round(value: number, decimals: number): number',
        description: 'Rounds a number to given decimals',
        code: `return round(123.4567, 2);
// Returns: 123.46`
      },
      {
        title: 'toFixed - Fixed Decimals',
        syntax: 'toFixed(value: number, decimals: number): string',
        description: 'Formats number with fixed decimals',
        code: `return toFixed(123.4, 2);
// Returns: "123.40"`
      },
      {
        title: 'percentageOf - Calculate Percentage',
        syntax: 'percentageOf(amount: number, percent: number): number',
        description: 'Returns percentage of a number',
        code: `return percentageOf(1000, 7.5);
// Returns: 75`
      },
      {
        title: 'Loan Interest Calculation',
        description: 'Calculate interest amount with rounding',
        code: `return round(percentageOf(context.principal, context.interestRate), 2);`
      }
    ]
  },

  // Validation Functions
  'validation': {
    category: '🧾 Validation Functions',
    snippets: [
      {
        title: 'isEmail - Validate Email',
        syntax: 'isEmail(str: string): boolean',
        description: 'Validates email format',
        code: `return isEmail("user@example.com");
// Returns: true`
      },
      {
        title: 'isPhoneNumber - Validate Phone',
        syntax: 'isPhoneNumber(str: string): boolean',
        description: 'Checks if string looks like phone number',
        code: `return isPhoneNumber("+2348123456789");
// Returns: true`
      },
      {
        title: 'isNumber - Check Numeric',
        syntax: 'isNumber(val: any): boolean',
        description: 'Checks if value is numeric',
        code: `return isNumber("1500.00");
// Returns: true`
      },
      {
        title: 'isDate - Validate Date',
        syntax: 'isDate(str: string): boolean',
        description: 'Checks if valid date string',
        code: `return isDate("2025-09-11");
// Returns: true`
      },
      {
        title: 'Email Validation Example',
        description: 'Validate and return appropriate message',
        code: `return isEmail(context.email) ? "Valid Email" : "Invalid Email";`
      }
    ]
  },

  // Utility Functions
  'utility': {
    category: '🛠️ Utility Functions',
    snippets: [
      {
        title: 'isNullOrEmpty - Check Empty',
        syntax: 'isNullOrEmpty(value: any): boolean',
        description: 'Checks for null/undefined/empty string',
        code: `return isNullOrEmpty("");
// Returns: true`
      },
      {
        title: 'coalesce - First Non-Empty',
        syntax: 'coalesce(...values: any[]): any',
        description: 'Returns first non-empty value',
        code: `return coalesce(null, "", "fallback");
// Returns: "fallback"`
      },
      {
        title: 'safeGet - Safe Property Access',
        syntax: 'safeGet(obj: object, path: string, defaultValue: any): any',
        description: 'Safely reads deep property by path',
        code: `return safeGet(context, "user.details.name", "Unknown");
// Returns: "John Doe" or "Unknown"`
      },
      {
        title: 'generateUUID - Random UUID',
        syntax: 'generateUUID(): string',
        description: 'Generates random UUID (v4)',
        code: `return generateUUID();
// Returns: "c6b1c3d8-37b4-4e3b-a34f-9824b9a7e5d7"`
      }
    ]
  },

  // BPMCORE Commands (doCmd) - Send Email, SMS, Query DB, etc.
  'commands': {
    category: '� Send Email/SMS & Commands (doCmd)',
    snippets: [
      {
        title: 'SendEmailCommand - Send Email',
        syntax: 'doCmd("SendEmailCommand", {...}): { Success: bool, Message: string }',
        description: 'Send email notification using BPMCORE',
        code: `var result = doCmd('SendEmailCommand', {
  Email: [context.customer.email],
  Subject: "Loan Application Status",
  Message: "<h1>Dear " + context.customer.firstName + ",</h1><p>Your loan has been approved!</p>",
  Sender: "noreply@banklingo.com"
});
return result.Success;`
      },
      {
        title: 'SendSMSCommand - Send SMS',
        syntax: 'doCmd("SendSMSCommand", {...}): { Success: bool, MessageId: string }',
        description: 'Send SMS notification',
        code: `var result = doCmd('SendSMSCommand', {
  MessageBody: "Your OTP is: " + context.otp,
  MobileNumber: context.customer.mobileNumber,
  ProviderCode: "DEFAULT"
});
return result.MessageId;`
      },
      {
        title: 'QueryCommand - Query Database',
        syntax: 'doCmd("QueryCommand", {...}): object[]',
        description: 'Query database records',
        code: `var loans = doCmd('QueryCommand', {
  Query: "SELECT * FROM Loans WHERE CustomerId = @customerId AND Status = @status",
  Parameters: {
    customerId: context.customer.id,
    status: "ACTIVE"
  }
});
return loans;`
      },
      {
        title: 'InsertCommand - Insert Record',
        syntax: 'doCmd("InsertCommand", {...}): { Id: string }',
        description: 'Insert new database record',
        code: `var result = doCmd('InsertCommand', {
  TableName: "LoanApplications",
  Data: {
    CustomerId: context.customer.id,
    Amount: context.loanAmount,
    Status: "PENDING",
    CreatedAt: now()
  }
});
context.newLoanId = result.Id;
return result;`
      },
      {
        title: 'UpdateCommand - Update Record',
        syntax: 'doCmd("UpdateCommand", {...}): { RowsAffected: int }',
        description: 'Update existing database record',
        code: `var result = doCmd('UpdateCommand', {
  TableName: "Loans",
  Data: {
    Status: "APPROVED",
    ApprovedAt: now(),
    ApprovedBy: context.user.id
  },
  Where: "Id = @loanId",
  Parameters: { loanId: context.loanId }
});
return result.RowsAffected;`
      },
      {
        title: 'APICallCommand - Call External API',
        syntax: 'doCmd("APICallCommand", {...}): object',
        description: 'Call external REST API',
        code: `var creditScore = doCmd('APICallCommand', {
  Url: "https://creditbureau.com/api/score",
  Method: "POST",
  Headers: {
    "Authorization": "Bearer " + $.secure.get("CREDIT_BUREAU_API_KEY"),
    "Content-Type": "application/json"
  },
  Body: {
    bvn: context.customer.bvn,
    customerId: context.customer.id
  }
});
context.creditScore = creditScore.score;
return creditScore;`
      },
      {
        title: 'GenerateDocumentCommand - Generate PDF',
        syntax: 'doCmd("GenerateDocumentCommand", {...}): { DocumentUrl: string }',
        description: 'Generate PDF document from template',
        code: `var doc = doCmd('GenerateDocumentCommand', {
  TemplateName: "LoanAgreement",
  Data: {
    customerName: context.customer.firstName + " " + context.customer.lastName,
    loanAmount: context.loanAmount,
    interestRate: context.interestRate,
    tenure: context.tenure,
    date: formatDate(now(), "DD/MM/YYYY")
  },
  OutputFormat: "PDF"
});
context.documentUrl = doc.DocumentUrl;
return doc;`
      },
      {
        title: 'BusinessRuleCommand - Apply Rule',
        syntax: 'doCmd("BusinessRuleCommand", {...}): object',
        description: 'Execute business rule engine',
        code: `var decision = doCmd('BusinessRuleCommand', {
  RuleName: "LoanEligibilityRule",
  Input: {
    creditScore: context.creditScore,
    monthlyIncome: context.customer.monthlyIncome,
    existingDebt: context.customer.existingDebt,
    requestedAmount: context.loanAmount
  }
});
context.isEligible = decision.Eligible;
context.maxLoanAmount = decision.MaxAmount;
return decision;`
      },
      {
        title: 'HttpInvoke - Generic HTTP Call',
        syntax: 'doCmd("HttpInvoke", {...}): object',
        description: 'Make generic HTTP request',
        code: `var response = doCmd('HttpInvoke', {
  Url: "https://api.example.com/webhook",
  Method: "POST",
  Headers: {
    "X-Signature": hmacSha256($.secure.get("WEBHOOK_SECRET"), context.payload)
  },
  Body: context.payload,
  Timeout: 30000
});
return response;`
      },
      {
        title: 'Command Chaining Example',
        description: 'Chain multiple commands for complete workflow',
        code: `// 1. Query customer data
var customer = doCmd('QueryCommand', {
  Query: "SELECT * FROM Customers WHERE Id = @id",
  Parameters: { id: context.customerId }
})[0];

// 2. Check credit score
var credit = doCmd('APICallCommand', {
  Url: "https://creditbureau.com/api/score",
  Method: "POST",
  Headers: { "Authorization": "Bearer " + $.secure.get("CREDIT_API_KEY") },
  Body: { bvn: customer.BVN }
});

// 3. Apply business rule
var decision = doCmd('BusinessRuleCommand', {
  RuleName: "LoanApprovalRule",
  Input: { creditScore: credit.score, income: customer.MonthlyIncome }
});

// 4. Update loan status
if (decision.Approved) {
  doCmd('UpdateCommand', {
    TableName: "Loans",
    Data: { Status: "APPROVED" },
    Where: "Id = @id",
    Parameters: { id: context.loanId }
  });
  
  // 5. Send notification
  doCmd('SendEmailCommand', {
    Email: [customer.Email],
    Subject: "Loan Approved!",
    Message: "Congratulations! Your loan has been approved."
  });
}

return decision;`
      }
    ]
  },

  // Secure Access
  'secure': {
    category: '🔐 Secure Credentials Access',
    snippets: [
      {
        title: '$.secure.get - Get Secure Key',
        syntax: '$.secure.get(keyName: string): string',
        description: 'Access secrets securely (read-only)',
        code: `var apiKey = $.secure.get("NIP_API_KEY");
return apiKey;`
      },
      {
        title: 'API Key with HMAC',
        description: 'Encrypt data using secure key',
        code: `var bvn = context.userBvn;
var key = $.secure.get("NIP_ENCRYPTION_KEY");
return hmacSha256(key, bvn);`
      },
      {
        title: 'Multiple Credentials',
        description: 'Access multiple secure values',
        code: `var apiKey = $.secure.get("NIP_API_KEY");
var secret = $.secure.get("NIP_SECRET");
return hmacSha256(apiKey, context.bvn);`
      }
    ]
  },

  // Context Access & Expressions
  'expressions': {
    category: '📝 Context Access & Expressions',
    snippets: [
      {
        title: 'context Object - Main Data Store',
        syntax: 'context: object',
        description: 'All workflow data is stored in context object. Access any property directly.',
        code: `// Access context properties
var customerId = context.customerId;
var loanAmount = context.loanAmount;
var email = context.customer.email;

// Set new context properties
context.approved = true;
context.approvalDate = now();

return context;`
      },
      {
        title: 'context.lastScriptResult - Previous Result',
        syntax: 'context.lastScriptResult: any',
        description: 'Result from the last executed script/command',
        code: `// Previous script returned { score: 750, rating: "GOOD" }
var creditScore = context.lastScriptResult.score;
var rating = context.lastScriptResult.rating;

// Use in decision
if (creditScore >= 700) {
  context.eligible = true;
}
return context.eligible;`
      },
      {
        title: 'Form Data from UserTask Signal',
        syntax: 'context.formFieldName: any',
        description: 'When UserTask is completed, form data is merged into context',
        code: `// After UserTask submission, form fields are in context
var loanAmount = context.loanAmount;  // from form
var tenure = context.tenure;  // from form
var guarantorName = context.guarantorName;  // from form

// Use form data in script
context.monthlyPayment = (loanAmount * 0.05) / tenure;
return context;`
      },
      {
        title: 'Result Variable Storage',
        syntax: 'context[ResultVariable]: any',
        description: 'Store command result in named context variable using ResultVariable',
        code: `// In ServiceTask, set ResultVariable = "creditCheckResult"
// After execution:
var creditData = context.creditCheckResult;
var score = creditData.score;

// Use stored result
if (score >= 700) {
  context.approvalStatus = "APPROVED";
}
return context;`
      },
      {
        title: 'Accessing Nested Context Data',
        syntax: 'context.parent.child.property',
        description: 'Navigate nested objects in context',
        code: `// Access deep properties
var firstName = context.customer.personalInfo.firstName;
var city = context.customer.address.city;
var accountNumber = context.customer.accounts[0].accountNumber;

// Safe access with coalesce
var email = coalesce(context.customer.email, context.customer.contactInfo.email, "noemail@example.com");

return { firstName, city, accountNumber, email };`
      },
      {
        title: 'Expression Syntax (in JSON/Templates)',
        description: 'Use {{...}} for dynamic values in JSON payloads',
        code: `// In email message template:
"Dear {{customer.firstName}}, your loan of {{loanAmount}} has been {{status}}."

// In conditional routing:
{{creditScore >= 700 ? "HIGH_SCORE" : "LOW_SCORE"}}

// In calculations:
{{loanAmount * (1 + interestRate/100)}}

// In database queries (Parameters):
"WHERE CustomerId = @customerId"
Parameters: { customerId: context.customerId }`
      },
      {
        title: 'UserTask PreScript - Prepare Form',
        syntax: 'PreScript returns formContext object',
        description: 'PreScript runs BEFORE form loads. Return formContext with data for form.',
        code: `// Query customer and loan data
var customer = doCmd('QueryCommand', {
  Query: "SELECT * FROM Customers WHERE Id = @id",
  Parameters: { id: context.customerId }
})[0];

var activeLoan = doCmd('QueryCommand', {
  Query: "SELECT * FROM Loans WHERE CustomerId = @id AND Status = 'ACTIVE'",
  Parameters: { id: context.customerId }
})[0];

// Calculate display values
var totalDebt = activeLoan ? activeLoan.OutstandingBalance : 0;
var availableCredit = customer.CreditLimit - totalDebt;

// Return formContext for form to use
return {
  customerName: customer.FirstName + " " + customer.LastName,
  customerEmail: customer.Email,
  currentDebt: totalDebt,
  maxLoanAmount: availableCredit,
  recommendedAmount: round(availableCredit * 0.8, 2)
};`
      },
      {
        title: 'UserTask ServerScript - Process Form',
        syntax: 'ServerScript runs AFTER form submission. Form data is in context.',
        description: 'ServerScript has access to submitted form data merged into context',
        code: `// Form data is now in context (e.g., context.loanAmount, context.tenure)
var requestedAmount = context.loanAmount;
var tenure = context.tenure;
var purpose = context.loanPurpose;

// Validate
if (requestedAmount > context.maxLoanAmount) {
  return { error: "Requested amount exceeds limit" };
}

// Update database
doCmd('InsertCommand', {
  TableName: "LoanApplications",
  Data: {
    CustomerId: context.customerId,
    Amount: requestedAmount,
    Tenure: tenure,
    Purpose: purpose,
    Status: "PENDING",
    CreatedAt: now()
  }
});

// Send notification
doCmd('SendEmailCommand', {
  Email: [context.customer.email],
  Subject: "Loan Application Received",
  Message: "We have received your loan application for " + requestedAmount
});

// Store audit log
context.applicationDate = now();
context.submittedBy = context.user.id;

return { success: true, message: "Application submitted successfully" };`
      }
    ]
  },

  // JSON Payloads
  'payloads': {
    category: '📋 JSON Payloads',
    snippets: [
      {
        title: 'Email Payload',
        description: 'Send email with context variables',
        code: `{
  "email": ["{{customer.email}}"],
  "subject": "Loan {{loan.id}} - Application Status",
  "message": "<h1>Dear {{customer.firstName}},</h1><p>Your loan application for {{loan.amount}} has been {{loan.status}}.</p>",
  "sender": "{{system.fromEmail}}"
}`
      },
      {
        title: 'SMS Payload',
        description: 'Send SMS notification',
        code: `{
  "messageBody": "Dear {{customer.firstName}}, your loan {{loan.id}} has been approved. Amount: {{loan.amount}}",
  "mobileNumber": "{{customer.mobileNumber}}",
  "providerCode": "DEFAULT"
}`
      },
      {
        title: 'API Call Payload',
        description: 'Call external REST API',
        code: `{
  "url": "https://api.example.com/endpoint",
  "method": "POST",
  "headers": {
    "Authorization": "Bearer {{system.apiKey}}",
    "Content-Type": "application/json"
  },
  "body": {
    "customerId": "{{customer.id}}",
    "amount": "{{form.amount}}"
  },
  "saveResultTo": "apiResponse"
}`
      },
      {
        title: 'Database Insert',
        description: 'Add new record to table',
        code: `{
  "tableName": "LoanApplications",
  "data": {
    "CustomerId": "{{customer.id}}",
    "LoanAmount": "{{form.loanAmount}}",
    "Status": "PENDING",
    "ApplicationDate": "{{system.currentDateTime}}"
  },
  "returnId": true,
  "saveResultTo": "newApplicationId"
}`
      }
    ]
  },

  // Complete Workflow Examples
  'examples': {
    category: '🧪 Complete Workflow Examples',
    snippets: [
      {
        title: 'Complete Loan Application Flow',
        description: 'End-to-end loan processing with credit check, decision, and notifications',
        code: `// STEP 1: Get customer data from context (from UserTask form)
var customerId = context.customerId;
var requestedAmount = context.loanAmount;
var tenure = context.tenure;

// STEP 2: Query customer details
var customer = doCmd('QueryCommand', {
  Query: "SELECT * FROM Customers WHERE Id = @id",
  Parameters: { id: customerId }
})[0];

// STEP 3: Call credit bureau API
var creditCheck = doCmd('APICallCommand', {
  Url: "https://creditbureau.com/api/score",
  Method: "POST",
  Headers: {
    "Authorization": "Bearer " + $.secure.get("CREDIT_BUREAU_API_KEY"),
    "Content-Type": "application/json"
  },
  Body: {
    bvn: customer.BVN,
    customerId: customerId
  }
});
context.creditScore = creditCheck.score;

// STEP 4: Calculate risk and make decision
var debtToIncome = customer.ExistingDebt / customer.MonthlyIncome;
var riskScore = 0;

if (creditCheck.score >= 750) riskScore += 40;
else if (creditCheck.score >= 650) riskScore += 25;

if (debtToIncome < 0.3) riskScore += 30;
if (customer.AccountAge > 12) riskScore += 20;

var approved = riskScore >= 70 && requestedAmount <= customer.MonthlyIncome * 3;
context.approved = approved;
context.riskScore = riskScore;

// STEP 5: Update loan application
var loanId = doCmd('InsertCommand', {
  TableName: "LoanApplications",
  Data: {
    CustomerId: customerId,
    Amount: requestedAmount,
    Tenure: tenure,
    Status: approved ? "APPROVED" : "REJECTED",
    CreditScore: creditCheck.score,
    RiskScore: riskScore,
    ProcessedAt: now()
  }
}).Id;
context.loanId = loanId;

// STEP 6: Send email notification
doCmd('SendEmailCommand', {
  Email: [customer.Email],
  Subject: approved ? "Loan Approved!" : "Loan Application Update",
  Message: approved 
    ? "<h1>Congratulations!</h1><p>Your loan of " + requestedAmount + " has been approved.</p>"
    : "<h1>Application Update</h1><p>Unfortunately, we cannot approve your loan at this time.</p>",
  Sender: "loans@banklingo.com"
});

// STEP 7: Send SMS
doCmd('SendSMSCommand', {
  MessageBody: approved 
    ? "Your loan of " + requestedAmount + " has been APPROVED. Ref: " + loanId
    : "Your loan application has been reviewed. Check email for details.",
  MobileNumber: customer.MobileNumber,
  ProviderCode: "DEFAULT"
});

// STEP 8: Generate agreement document if approved
if (approved) {
  var doc = doCmd('GenerateDocumentCommand', {
    TemplateName: "LoanAgreement",
    Data: {
      customerName: customer.FirstName + " " + customer.LastName,
      loanAmount: requestedAmount,
      tenure: tenure,
      interestRate: 12.5,
      date: formatDate(now(), "DD/MM/YYYY")
    },
    OutputFormat: "PDF"
  });
  context.agreementUrl = doc.DocumentUrl;
}

return {
  approved: approved,
  loanId: loanId,
  creditScore: creditCheck.score,
  riskScore: riskScore
};`
      },
      {
        title: 'UserTask PreScript - Loan Form Prep',
        description: 'Prepare data for loan application form before it loads',
        code: `// Query customer information
var customer = doCmd('QueryCommand', {
  Query: "SELECT * FROM Customers WHERE Id = @id",
  Parameters: { id: context.customerId }
})[0];

// Get active loans
var activeLoans = doCmd('QueryCommand', {
  Query: "SELECT SUM(OutstandingBalance) as TotalDebt FROM Loans WHERE CustomerId = @id AND Status = 'ACTIVE'",
  Parameters: { id: context.customerId }
})[0];

// Get loan products
var loanProducts = doCmd('QueryCommand', {
  Query: "SELECT * FROM LoanProducts WHERE Active = 1",
  Parameters: {}
});

// Calculate eligibility
var totalDebt = activeLoans.TotalDebt || 0;
var availableCredit = customer.CreditLimit - totalDebt;
var maxLoanAmount = round(customer.MonthlyIncome * 3, 2);

// Return formContext - this data will be available in the form
return {
  // Customer info for display
  customerName: customer.FirstName + " " + customer.LastName,
  customerEmail: customer.Email,
  customerPhone: customer.MobileNumber,
  accountNumber: customer.AccountNumber,
  
  // Financial info
  monthlyIncome: customer.MonthlyIncome,
  currentDebt: totalDebt,
  creditLimit: customer.CreditLimit,
  availableCredit: availableCredit,
  
  // Loan limits
  maxLoanAmount: maxLoanAmount,
  minLoanAmount: 10000,
  recommendedAmount: round(maxLoanAmount * 0.7, 2),
  
  // Loan products dropdown
  loanProducts: loanProducts,
  
  // Calculated fields
  debtToIncomeRatio: round((totalDebt / customer.MonthlyIncome) * 100, 2)
};`
      },
      {
        title: 'UserTask ServerScript - Process Submission',
        description: 'Process loan application after form submission',
        code: `// Form data is now merged into context
var loanAmount = context.loanAmount;
var tenure = context.tenure;
var loanProductId = context.loanProductId;
var purpose = context.loanPurpose;

// Validate form data
if (!loanAmount || loanAmount <= 0) {
  return { error: "Invalid loan amount" };
}

if (loanAmount > context.maxLoanAmount) {
  return { 
    error: "Requested amount exceeds maximum limit of " + context.maxLoanAmount 
  };
}

// Get loan product details
var product = doCmd('QueryCommand', {
  Query: "SELECT * FROM LoanProducts WHERE Id = @id",
  Parameters: { id: loanProductId }
})[0];

// Calculate loan details
var interestRate = product.InterestRate;
var monthlyRate = interestRate / 100 / 12;
var monthlyPayment = loanAmount * (monthlyRate * Math.pow(1 + monthlyRate, tenure)) / 
                     (Math.pow(1 + monthlyRate, tenure) - 1);
var totalPayment = monthlyPayment * tenure;
var totalInterest = totalPayment - loanAmount;

// Store calculations in context
context.interestRate = interestRate;
context.monthlyPayment = round(monthlyPayment, 2);
context.totalPayment = round(totalPayment, 2);
context.totalInterest = round(totalInterest, 2);

// Insert application
var applicationId = doCmd('InsertCommand', {
  TableName: "LoanApplications",
  Data: {
    CustomerId: context.customerId,
    LoanProductId: loanProductId,
    Amount: loanAmount,
    Tenure: tenure,
    Purpose: purpose,
    MonthlyPayment: context.monthlyPayment,
    TotalPayment: context.totalPayment,
    InterestRate: interestRate,
    Status: "PENDING",
    CreatedAt: now(),
    CreatedBy: context.user.id
  }
}).Id;
context.applicationId = applicationId;

// Send confirmation email
doCmd('SendEmailCommand', {
  Email: [context.customerEmail],
  Subject: "Loan Application Received - Ref: " + applicationId,
  Message: "<h1>Application Received</h1>" +
           "<p>Dear " + context.customerName + ",</p>" +
           "<p>We have received your loan application:</p>" +
           "<ul>" +
           "<li>Amount: " + loanAmount + "</li>" +
           "<li>Tenure: " + tenure + " months</li>" +
           "<li>Monthly Payment: " + context.monthlyPayment + "</li>" +
           "</ul>" +
           "<p>We will review and get back to you shortly.</p>",
  Sender: "loans@banklingo.com"
});

// Log audit trail
doCmd('InsertCommand', {
  TableName: "AuditLog",
  Data: {
    EntityType: "LoanApplication",
    EntityId: applicationId,
    Action: "CREATED",
    UserId: context.user.id,
    Timestamp: now(),
    Details: "Loan application submitted for " + loanAmount
  }
});

return {
  success: true,
  applicationId: applicationId,
  message: "Your loan application has been submitted successfully",
  monthlyPayment: context.monthlyPayment,
  totalInterest: context.totalInterest
};`
      },
      {
        title: 'Gateway Decision Script',
        description: 'Exclusive Gateway condition to route workflow based on credit score',
        code: `// Check if credit score exists in context
if (!context.creditScore) {
  return "NO_SCORE";
}

// Route based on credit score ranges
if (context.creditScore >= 750) {
  return "EXCELLENT";  // Auto-approve path
}
else if (context.creditScore >= 650) {
  return "GOOD";  // Manual review path
}
else if (context.creditScore >= 550) {
  return "FAIR";  // Additional verification path
}
else {
  return "POOR";  // Rejection path
}`
      },
      {
        title: 'ServiceTask - Payment Processing',
        description: 'Process loan disbursement with multiple commands',
        code: `// Get loan and customer details
var loan = doCmd('QueryCommand', {
  Query: "SELECT * FROM Loans WHERE Id = @id",
  Parameters: { id: context.loanId }
})[0];

var customer = doCmd('QueryCommand', {
  Query: "SELECT * FROM Customers WHERE Id = @id",
  Parameters: { id: loan.CustomerId }
})[0];

// Generate payment reference
var paymentRef = "LN" + formatDate(now(), "YYYYMMDDHHmmss") + context.loanId;
context.paymentReference = paymentRef;

// Create payment record
var paymentId = doCmd('InsertCommand', {
  TableName: "Payments",
  Data: {
    LoanId: context.loanId,
    Amount: loan.Amount,
    Reference: paymentRef,
    Status: "PENDING",
    CreatedAt: now()
  }
}).Id;

// Call payment gateway API
var paymentResult = doCmd('APICallCommand', {
  Url: $.secure.get("PAYMENT_GATEWAY_URL") + "/disburse",
  Method: "POST",
  Headers: {
    "Authorization": "Bearer " + $.secure.get("PAYMENT_GATEWAY_KEY"),
    "Content-Type": "application/json",
    "X-Signature": hmacSha256(
      $.secure.get("PAYMENT_GATEWAY_SECRET"),
      paymentRef + loan.Amount + customer.AccountNumber
    )
  },
  Body: {
    reference: paymentRef,
    amount: loan.Amount,
    accountNumber: customer.AccountNumber,
    accountName: customer.FirstName + " " + customer.LastName,
    narration: "Loan Disbursement - " + context.loanId
  }
});

// Update payment status
var paymentStatus = paymentResult.success ? "COMPLETED" : "FAILED";
doCmd('UpdateCommand', {
  TableName: "Payments",
  Data: {
    Status: paymentStatus,
    GatewayReference: paymentResult.transactionId,
    CompletedAt: now(),
    Response: JSON.stringify(paymentResult)
  },
  Where: "Id = @id",
  Parameters: { id: paymentId }
});

// Update loan status if payment successful
if (paymentResult.success) {
  doCmd('UpdateCommand', {
    TableName: "Loans",
    Data: {
      Status: "DISBURSED",
      DisbursedAt: now(),
      DisbursementReference: paymentRef
    },
    Where: "Id = @id",
    Parameters: { id: context.loanId }
  });
  
  // Send success notification
  doCmd('SendSMSCommand', {
    MessageBody: "Your loan of " + loan.Amount + " has been disbursed to your account. Ref: " + paymentRef,
    MobileNumber: customer.MobileNumber,
    ProviderCode: "DEFAULT"
  });
}

return {
  success: paymentResult.success,
  paymentReference: paymentRef,
  transactionId: paymentResult.transactionId,
  status: paymentStatus
};`
      }
    ]
  }
};

// You must ALWAYS validate the entity state FIRST.
// If the entity is not in a state that is compatible with the selected User Action, the task must NOT execute and an error must be returned.
export  const TASK_FIELDS = {
  UserTask: [
    // Basic Info
    'name',
    'description',

    // Form & UI
    'form',

    // Scripts (execution order)
    'preScript', // Runs before task
    'clientScript', // Runs in client
    'serverScript', // Runs on server

    // Business Logic
    'userAction',
    'entityState',

    // Assignment & Access Control
    'responsibleTeam',
    'responsibleUser',
    'permission',

    // Execution
    'resultVariable',
    'asyncBefore'
  ],

  ExclusiveGateway: [
    // Basic Info
    'name',
    'description',

    // Routing Logic
    'conditionalScript',
    'entityState',

    // Assignment (disabled - gateways don't assign to users)
    'responsibleTeam', // Always disabled
    'responsibleUser', // Always disabled

    // Execution
    'resultVariable',
    'asyncBefore'
  ],
  InclusiveGateway: [
    // Basic Info
    'name',
    'description',

    // Routing Logic
    'conditionalScript',
    'entityState',

    // Assignment (disabled - gateways don't assign to users)
    'responsibleTeam', // Always disabled
    'responsibleUser', // Always disabled

    // Execution
    'asyncBefore'
  ],
  ParallelGateway: [
    // Basic Info
    'name',
    'description',

    // Routing Logic
    'conditionalScript',
    'entityState',

    // Assignment (disabled - gateways don't assign to users)
    'responsibleTeam', // Always disabled
    'responsibleUser', // Always disabled

    // Execution
    'asyncBefore'
  ],

  SequenceFlow: [
    // Basic Info
    'name',
    'description',

    // Routing Logic
    'conditionalScript',
    'entityState',

    // Execution
    'asyncBefore'
  ],

  ServiceTask: [
    // Basic Info
    'name',
    'description',

    // Service Configuration
    'serviceType', // This should either be 'Command Execution', 'Rest Call', or 'AI Model'

    // Command Execution fields (disabled when serviceType = 'Rest Call')
    'ConnectorKey', // Command name - disabled if serviceType is 'Rest Call'

    // Rest Call fields (disabled when serviceType = 'Command Execution')
    'endpoint', // HTTP endpoint - disabled if serviceType is 'Command Execution'
    'httpMethod', // HTTP method - disabled if serviceType is 'Command Execution'
    'payloadMapping', // Request body mapping - disabled if serviceType is 'Command Execution'
    'headersMapping', // HTTP headers - disabled if serviceType is 'Command Execution'

    // AI Model fields (only shown when serviceType = 'AI Model')
    'aiCapability',           // Dropdown populated by GetAIModelCapabilitiesQuery
    'aiConfigKey',            // Auto-populated from capability's defaultConfigKey, editable
    'aiInputMapping',         // JSON textarea for input mapping
    'aiConfidenceThreshold',  // Optional - minimum confidence score
    'aiFallbackStrategy',     // Optional - what to do when AI fails
    'aiDefaultValue',         // Optional - fallback JSON value
    'aiTimeoutMs',            // Optional - timeout in ms

    // Response & Output
    'outMappings', // Output variable mappings

    // Reliability & Error Handling
    'timeoutMs',
    'retries',
    'retryBackoff',

    // Execution
    'resultVariable',         // Where to store the result (AI or service)
    'asyncBefore'
  ],
  ScriptTask: [
    // Basic Info
    'name',
    'description',

    // Script Configuration
    'scriptLanguage',
    'script',

    // Output
    'outMappings',
    'retries',
    'retryBackoff',
    'resultVariable',

    // Execution
    'asyncBefore'
  ],
  SendTask: [
    // Basic Info
    'name',
    'description',

    // Channel Configuration
    'channel', // email, sms, slack, push, etc.
    'providerKey', // Key for secure store provider configuration (JSON)

    // Message Content (choose one approach)
    'templateId', // Use template ID OR messageContent, not both
    'messageContent', // Direct message content - only for email/sms channels

    // Recipient & Data
    'recipientExpr', // Where to send the message
    'payloadMapping', // Data payload to include in the message

    // Reliability & Error Handling
    'timeoutMs',
    'retries',
    'retryBackoff',

    // Execution
    'resultVariable',
    'asyncBefore'
  ],
  ReceiveTask: [
    // Basic Info
    'name',
    'description',

    // Form & UI
    'form',

    // Scripts (execution order)
    'preScript', // Runs before task
    'clientScript', // Runs in client
    'serverScript', // Runs on server


    // Message Configuration
    'messageName',
    'subscriptionName',
    'correlationKey',
    'waitForSignal',

    // Execution
    'resultVariable',
    'outMappings',
    'timeoutMs',
    'asyncBefore'
  ],
  BusinessRuleTask: [
    // Basic Info
    'name',
    'description',

    // Decision Configuration
    'decisionRef',
    'decisionBinding',
    'decisionVersion',
    'ruleSet',

    // Input/Output
    'inputMapping',
    'resultVariable',

    // Execution
    'asyncBefore'
  ],
  CallActivity: [
    // Basic Info
    'name',
    'description',

    // Subprocess Configuration
    'calledElement',
    'propagateAllVariables',

    // Variable Mappings
    'inMappings',
    'outMappings',

    // results
    'resultVariable',
    'isMultiInstance',
    'collection',
    'elementVariable',

    // Execution
    'asyncBefore'
  ],
  SubProcess: [
    // Basic Info
    'name',
    'description',

    // Multi-Instance Configuration
    'isMultiInstance', // Enable multi-instance execution
    'collectionVariable', // Variable name containing the collection (e.g., 'loans', NOT '${context.loans}')
    'elementVariable', // Variable name for current iteration element (e.g., 'currentLoan')
    'resultVariable', // Variable name to store results array
    'multiInstanceMode', // 'parallel' or 'sequential'

    // Completion Condition (optional)
    'completionCondition', // Expression to stop iteration early

    // Execution
    'asyncBefore'
  ],
  StartEvent: [
    // Basic Info
    'name',
    'description',

    // Signal Configuration
    'signalId'
  ],
  Task: ['name', 'description', 'entityState', 'asyncBefore']
};

// Define REQUIRED properties for each task type (minimum needed for task to be valid)
export  const REQUIRED_PROPERTIES = {
  UserTask: ['name', 'form',],
  ServiceTask: ['name', 'serviceType', 'commandName'], // commandName required for Command Execution
  ScriptTask: ['name', 'script'],
  SendTask: ['name', 'channel', 'recipientExpr'],
  BusinessRuleTask: ['name', 'decisionRef'],
  ExclusiveGateway: ['name', 'conditionalScript'],
  InclusiveGateway: ['name'],
  ParallelGateway: ['name'],
  CallActivity: ['name', 'calledElement'],
  SubProcess: ['name'], // SubProcess only requires name; multi-instance is optional
  Task: ['name']
};








  /**
   * 🧪 MOCK DATA - Replica of Backend Response Format
   * This is what GetRequestFormById should return
   */
  export const MOCK_FORMS = {
    "FORM-TEST-001": {
      // ✅ This structure matches what backend should return
      formId: "FORM-TEST-001",
      formName: "Loan Approval Form",

      // Process/Task Info
      processInfo: {
        correlationId: "CORR-12345",
        processInstanceId: "proc-001",
        taskId: "task-001",
        processName: "Loan Approval Workflow",
        taskName: "Manager Approval",
        initiator: "John Doe",
        startTime: new Date().toISOString(),
        status: "Pending",
      },

      // Form Definition (from FormBuilder)
      formJson: {
        formular: [
          {
            id: "loan-amount",
            type: "input",
            name: "loanAmount",
            config: { label: "Loan Amount", required: true, placeholder: "Enter amount" },
            display: { span: 12 }
          },
          {
            id: "applicant-name",
            type: "input",
            name: "applicantName",
            config: { label: "Applicant Name", required: true, placeholder: "Enter name" },
            display: { span: 12 }
          },
          {
            id: "loan-type",
            type: "select",
            name: "loanType",
            config: {
              label: "Loan Type",
              required: true,
              placeholder: "Select loan type",
              options: [
                { label: "Personal Loan", value: "personal" },
                { label: "Business Loan", value: "business" },
                { label: "Mortgage", value: "mortgage" },
                { label: "Auto Loan", value: "auto" }
              ]
            },
            display: { span: 12 }
          },
          {
            id: "interest-rate",
            type: "input-number",
            name: "interestRate",
            config: { label: "Interest Rate (%)", placeholder: "Rate", required: false },
            display: { span: 6 }
          },
          {
            id: "monthly-payment",
            type: "input-number",
            name: "monthlyPayment",
            config: { label: "Monthly Payment", placeholder: "Payment", required: false },
            display: { span: 6 }
          },
          {
            id: "credit-score",
            type: "input-number",
            name: "creditScore",
            config: { label: "Credit Score", disabled: true, required: false },
            display: { span: 12 }
          },
          {
            id: "comment",
            type: "textarea",
            name: "comments",
            config: { label: "Comments (Optional)", placeholder: "Enter your comments here", rows: 4, required: false },
            display: { span: 24 }
          },
          {
            id: "divider-actions",
            type: "divider",
            config: { label: "📋 Submit Your Decision", orientation: "center" },
            display: { span: 24 }
          },
          {
            id: "text-helper",
            type: "text",
            config: {
              text: "Click a button below (handled by client script)",
              style: { textAlign: "center", color: "#666", fontSize: 14, marginBottom: 24 }
            },
            display: { span: 24 }
          },
          {
            id: "button-container",
            type: "empty",
            display: { span: 24 }
          },
          {
            id: "spacer-left",
            type: "empty",
            display: { span: 7 }
          },
          {
            id: "btn-reject",
            type: "button",
            config: {
              text: "Reject",
              type: "default",
              size: "large",
              danger: true,
              icon: "CloseCircleOutlined",
              dataAction: "reject",
              style: { minWidth: 160, height: 48, fontSize: 16, borderRadius: 8 }
            },
            display: { span: 4 }
          },
          {
            id: "spacer-middle",
            type: "empty",
            display: { span: 2 }
          },
          {
            id: "btn-approve",
            type: "button",
            config: {
              text: "Approve",
              type: "primary",
              size: "large",
              icon: "CheckCircleOutlined",
              dataAction: "approve",
              style: { minWidth: 160, height: 48, fontSize: 16, borderRadius: 8 }
            },
            display: { span: 4 }
          },
          {
            id: "spacer-right",
            type: "empty",
            display: { span: 7 }
          }
        ]
      },

      // Client Script (from ProcessTab)
      clientScript: `
        // Populate form from context
        form.setFieldsValue({
          loanAmount: context.processVariables.loanAmount,
          applicantName: context.processVariables.applicantName,
          loanType: context.processVariables.loanType,
          creditScore: context.entityData.creditScore
        });

        // Calculate interest rate based on credit score
        const creditScore = context.entityData.creditScore;
        const initialRate = creditScore > 700 ? 6.0 : 8.0;
        form.setFieldValue('interestRate', initialRate);

        // Calculate monthly payment
        const amount = context.processVariables.loanAmount;
        const monthly = (amount * (1 + initialRate / 100)) / 12;
        form.setFieldValue('monthlyPayment', monthly.toFixed(2));

        console.log('✅ Loan details loaded successfully');

        // Handle loan amount changes
        addEventListenerTo('[name="loanAmount"]', 'input', (e) => {
          const amount = parseFloat(e.target.value) || 0;
          const rate = form.getFieldValue('interestRate') || 6.0;
          const monthly = (amount * (1 + rate / 100)) / 12;
          form.setFieldValue('monthlyPayment', monthly.toFixed(2));
        });

        // Handle approve button
        addEventListenerTo('[data-action="approve"]', 'click', async (e) => {
          e.preventDefault();
          
          try {
            await form.validateFields();
          } catch (err) {
            A.message.error('Please complete all required fields');
            return;
          }
          
          const formData = form.getFieldsValue();
          
          if (parseFloat(formData.loanAmount) > context.userPermissions.maxApprovalAmount) {
            A.message.error('Amount exceeds your approval limit of $' + context.userPermissions.maxApprovalAmount);
            return;
          }
          
          A.Modal.confirm({
            title: 'Confirm Approval',
            icon: null,
            content: 'Approve loan of $' + formData.loanAmount + ' for ' + formData.applicantName + '?',
            okText: 'Approve',
            okType: 'primary',
            okButtonProps: {
              style: { backgroundColor: '#059669', borderColor: '#059669', height: 40 }
            },
            cancelButtonProps: {
              style: { height: 40 }
            },
            onOk: async () => {
              const hide = A.message.loading('Processing approval...', 0);
              
              try {
                // Call ReturnCallbackCommand with form results
                const response = await executeCommand('ReturnCallbackCommand', {
                  correlationKey: context.correlationId,
                  results: {
                    approved: true,
                    decidedBy: context.currentUser || 'manager@bank.com',
                    decidedAt: new Date().toISOString(),
                    formData: formData,
                    action: 'approve'
                  },
                  isFailed: false
                });
                
                hide();
                
                if (response?.outData?.isSuccessful) {
                  A.message.success('Loan approved successfully!');
                  console.log('✅ Approval response:', response.outData);
                  setTimeout(() => window.location.href = '/dashboard', 1500);
                } else {
                  A.message.error('Approval failed: ' + (response?.outData?.message || 'Unknown error'));
                }
              } catch (error) {
                hide();
                console.error('❌ Approval error:', error);
                A.message.error('Failed to approve: ' + error.message);
              }
            }
          });
        });

        // Handle reject button
        addEventListenerTo('[data-action="reject"]', 'click', async (e) => {
          e.preventDefault();
          
          const formData = form.getFieldsValue();
          
          A.Modal.confirm({
            title: 'Confirm Rejection',
            icon: null,
            content: 'Reject loan for ' + formData.applicantName + '?',
            okText: 'Reject',
            okType: 'danger',
            okButtonProps: {
              style: { height: 40 }
            },
            cancelButtonProps: {
              style: { height: 40 }
            },
            onOk: async () => {
              const hide = A.message.loading('Processing rejection...', 0);
              
              try {
                // Call ReturnCallbackCommand with form results
                const response = await executeCommand('ReturnCallbackCommand', {
                  correlationKey: context.correlationId,
                  results: {
                    approved: false,
                    decidedBy: context.currentUser || 'manager@bank.com',
                    decidedAt: new Date().toISOString(),
                    formData: formData,
                    action: 'reject'
                  },
                  isFailed: false
                });
                
                hide();
                
                if (response?.outData?.isSuccessful) {
                  A.message.success('Loan rejected');
                  console.log('✅ Rejection response:', response.outData);
                  setTimeout(() => window.location.href = '/dashboard', 1500);
                } else {
                  A.message.error('Rejection failed: ' + (response?.outData?.message || 'Unknown error'));
                }
              } catch (error) {
                hide();
                console.error('❌ Rejection error:', error);
                A.message.error('Failed to reject: ' + error.message);
              }
            }
          });
        });
      `,

      // Process Info
      processInfo: {
        processName: "Loan Approval Workflow",
        taskName: "Manager Approval",
        initiator: "John Doe",
        status: "Pending"
      },

      // Context (Backend Data)
      context: {
        correlationId: "CORR-12345",
        taskId: "task-001",
        processVariables: {
          loanAmount: 50000,
          applicantName: "John Doe",
          loanType: "Personal"
        },
        entityData: {
          accountNumber: "ACC-123",
          creditScore: 720
        },
        userPermissions: {
          canApprove: true,
          canReject: true,
          maxApprovalAmount: 100000
        }
      }
    },
    "FORM-TEST-002": {
      formId: "FORM-TEST-002",
      formName: "Transfer Authorization Form",

      processInfo: {
        correlationId: "CORR-67890",
        processInstanceId: "proc-002",
        taskId: "task-002",
        processName: "Transfer Authorization",
        taskName: "Senior Manager Review",
        initiator: "Jane Smith",
        startTime: new Date().toISOString(),
        status: "Pending",
      },

      // Form Definition (from FormBuilder) - Transfer Form
      formJson: {
        formular: [
          {
            id: "from-account",
            type: "input",
            name: "fromAccount",
            config: { label: "From Account", disabled: true },
            display: { span: 12 }
          },
          {
            id: "to-account",
            type: "input",
            name: "toAccount",
            config: { label: "To Account", disabled: true },
            display: { span: 12 }
          },
          {
            id: "transfer-amount",
            type: "input-number",
            name: "transferAmount",
            config: { label: "Transfer Amount", disabled: true },
            display: { span: 12 }
          },
          {
            id: "beneficiary-name",
            type: "input",
            name: "beneficiaryName",
            config: { label: "Beneficiary Name", disabled: true },
            display: { span: 12 }
          },
          {
            id: "review-notes",
            type: "textarea",
            name: "reviewNotes",
            config: { label: "Review Notes", required: true, placeholder: "Enter review notes", rows: 4 },
            display: { span: 24 }
          },
          {
            id: "divider-actions",
            type: "divider",
            config: { label: "📋 Submit Your Decision", orientation: "center" },
            display: { span: 24 }
          },
          {
            id: "text-helper",
            type: "text",
            config: {
              text: "Click a button below (handled by client script)",
              style: { textAlign: "center", color: "#666", fontSize: 14, marginBottom: 24 }
            },
            display: { span: 24 }
          },
          {
            id: "button-container",
            type: "empty",
            display: { span: 24 }
          },
          {
            id: "spacer-left",
            type: "empty",
            display: { span: 7 }
          },
          {
            id: "btn-decline",
            type: "button",
            config: {
              text: "Decline",
              type: "default",
              size: "large",
              danger: true,
              icon: "CloseCircleOutlined",
              dataAction: "reject",
              style: { minWidth: 160, height: 48, fontSize: 16, borderRadius: 8 }
            },
            display: { span: 5 }
          },
          {
            id: "btn-authorize",
            type: "button",
            config: {
              text: "Authorize",
              type: "primary",
              size: "large",
              icon: "CheckCircleOutlined",
              dataAction: "approve",
              style: { minWidth: 160, height: 48, fontSize: 16, borderRadius: 8 }
            },
            display: { span: 5 }
          },
          {
            id: "spacer-right",
            type: "empty",
            display: { span: 7 }
          }
        ]
      },

      // Client Script (from ProcessTab)
      clientScript: `
        // Populate transfer details from context
        form.setFieldsValue({
          fromAccount: context.processVariables.fromAccount,
          toAccount: context.processVariables.toAccount,
          transferAmount: context.processVariables.amount,
          beneficiaryName: context.processVariables.beneficiaryName
        });

        console.log('✅ Transfer details loaded successfully');

        // Handle authorize button
        addEventListenerTo('[data-action="approve"]', 'click', async (e) => {
          e.preventDefault();
          
          try {
            await form.validateFields();
          } catch (err) {
            A.message.error('Review notes are required');
            return;
          }
          
          const formData = form.getFieldsValue();
          const amount = context.processVariables.amount;
          
          if (amount > context.userPermissions.maxAuthAmount) {
            A.message.error('Transfer amount exceeds your authorization limit of $' + context.userPermissions.maxAuthAmount);
            return;
          }
          
          A.Modal.confirm({
            title: 'Authorize Transfer',
            icon: null,
            content: 'Authorize transfer of $' + amount + ' from ' + formData.fromAccount + ' to ' + formData.beneficiaryName + '?',
            okText: 'Authorize',
            okType: 'primary',
            okButtonProps: {
              style: { backgroundColor: '#059669', borderColor: '#059669', height: 40 }
            },
            cancelButtonProps: {
              style: { height: 40 }
            },
            onOk: async () => {
              const hide = A.message.loading('Processing authorization...', 0);
              
              try {
                // Call ReturnCallbackCommand with form results
                const response = await executeCommand('ReturnCallbackCommand', {
                  correlationKey: context.correlationId,
                  results: {
                    approved: true,
                    decidedBy: context.currentUser || 'senior.manager@bank.com',
                    decidedAt: new Date().toISOString(),
                    formData: formData,
                    action: 'approve'
                  },
                  isFailed: false
                });
                
                hide();
                
                if (response?.outData?.isSuccessful) {
                  A.message.success('Transfer authorized successfully!');
                  console.log('✅ Authorization response:', response.outData);
                  setTimeout(() => window.location.href = '/dashboard', 1500);
                } else {
                  A.message.error('Authorization failed: ' + (response?.outData?.message || 'Unknown error'));
                }
              } catch (error) {
                hide();
                console.error('❌ Authorization error:', error);
                A.message.error('Failed to authorize: ' + error.message);
              }
            }
          });
        });

        // Handle decline button
        addEventListenerTo('[data-action="reject"]', 'click', async (e) => {
          e.preventDefault();
          
          const formData = form.getFieldsValue();
          
          if (!formData.reviewNotes) {
            A.message.error('Review notes required for declining');
            return;
          }
          
          A.Modal.confirm({
            title: 'Decline Transfer',
            icon: null,
            content: 'Decline transfer for ' + formData.beneficiaryName + '?',
            okText: 'Decline',
            okType: 'danger',
            okButtonProps: {
              style: { height: 40 }
            },
            cancelButtonProps: {
              style: { height: 40 }
            },
            onOk: async () => {
              const hide = A.message.loading('Processing decline...', 0);
              
              try {
                // Call ReturnCallbackCommand with form results
                const response = await executeCommand('ReturnCallbackCommand', {
                  correlationKey: context.correlationId,
                  results: {
                    approved: false,
                    decidedBy: context.currentUser || 'senior.manager@bank.com',
                    decidedAt: new Date().toISOString(),
                    formData: formData,
                    action: 'reject'
                  },
                  isFailed: false
                });
                
                hide();
                
                if (response?.outData?.isSuccessful) {
                  A.message.success('Transfer declined');
                  console.log('✅ Decline response:', response.outData);
                  setTimeout(() => window.location.href = '/dashboard', 1500);
                } else {
                  A.message.error('Decline failed: ' + (response?.outData?.message || 'Unknown error'));
                }
              } catch (error) {
                hide();
                console.error('❌ Decline error:', error);
                A.message.error('Failed to decline: ' + error.message);
              }
            }
          });
        });
      `,

      // Process Info
      processInfo: {
        processName: "Transfer Authorization Workflow",
        taskName: "Senior Manager Authorization",
        initiator: "System Auto-Trigger",
        status: "Pending"
      },

      // Context (Backend Data)
      context: {
        correlationId: "CORR-67890",
        taskId: "task-002",
        processVariables: {
          fromAccount: "ACC-456",
          toAccount: "ACC-789",
          amount: 75000,
          beneficiaryName: "Jane Smith",
          transferType: "International"
        },
        entityData: {
          senderAccountBalance: 150000,
          beneficiaryVerified: true
        },
        userPermissions: {
          canApprove: true,
          canReject: true,
          maxAuthAmount: 100000
        }
      }
    },

    // ========================================
    // 📋 FORM-TEST-003: Review Screen
    // ========================================
    "FORM-TEST-003": {
      formId: "FORM-TEST-003",
      processName: "Purchase Order Review",
      formName: "Review Purchase Order",
      taskName: "Finance Review",
      initiatedBy: "Emily Chen",

      // Form JSON (from FormBuilder)
      formJson: {
        formControls: [
          // Section: Purchase Details (Read-only)
          {
            id: "divider-details",
            type: "divider",
            config: { label: "📦 Purchase Order Details", orientation: "left" },
            display: { span: 24 }
          },
          {
            id: "po-number",
            type: "label",
            config: { label: "PO Number", value: "PO-2026-001" },
            display: { span: 8 }
          },
          {
            id: "vendor-name",
            type: "label",
            config: { label: "Vendor Name", value: "Tech Supplies Inc." },
            display: { span: 8 }
          },
          {
            id: "order-date",
            type: "label",
            config: { label: "Order Date", value: "2026-01-10" },
            display: { span: 8 }
          },
          {
            id: "item-description",
            type: "label",
            config: { label: "Item Description", value: "Office equipment: 5x Laptops (Dell XPS 15), 3x Monitors (27-inch), 2x Printers (HP LaserJet)" },
            display: { span: 24 }
          },
          {
            id: "order-amount",
            type: "label",
            config: { label: "Total Amount", value: "$12,500.00" },
            display: { span: 8 }
          },
          {
            id: "department",
            type: "label",
            config: { label: "Department", value: "IT Department" },
            display: { span: 8 }
          },
          {
            id: "requested-by",
            type: "label",
            config: { label: "Requested By", value: "Emily Chen" },
            display: { span: 8 }
          },

          // Section: Budget Information (Read-only)
          {
            id: "divider-budget",
            type: "divider",
            config: { label: "💰 Budget Information", orientation: "left" },
            display: { span: 24 }
          },
          {
            id: "budget-allocated",
            type: "label",
            config: { label: "Budget Allocated", value: "$50,000.00" },
            display: { span: 8 }
          },
          {
            id: "budget-remaining",
            type: "label",
            config: { label: "Budget Remaining", value: "$18,000.00" },
            display: { span: 8 }
          },
          {
            id: "budget-status",
            type: "label",
            config: { label: "Budget Status", value: "Within Budget" },
            display: { span: 8 }
          },

          // Section: Review Comments (Editable)
          {
            id: "divider-review",
            type: "divider",
            config: { label: "📝 Your Review", orientation: "left" },
            display: { span: 24 }
          },
          {
            id: "review-comments",
            type: "textarea",
            name: "reviewComments",
            config: {
              label: "Review Comments",
              required: true,
              placeholder: "Enter your review comments here...",
              rows: 5
            },
            display: { span: 24 }
          },

          // Section: Action Buttons
          {
            id: "divider-actions",
            type: "divider",
            config: { label: "📋 Submit Your Decision", orientation: "center" },
            display: { span: 24 }
          },
          {
            id: "text-helper",
            type: "text",
            config: {
              text: "Click a button below (handled by client script)",
              style: { textAlign: "center", color: "#666", fontSize: 14, marginBottom: 24 }
            },
            display: { span: 24 }
          },
          {
            id: "button-container",
            type: "empty",
            display: { span: 24 }
          },
          {
            id: "spacer-left",
            type: "empty",
            display: { span: 7 }
          },
          {
            id: "btn-reject",
            type: "button",
            config: {
              text: "Reject",
              type: "default",
              size: "large",
              danger: true,
              icon: "CloseCircleOutlined",
              dataAction: "reject",
              style: { minWidth: 160, height: 48, fontSize: 16, borderRadius: 8 }
            },
            display: { span: 4 }
          },
          {
            id: "spacer-middle",
            type: "empty",
            display: { span: 2 }
          },
          {
            id: "btn-approve",
            type: "button",
            config: {
              text: "Approve",
              type: "primary",
              size: "large",
              icon: "CheckCircleOutlined",
              dataAction: "approve",
              style: { minWidth: 160, height: 48, fontSize: 16, borderRadius: 8 }
            },
            display: { span: 4 }
          },
          {
            id: "spacer-right",
            type: "empty",
            display: { span: 7 }
          }
        ]
      },

      // Client Script (from ProcessTab)
      clientScript: `
        // No need to populate - labels display static values
        console.log('✅ Review details loaded successfully');

        // Handle approve button
        addEventListenerTo('[data-action="approve"]', 'click', async (e) => {
          e.preventDefault();
          
          try {
            await form.validateFields();
          } catch (err) {
            A.message.error('Please enter review comments');
            return;
          }
          
          const formData = form.getFieldsValue();
          
          // Check budget constraints
          if (formData.orderAmount > formData.budgetRemaining) {
            A.Modal.confirm({
              title: '⚠️ Budget Exceeded',
              icon: null,
              content: 'This order exceeds remaining budget by $' + (formData.orderAmount - formData.budgetRemaining).toFixed(2) + '. Approve anyway?',
              okText: 'Approve',
              okType: 'primary',
              okButtonProps: {
                style: { backgroundColor: '#059669', borderColor: '#059669', height: 40 }
              },
              cancelButtonProps: {
                style: { height: 40 }
              },
              onOk: async () => {
                await processApproval(formData);
              }
            });
            return;
          }
          
          A.Modal.confirm({
            title: 'Confirm Approval',
            icon: null,
            content: 'Approve purchase order ' + formData.poNumber + ' for $' + formData.orderAmount + '?',
            okText: 'Approve',
            okType: 'primary',
            okButtonProps: {
              style: { backgroundColor: '#059669', borderColor: '#059669', height: 40 }
            },
            cancelButtonProps: {
              style: { height: 40 }
            },
            onOk: async () => {
              await processApproval(formData);
            }
          });
        });

        // Handle reject button
        addEventListenerTo('[data-action="reject"]', 'click', async (e) => {
          e.preventDefault();
          
          try {
            await form.validateFields();
          } catch (err) {
            A.message.error('Please enter review comments');
            return;
          }
          
          const formData = form.getFieldsValue();
          
          A.Modal.confirm({
            title: 'Confirm Rejection',
            icon: null,
            content: 'Reject purchase order ' + formData.poNumber + '?',
            okText: 'Reject',
            okType: 'danger',
            okButtonProps: {
              style: { height: 40 }
            },
            cancelButtonProps: {
              style: { height: 40 }
            },
            onOk: async () => {
              const hide = A.message.loading('Processing rejection...', 0);
              
              try {
                const response = await executeCommand('ReturnCallbackCommand', {
                  correlationKey: context.correlationId,
                  results: {
                    approved: false,
                    decidedBy: context.currentUser || 'finance.manager@company.com',
                    decidedAt: new Date().toISOString(),
                    formData: formData,
                    action: 'reject'
                  },
                  isFailed: false
                });
                
                hide();
                
                if (response?.outData?.isSuccessful) {
                  A.message.success('Purchase order rejected');
                  console.log('✅ Rejection response:', response.outData);
                  setTimeout(() => window.location.href = '/dashboard', 1500);
                } else {
                  A.message.error('Rejection failed: ' + (response?.outData?.message || 'Unknown error'));
                }
              } catch (error) {
                hide();
                console.error('❌ Rejection error:', error);
                A.message.error('Failed to reject: ' + error.message);
              }
            }
          });
        });

        // Helper function for approval processing
        async function processApproval(formData) {
          const hide = A.message.loading('Processing approval...', 0);
          
          try {
            const response = await executeCommand('ReturnCallbackCommand', {
              correlationKey: context.correlationId,
              results: {
                approved: true,
                decidedBy: context.currentUser || 'finance.manager@company.com',
                decidedAt: new Date().toISOString(),
                formData: formData,
                action: 'approve'
              },
              isFailed: false
            });
            
            hide();
            
            if (response?.outData?.isSuccessful) {
              A.message.success('Purchase order approved successfully!');
              console.log('✅ Approval response:', response.outData);
              setTimeout(() => window.location.href = '/dashboard', 1500);
            } else {
              A.message.error('Approval failed: ' + (response?.outData?.message || 'Unknown error'));
            }
          } catch (error) {
            hide();
            console.error('❌ Approval error:', error);
            A.message.error('Failed to approve: ' + error.message);
          }
        }
      `,

      // Process Info
      processInfo: {
        processName: "Purchase Order Review",
        taskName: "Finance Review",
        initiator: "Emily Chen",
        status: "Pending"
      },

      // Context (Backend Data)
      context: {
        correlationId: "CORR-67890",
        taskId: "task-003",
        processVariables: {
          poNumber: "PO-2026-001",
          vendorName: "Tech Supplies Inc.",
          orderDate: "2026-01-10",
          itemDescription: "Office equipment: 5x Laptops (Dell XPS 15), 3x Monitors (27-inch), 2x Printers (HP LaserJet)",
          orderAmount: 12500,
          department: "IT Department",
          requestedBy: "Emily Chen"
        },
        entityData: {
          budgetAllocated: 50000,
          budgetRemaining: 18000,
          budgetStatus: "Within Budget"
        },
        userPermissions: {
          canApprove: true,
          canReject: true,
          maxApprovalAmount: 50000
        }
      }
    },

    // ========================================
    // 📋 FORM-TEST-004: Table-Style Review Screen
    // ========================================
    "FORM-TEST-004": {
      formId: "FORM-TEST-004",
      processName: "Transaction Review Workflow",
      formName: "Transaction Review",
      taskName: "Compliance Review",
      initiatedBy: "System Auto-Trigger",

      // Form JSON (from FormBuilder)
      formJson: {
        formControls: [
          // Transaction Details in Table Format
          {
            id: "divider-transaction",
            type: "divider",
            config: { label: "Transaction Details", orientation: "left" },
            display: { span: 24 }
          },
          {
            id: "trans-status",
            type: "description-item",
            config: { label: "Transaction Status", value: "Hold" },
            display: { span: 24 }
          },
          {
            id: "trans-type",
            type: "description-item",
            config: { label: "Transaction Type", value: "Withdrawals" },
            display: { span: 24 }
          },
          {
            id: "trans-id",
            type: "description-item",
            config: { label: "Transaction ID", value: "2312250000000001885" },
            display: { span: 24 }
          },
          {
            id: "date-initiated",
            type: "description-item",
            config: { label: "Date Initiated", value: "23-12-2025 08:18" },
            display: { span: 24 }
          },
          {
            id: "user-branch",
            type: "description-item",
            config: { label: "User Branch", value: "" },
            display: { span: 24 }
          },
          {
            id: "remarks",
            type: "description-item",
            config: { label: "Remarks", value: "a test" },
            display: { span: 24 }
          },

          // Review Comments Section
          {
            id: "divider-review",
            type: "divider",
            config: { label: "Your Review", orientation: "left" },
            display: { span: 24 }
          },
          {
            id: "review-comments",
            type: "textarea",
            name: "reviewComments",
            config: {
              label: "Review Comments",
              required: true,
              placeholder: "Enter your review comments here...",
              rows: 4
            },
            display: { span: 24 }
          },

          // Action Buttons
          {
            id: "divider-actions",
            type: "divider",
            config: { label: "📋 Submit Your Decision", orientation: "center" },
            display: { span: 24 }
          },
          {
            id: "text-helper",
            type: "text",
            config: {
              text: "Click a button below (handled by client script)",
              style: { textAlign: "center", color: "#666", fontSize: 14, marginBottom: 24 }
            },
            display: { span: 24 }
          },
          {
            id: "button-container",
            type: "empty",
            display: { span: 24 }
          },
          {
            id: "spacer-left",
            type: "empty",
            display: { span: 7 }
          },
          {
            id: "btn-reject",
            type: "button",
            config: {
              text: "Reject",
              type: "default",
              size: "large",
              danger: true,
              icon: "CloseCircleOutlined",
              dataAction: "reject",
              style: { minWidth: 160, height: 48, fontSize: 16, borderRadius: 8 }
            },
            display: { span: 4 }
          },
          {
            id: "spacer-middle",
            type: "empty",
            display: { span: 2 }
          },
          {
            id: "btn-approve",
            type: "button",
            config: {
              text: "Approve",
              type: "primary",
              size: "large",
              icon: "CheckCircleOutlined",
              dataAction: "approve",
              style: { minWidth: 160, height: 48, fontSize: 16, borderRadius: 8 }
            },
            display: { span: 4 }
          },
          {
            id: "spacer-right",
            type: "empty",
            display: { span: 7 }
          }
        ]
      },

      // Client Script (from ProcessTab)
      clientScript: `
        console.log('✅ Transaction details loaded successfully');

        // Handle approve button
        addEventListenerTo('[data-action="approve"]', 'click', async (e) => {
          e.preventDefault();
          
          try {
            await form.validateFields();
          } catch (err) {
            A.message.error('Please enter review comments');
            return;
          }
          
          const formData = form.getFieldsValue();
          
          A.Modal.confirm({
            title: 'Approve Transaction',
            icon: null,
            content: 'Approve transaction ID: 2312250000000001885?',
            okText: 'Approve',
            okType: 'primary',
            okButtonProps: {
              style: { backgroundColor: '#059669', borderColor: '#059669', height: 40 }
            },
            cancelButtonProps: {
              style: { height: 40 }
            },
            onOk: async () => {
              const hide = A.message.loading('Processing approval...', 0);
              
              try {
                const response = await executeCommand('ReturnCallbackCommand', {
                  correlationKey: context.correlationId,
                  results: {
                    approved: true,
                    decidedBy: context.currentUser || 'compliance@bank.com',
                    decidedAt: new Date().toISOString(),
                    formData: formData,
                    action: 'approve'
                  },
                  isFailed: false
                });
                
                hide();
                
                if (response?.outData?.isSuccessful) {
                  A.message.success('Transaction approved successfully!');
                  console.log('✅ Approval response:', response.outData);
                  setTimeout(() => window.location.href = '/dashboard', 1500);
                } else {
                  A.message.error('Approval failed: ' + (response?.outData?.message || 'Unknown error'));
                }
              } catch (error) {
                hide();
                console.error('❌ Approval error:', error);
                A.message.error('Failed to approve: ' + error.message);
              }
            }
          });
        });

        // Handle reject button
        addEventListenerTo('[data-action="reject"]', 'click', async (e) => {
          e.preventDefault();
          
          try {
            await form.validateFields();
          } catch (err) {
            A.message.error('Please enter review comments');
            return;
          }
          
          const formData = form.getFieldsValue();
          
          A.Modal.confirm({
            title: 'Reject Transaction',
            icon: null,
            content: 'Reject transaction ID: 2312250000000001885?',
            okText: 'Reject',
            okType: 'danger',
            okButtonProps: {
              style: { height: 40 }
            },
            cancelButtonProps: {
              style: { height: 40 }
            },
            onOk: async () => {
              const hide = A.message.loading('Processing rejection...', 0);
              
              try {
                const response = await executeCommand('ReturnCallbackCommand', {
                  correlationKey: context.correlationId,
                  results: {
                    approved: false,
                    decidedBy: context.currentUser || 'compliance@bank.com',
                    decidedAt: new Date().toISOString(),
                    formData: formData,
                    action: 'reject'
                  },
                  isFailed: false
                });
                
                hide();
                
                if (response?.outData?.isSuccessful) {
                  A.message.success('Transaction rejected');
                  console.log('✅ Rejection response:', response.outData);
                  setTimeout(() => window.location.href = '/dashboard', 1500);
                } else {
                  A.message.error('Rejection failed: ' + (response?.outData?.message || 'Unknown error'));
                }
              } catch (error) {
                hide();
                console.error('❌ Rejection error:', error);
                A.message.error('Failed to reject: ' + error.message);
              }
            }
          });
        });
      `,

      // Process Info
      processInfo: {
        processName: "Transaction Review Workflow",
        taskName: "Compliance Review",
        initiator: "System Auto-Trigger",
        status: "Pending"
      },

      // Context (Backend Data)
      context: {
        correlationId: "CORR-99999",
        taskId: "task-004",
        processVariables: {
          transactionId: "2312250000000001885",
          transactionType: "Withdrawals",
          transactionStatus: "Hold",
          dateInitiated: "23-12-2025 08:18",
          userBranch: "",
          remarks: "a test"
        },
        entityData: {
          accountNumber: "ACC-789",
          customerName: "John Smith",
          amount: 5000
        },
        userPermissions: {
          canApprove: true,
          canReject: true,
          maxApprovalAmount: 100000
        }
      }
    },

    // ========================================
    // 📋 FORM-TEST-005: Deposit Review (Modal-Style)
    // ========================================
    "FORM-TEST-005": {
      formId: "FORM-TEST-005",
      processName: "Deposit Approval Workflow",
      formName: "Review Deposit",
      taskName: "Compliance Review",
      initiatedBy: "Teller Desk",

      // Form JSON (from FormBuilder)
      formJson: {
        formControls: [
          // Deposit Details in Clean Table Format
          {
            id: "account-number",
            type: "description-item",
            config: { label: "Account Number", value: "0900852074" },
            display: { span: 24 }
          },
          {
            id: "account-name",
            type: "description-item",
            config: { label: "Account Name", value: "TUNDE ADENIYI" },
            display: { span: 24 }
          },
          {
            id: "product",
            type: "description-item",
            config: { label: "Product", value: "Test Product Config" },
            display: { span: 24 }
          },
          {
            id: "amount",
            type: "description-item",
            config: { label: "Amount", value: "2,000.00" },
            display: { span: 24 }
          },
          {
            id: "currency",
            type: "description-item",
            config: { label: "Currency", value: "NGN" },
            display: { span: 24 }
          },
          {
            id: "transaction-channel",
            type: "description-item",
            config: { label: "Transaction Channel (Source)", value: "Flutterwave" },
            display: { span: 24 }
          },
          {
            id: "backdate-transaction",
            type: "description-item",
            config: { label: "Do you want to backdate transaction?", value: "No" },
            display: { span: 24 }
          },
          {
            id: "set-booking-date",
            type: "description-item",
            config: { label: "Do you want to set booking date?", value: "No" },
            display: { span: 24 }
          },
          {
            id: "notes",
            type: "description-item",
            config: { label: "Notes", value: "" },
            display: { span: 24 }
          },

          // Comments Section
          {
            id: "divider-comments",
            type: "divider",
            config: { label: "Comments", orientation: "left" },
            display: { span: 24 }
          },
          {
            id: "review-comments",
            type: "textarea",
            name: "reviewComments",
            config: {
              label: "Review Comments",
              required: false,
              placeholder: "Enter your comments here (optional)...",
              rows: 3
            },
            display: { span: 24 }
          },

          // Confirmation Checkbox
          {
            id: "confirmation",
            type: "checkbox",
            name: "confirmAmount",
            config: {
              label: "I confirm that NGN 2,000.00 is the deposit amount for this account.",
              required: true
            },
            display: { span: 24 }
          },

          // Action Buttons
          {
            id: "divider-actions",
            type: "divider",
            config: { label: "📋 Submit Your Decision", orientation: "center" },
            display: { span: 24 }
          },
          {
            id: "text-helper",
            type: "text",
            config: {
              text: "Click a button below (handled by client script)",
              style: { textAlign: "center", color: "#666", fontSize: 14, marginBottom: 24 }
            },
            display: { span: 24 }
          },
          {
            id: "button-container",
            type: "empty",
            display: { span: 24 }
          },
          {
            id: "spacer-left",
            type: "empty",
            display: { span: 7 }
          },
          {
            id: "btn-reject",
            type: "button",
            config: {
              text: "Reject",
              type: "default",
              size: "large",
              danger: true,
              icon: "CloseCircleOutlined",
              dataAction: "reject",
              style: { minWidth: 160, height: 48, fontSize: 16, borderRadius: 8 }
            },
            display: { span: 4 }
          },
          {
            id: "spacer-middle",
            type: "empty",
            display: { span: 2 }
          },
          {
            id: "btn-approve",
            type: "button",
            config: {
              text: "Cash Deposit",
              type: "primary",
              size: "large",
              icon: "CheckCircleOutlined",
              dataAction: "approve",
              style: { minWidth: 160, height: 48, fontSize: 16, borderRadius: 8 }
            },
            display: { span: 4 }
          },
          {
            id: "spacer-right",
            type: "empty",
            display: { span: 7 }
          }
        ]
      },

      // Client Script (from ProcessTab)
      clientScript: `
        console.log('✅ Deposit details loaded successfully');

        // Handle approve button (Cash Deposit)
        addEventListenerTo('[data-action="approve"]', 'click', async (e) => {
          e.preventDefault();
          
          try {
            await form.validateFields();
          } catch (err) {
            A.message.error('Please confirm the deposit amount');
            return;
          }
          
          const formData = form.getFieldsValue();
          
          if (!formData.confirmAmount) {
            A.message.error('Please confirm the deposit amount');
            return;
          }
          
          A.Modal.confirm({
            title: 'Confirm Deposit',
            icon: null,
            content: 'Process cash deposit of NGN 2,000.00 for account 0900852074?',
            okText: 'Cash Deposit',
            okType: 'primary',
            okButtonProps: {
              style: { backgroundColor: '#059669', borderColor: '#059669', height: 40 }
            },
            cancelButtonProps: {
              style: { height: 40 }
            },
            onOk: async () => {
              const hide = A.message.loading('Processing deposit...', 0);
              
              try {
                const response = await executeCommand('ReturnCallbackCommand', {
                  correlationKey: context.correlationId,
                  results: {
                    approved: true,
                    decidedBy: context.currentUser || 'teller@bank.com',
                    decidedAt: new Date().toISOString(),
                    formData: {
                      accountNumber: '0900852074',
                      accountName: 'TUNDE ADENIYI',
                      amount: 2000.00,
                      currency: 'NGN',
                      channel: 'Flutterwave',
                      confirmed: true
                    },
                    action: 'approve'
                  },
                  isFailed: false
                });
                
                hide();
                
                if (response?.outData?.isSuccessful) {
                  A.message.success('Deposit processed successfully!');
                  console.log('✅ Deposit response:', response.outData);
                  setTimeout(() => window.location.href = '/dashboard', 1500);
                } else {
                  A.message.error('Deposit failed: ' + (response?.outData?.message || 'Unknown error'));
                }
              } catch (error) {
                hide();
                console.error('❌ Deposit error:', error);
                A.message.error('Failed to process deposit: ' + error.message);
              }
            }
          });
        });

        // Handle reject button
        addEventListenerTo('[data-action="reject"]', 'click', async (e) => {
          e.preventDefault();
          
          A.Modal.confirm({
            title: 'Reject Deposit',
            icon: null,
            content: 'Reject deposit for account 0900852074?',
            okText: 'Reject',
            okType: 'danger',
            okButtonProps: {
              style: { height: 40 }
            },
            cancelButtonProps: {
              style: { height: 40 }
            },
            onOk: async () => {
              const hide = A.message.loading('Processing rejection...', 0);
              
              try {
                const response = await executeCommand('ReturnCallbackCommand', {
                  correlationKey: context.correlationId,
                  results: {
                    approved: false,
                    decidedBy: context.currentUser || 'teller@bank.com',
                    decidedAt: new Date().toISOString(),
                    formData: {},
                    action: 'reject'
                  },
                  isFailed: false
                });
                
                hide();
                
                if (response?.outData?.isSuccessful) {
                  A.message.success('Deposit rejected');
                  console.log('✅ Rejection response:', response.outData);
                  setTimeout(() => window.location.href = '/dashboard', 1500);
                } else {
                  A.message.error('Rejection failed: ' + (response?.outData?.message || 'Unknown error'));
                }
              } catch (error) {
                hide();
                console.error('❌ Rejection error:', error);
                A.message.error('Failed to reject: ' + error.message);
              }
            }
          });
        });
      `,

      // Process Info
      processInfo: {
        processName: "Deposit Approval Workflow",
        taskName: "Compliance Review",
        initiator: "Teller Desk",
        status: "Pending"
      },

      // Context (Backend Data)
      context: {
        correlationId: "CORR-88888",
        taskId: "task-005",
        processVariables: {
          accountNumber: "0900852074",
          accountName: "TUNDE ADENIYI",
          product: "Test Product Config",
          amount: 2000.00,
          currency: "NGN",
          transactionChannel: "Flutterwave",
          backdateTransaction: false,
          setBookingDate: false,
          notes: ""
        },
        entityData: {
          accountBalance: 15000,
          accountStatus: "Active"
        },
        userPermissions: {
          canApprove: true,
          canReject: true,
          maxDepositAmount: 1000000
        }
      }
    },

    // ========================================
    // 📋 FORM-TEST-006: Link Review Screen
    // ========================================
    "FORM-TEST-006": {
      formId: "FORM-TEST-006",
      processName: "Document Review Workflow",
      formName: "Review Loan Application",
      taskName: "Document Verification",
      initiatedBy: "Michael Johnson",

      // Form JSON (from FormBuilder)
      formJson: {
        formControls: [
          // Application Details
          {
            id: "divider-application",
            type: "divider",
            config: { label: "Application Details", orientation: "left" },
            display: { span: 24 }
          },
          {
            id: "applicant-name",
            type: "description-item",
            config: { label: "Applicant Name", value: "Michael Johnson" },
            display: { span: 24 }
          },
          {
            id: "loan-type",
            type: "description-item",
            config: { label: "Loan Type", value: "Personal Loan" },
            display: { span: 24 }
          },
          {
            id: "loan-amount",
            type: "description-item",
            config: { label: "Requested Amount", value: "$25,000.00" },
            display: { span: 24 }
          },
          {
            id: "application-date",
            type: "description-item",
            config: { label: "Application Date", value: "15-01-2026" },
            display: { span: 24 }
          },

          // Document Links Section
          {
            id: "divider-documents",
            type: "divider",
            config: { label: "Documents & References", orientation: "left" },
            display: { span: 24 }
          },

          // 1. Document Download Link (URL will be set by script from context)
          {
            id: "link-application-form",
            type: "link",
            config: {
              label: "Loan Application Form",
              text: "Download PDF",
              url: "#",  // ✅ Placeholder - script will update from context
              linkType: "download",
              icon: "DownloadOutlined"
            },
            display: { span: 24 }
          },
          {
            id: "link-income-proof",
            type: "link",
            config: {
              label: "Income Proof",
              text: "Download Document",
              url: "#",  // ✅ Placeholder - script will update from context
              linkType: "download",
              icon: "DownloadOutlined"
            },
            display: { span: 24 }
          },
          {
            id: "link-identity-document",
            type: "link",
            config: {
              label: "Identity Document",
              text: "Download ID",
              url: "#",  // ✅ Placeholder - script will update from context
              linkType: "download",
              icon: "DownloadOutlined"
            },
            display: { span: 24 }
          },

          // 2. External Website Link (URL will be set by script from context)
          {
            id: "link-credit-bureau",
            type: "link",
            config: {
              label: "Credit Bureau Report",
              text: "View on CreditCheck.com",
              url: "#",  // ✅ Placeholder - script will update from context
              linkType: "external",
              icon: "LinkOutlined"
            },
            display: { span: 24 }
          },

          // 3. Internal App Links (URLs and text will be set by script from context)
          {
            id: "link-loan-details",
            type: "link",
            config: {
              label: "Existing Loan Account",
              text: "View Loan Details",  // ✅ Generic - script will update with actual ID
              url: "#",  // ✅ Placeholder - script will update from context
              linkType: "internal",
              icon: "EyeOutlined"
            },
            display: { span: 24 }
          },
          {
            id: "link-customer-profile",
            type: "link",
            config: {
              label: "Customer Profile",
              text: "View Customer Profile",  // ✅ Generic - script will update with actual ID
              url: "#",  // ✅ Placeholder - script will update from context
              linkType: "internal",
              icon: "EyeOutlined"
            },
            display: { span: 24 }
          },
          {
            id: "link-account-details",
            type: "link",
            config: {
              label: "Primary Account",
              text: "View Account Details",  // ✅ Generic - script will update with actual ID
              url: "#",  // ✅ Placeholder - script will update from context
              linkType: "internal",
              icon: "EyeOutlined"
            },
            display: { span: 24 }
          },

          // Review Comments Section
          {
            id: "divider-review",
            type: "divider",
            config: { label: "Your Review", orientation: "left" },
            display: { span: 24 }
          },
          {
            id: "verification-status",
            type: "select",
            name: "verificationStatus",
            config: {
              label: "Document Verification Status",
              required: true,
              placeholder: "Select verification status",
              options: [
                { label: "All Documents Verified", value: "verified" },
                { label: "Missing Documents", value: "missing" },
                { label: "Documents Need Correction", value: "correction" },
                { label: "Fraudulent Documents Detected", value: "fraud" }
              ]
            },
            display: { span: 24 }
          },
          {
            id: "review-notes",
            type: "textarea",
            name: "reviewNotes",
            config: {
              label: "Review Notes",
              required: true,
              placeholder: "Enter detailed review notes...",
              rows: 4
            },
            display: { span: 24 }
          },

          // Action Buttons
          {
            id: "divider-actions",
            type: "divider",
            config: { label: "📋 Submit Your Decision", orientation: "center" },
            display: { span: 24 }
          },
          {
            id: "text-helper",
            type: "text",
            config: {
              text: "Review all documents and links before making a decision",
              style: { textAlign: "center", color: "#666", fontSize: 14, marginBottom: 24 }
            },
            display: { span: 24 }
          },
          {
            id: "button-container",
            type: "empty",
            display: { span: 24 }
          },
          {
            id: "spacer-left",
            type: "empty",
            display: { span: 7 }
          },
          {
            id: "btn-reject",
            type: "button",
            config: {
              text: "Reject",
              type: "default",
              size: "large",
              danger: true,
              icon: "CloseCircleOutlined",
              dataAction: "reject",
              style: { minWidth: 160, height: 48, fontSize: 16, borderRadius: 8 }
            },
            display: { span: 4 }
          },
          {
            id: "spacer-middle",
            type: "empty",
            display: { span: 2 }
          },
          {
            id: "btn-approve",
            type: "button",
            config: {
              text: "Approve",
              type: "primary",
              size: "large",
              icon: "CheckCircleOutlined",
              dataAction: "approve",
              style: { minWidth: 160, height: 48, fontSize: 16, borderRadius: 8 }
            },
            display: { span: 4 }
          },
          {
            id: "spacer-right",
            type: "empty",
            display: { span: 7 }
          }
        ]
      },

      // Client Script (from ProcessTab)
      clientScript: `
        console.log('✅ Document review loaded successfully');
        console.log('📁 Documents available:', context.processVariables.documents);

        // ✅ REACT-LIKE API - Update links using helper functions (no DOM queries!)
        // Much easier for business users who know React
        
        // Update document download links
        if (context.processVariables.documents?.applicationForm) {
          setLinkUrl('link-application-form', context.processVariables.documents.applicationForm);
        }
        
        if (context.processVariables.documents?.incomeProof) {
          setLinkUrl('link-income-proof', context.processVariables.documents.incomeProof);
        }
        
        if (context.processVariables.documents?.identityDocument) {
          setLinkUrl('link-identity-document', context.processVariables.documents.identityDocument);
        }
        
        // Update external link
        if (context.processVariables.externalLinks?.creditBureauReport) {
          setLinkUrl('link-credit-bureau', context.processVariables.externalLinks.creditBureauReport);
        }
        
        // Update internal app links with dynamic IDs and text
        if (context.processVariables.references?.existingLoan) {
          const loanId = context.processVariables.references.existingLoan;
          setLink('link-loan-details', '/loans/' + loanId, 'View Loan #' + loanId);
        }
        
        if (context.processVariables.references?.customerId) {
          const custId = context.processVariables.references.customerId;
          setLink('link-customer-profile', '/customers/' + custId, 'View Profile #' + custId);
        }
        
        if (context.processVariables.references?.accountId) {
          const acctId = context.processVariables.references.accountId;
          setLink('link-account-details', '/accounts/' + acctId, 'View Account #' + acctId);
        }
        
        console.log('✅ All links updated using React-like helpers');

        // Handle approve button
        addEventListenerTo('[data-action="approve"]', 'click', async (e) => {
          e.preventDefault();
          
          try {
            await form.validateFields();
          } catch (err) {
            A.message.error('Please complete verification status and review notes');
            return;
          }
          
          const formData = form.getFieldsValue();
          
          if (formData.verificationStatus === 'fraud') {
            A.message.error('Cannot approve application with fraudulent documents detected');
            return;
          }
          
          if (formData.verificationStatus === 'missing' || formData.verificationStatus === 'correction') {
            A.Modal.confirm({
              title: '⚠️ Incomplete Verification',
              icon: null,
              content: 'Document verification is incomplete. Are you sure you want to approve?',
              okText: 'Approve Anyway',
              okType: 'primary',
              okButtonProps: {
                style: { backgroundColor: '#059669', borderColor: '#059669', height: 40 }
              },
              cancelButtonProps: {
                style: { height: 40 }
              },
              onOk: async () => {
                await processApproval(formData);
              }
            });
            return;
          }
          
          A.Modal.confirm({
            title: 'Approve Application',
            icon: null,
            content: 'Approve loan application for Michael Johnson ($25,000)?',
            okText: 'Approve',
            okType: 'primary',
            okButtonProps: {
              style: { backgroundColor: '#059669', borderColor: '#059669', height: 40 }
            },
            cancelButtonProps: {
              style: { height: 40 }
            },
            onOk: async () => {
              await processApproval(formData);
            }
          });
        });

        // Handle reject button
        addEventListenerTo('[data-action="reject"]', 'click', async (e) => {
          e.preventDefault();
          
          try {
            await form.validateFields();
          } catch (err) {
            A.message.error('Please complete verification status and review notes');
            return;
          }
          
          const formData = form.getFieldsValue();
          
          A.Modal.confirm({
            title: 'Reject Application',
            icon: null,
            content: 'Reject loan application for Michael Johnson?',
            okText: 'Reject',
            okType: 'danger',
            okButtonProps: {
              style: { height: 40 }
            },
            cancelButtonProps: {
              style: { height: 40 }
            },
            onOk: async () => {
              const hide = A.message.loading('Processing rejection...', 0);
              
              try {
                const response = await executeCommand('ReturnCallbackCommand', {
                  correlationKey: context.correlationId,
                  results: {
                    approved: false,
                    decidedBy: context.currentUser || 'verifier@bank.com',
                    decidedAt: new Date().toISOString(),
                    formData: formData,
                    action: 'reject',
                    verificationStatus: formData.verificationStatus
                  },
                  isFailed: false
                });
                
                hide();
                
                if (response?.outData?.isSuccessful) {
                  A.message.success('Application rejected');
                  console.log('✅ Rejection response:', response.outData);
                  setTimeout(() => window.location.href = '/dashboard', 1500);
                } else {
                  A.message.error('Rejection failed: ' + (response?.outData?.message || 'Unknown error'));
                }
              } catch (error) {
                hide();
                console.error('❌ Rejection error:', error);
                A.message.error('Failed to reject: ' + error.message);
              }
            }
          });
        });

        // Helper function for approval processing
        async function processApproval(formData) {
          const hide = A.message.loading('Processing approval...', 0);
          
          try {
            const response = await executeCommand('ReturnCallbackCommand', {
              correlationKey: context.correlationId,
              results: {
                approved: true,
                decidedBy: context.currentUser || 'verifier@bank.com',
                decidedAt: new Date().toISOString(),
                formData: formData,
                action: 'approve',
                verificationStatus: formData.verificationStatus
              },
              isFailed: false
            });
            
            hide();
            
            if (response?.outData?.isSuccessful) {
              A.message.success('Application approved successfully!');
              console.log('✅ Approval response:', response.outData);
              setTimeout(() => window.location.href = '/dashboard', 1500);
            } else {
              A.message.error('Approval failed: ' + (response?.outData?.message || 'Unknown error'));
            }
          } catch (error) {
            hide();
            console.error('❌ Approval error:', error);
            A.message.error('Failed to approve: ' + error.message);
          }
        }
      `,

      // Process Info
      processInfo: {
        processName: "Document Review Workflow",
        taskName: "Document Verification",
        initiator: "Michael Johnson",
        status: "Pending"
      },

      // Context (Backend Data)
      context: {
        correlationId: "CORR-77777",
        taskId: "task-006",
        processVariables: {
          applicantName: "Michael Johnson",
          loanType: "Personal Loan",
          loanAmount: 25000,
          applicationDate: "15-01-2026",
          documents: {
            applicationForm: "/documents/loan-applications/APP-2026-001.pdf",
            incomeProof: "/documents/income-proofs/INC-2026-001.pdf",
            identityDocument: "/documents/identity/ID-2026-001.pdf"
          },
          externalLinks: {
            creditBureauReport: "https://www.creditcheck.com/reports/MJ-2026-001"
          },
          references: {
            existingLoan: "LOAN-12345",
            customerId: "CUST-98765",
            accountId: "ACC-456789"
          }
        },
        entityData: {
          creditScore: 680,
          existingLoanBalance: 5000,
          accountBalance: 12000
        },
        userPermissions: {
          canApprove: true,
          canReject: true,
          canViewDocuments: true,
          maxApprovalAmount: 50000
        }
      }
    },

    // ========================================
    // 📋 FORM-TEST-007: React Hooks Demo
    // ========================================
    "FORM-TEST-007": {
      formId: "FORM-TEST-007",
      processName: "Advanced Form with React Hooks",
      formName: "Interactive Loan Calculator",
      taskName: "Calculate and Review",
      initiatedBy: "Sarah Williams",

      // Form JSON (from FormBuilder)
      formJson: {
        formControls: [
          // Input Fields
          {
            id: "divider-inputs",
            type: "divider",
            config: { label: "Loan Parameters", orientation: "left" },
            display: { span: 24 }
          },
          {
            id: "loan-amount",
            type: "input-number",
            name: "loanAmount",
            config: {
              label: "Loan Amount ($)",
              required: true,
              min: 1000,
              max: 1000000,
              placeholder: "Enter amount"
            },
            display: { span: 12 }
          },
          {
            id: "interest-rate",
            type: "input-number",
            name: "interestRate",
            config: {
              label: "Interest Rate (%)",
              required: true,
              min: 0.1,
              max: 30,
              step: 0.1,
              placeholder: "Enter rate"
            },
            display: { span: 12 }
          },
          {
            id: "term-months",
            type: "input-number",
            name: "termMonths",
            config: {
              label: "Loan Term (Months)",
              required: true,
              min: 6,
              max: 360,
              placeholder: "Enter term"
            },
            display: { span: 12 }
          },

          // Calculated Results (description-item)
          {
            id: "divider-results",
            type: "divider",
            config: { label: "Calculated Results", orientation: "left" },
            display: { span: 24 }
          },
          {
            id: "monthly-payment",
            type: "description-item",
            config: { label: "Monthly Payment", value: "—" },
            display: { span: 24 }
          },
          {
            id: "total-payment",
            type: "description-item",
            config: { label: "Total Payment", value: "—" },
            display: { span: 24 }
          },
          {
            id: "total-interest",
            type: "description-item",
            config: { label: "Total Interest", value: "—" },
            display: { span: 24 }
          },

          // External Resources
          {
            id: "divider-resources",
            type: "divider",
            config: { label: "Resources & Documents", orientation: "left" },
            display: { span: 24 }
          },
          {
            id: "link-calculator",
            type: "link",
            config: {
              label: "Loan Calculator",
              text: "Open External Calculator",
              url: "#",
              linkType: "external",
              icon: "LinkOutlined"
            },
            display: { span: 24 }
          },
          {
            id: "link-terms",
            type: "link",
            config: {
              label: "Terms & Conditions",
              text: "Download PDF",
              url: "#",
              linkType: "download",
              icon: "DownloadOutlined"
            },
            display: { span: 24 }
          },
          {
            id: "link-application",
            type: "link",
            config: {
              label: "Application Form",
              text: "View Application",
              url: "#",
              linkType: "internal",
              icon: "EyeOutlined"
            },
            display: { span: 24 }
          },

          // Review Comments
          {
            id: "divider-review",
            type: "divider",
            config: { label: "Your Review", orientation: "left" },
            display: { span: 24 }
          },
          {
            id: "review-notes",
            type: "textarea",
            name: "reviewNotes",
            config: {
              label: "Review Notes",
              required: true,
              placeholder: "Enter review notes...",
              rows: 4
            },
            display: { span: 24 }
          },

          // Action Buttons
          {
            id: "divider-actions",
            type: "divider",
            config: { label: "📋 Submit Your Decision", orientation: "center" },
            display: { span: 24 }
          },
          {
            id: "text-helper",
            type: "text",
            config: {
              text: "Review calculations and submit",
              style: { textAlign: "center", color: "#666", fontSize: 14, marginBottom: 24 }
            },
            display: { span: 24 }
          },
          {
            id: "spacer-left",
            type: "empty",
            display: { span: 7 }
          },
          {
            id: "btn-reject",
            type: "button",
            config: {
              text: "Reject",
              type: "default",
              size: "large",
              danger: true,
              icon: "CloseCircleOutlined",
              dataAction: "reject",
              style: { minWidth: 160, height: 48, fontSize: 16, borderRadius: 8 }
            },
            display: { span: 4 }
          },
          {
            id: "spacer-middle",
            type: "empty",
            display: { span: 2 }
          },
          {
            id: "btn-approve",
            type: "button",
            config: {
              text: "Approve",
              type: "primary",
              size: "large",
              icon: "CheckCircleOutlined",
              dataAction: "approve",
              style: { minWidth: 160, height: 48, fontSize: 16, borderRadius: 8 }
            },
            display: { span: 4 }
          },
          {
            id: "spacer-right",
            type: "empty",
            display: { span: 7 }
          }
        ]
      },

      // Client Script (from ProcessTab) - DEMONSTRATES REACT HOOKS!
      clientScript: `
        console.log('✅ React Hooks Demo - Advanced scripting');
        
        // ========================================
        // ✅ REACT HOOKS ARE AVAILABLE!
        // ========================================
        
        // React State Management (just like React components!)
        // Note: In real implementation, these would be managed differently
        // This demonstrates the API is available for users
        
        // ========================================
        // ✅ ENHANCED LINK OPTIONS
        // ========================================
        
        // External link - opens in new tab
        setLink(
          'link-calculator',
          'https://www.calculator.net/loan-calculator.html',
          'Open External Calculator',
          { target: '_blank' }  // ✅ Opens in new window!
        );
        
        // Download link - triggers download
        setLink(
          'link-terms',
          '/documents/terms-and-conditions.pdf',
          'Download Terms & Conditions',
          { download: 'terms.pdf' }  // ✅ Downloads with custom filename!
        );
        
        // Internal link - same window
        if (context.processVariables.applicationId) {
          const appId = context.processVariables.applicationId;
          setLink(
            'link-application',
            '/applications/' + appId,
            'View Application #' + appId
            // No options = opens in same window (default)
          );
        }
        
        console.log('✅ Links configured with target and download options');
        
        // ========================================
        // ✅ REAL-TIME CALCULATIONS (React-like)
        // ========================================
        
        // Function to calculate loan payment
        const calculateLoan = () => {
          const amount = form.getFieldValue('loanAmount') || 0;
          const rate = form.getFieldValue('interestRate') || 0;
          const months = form.getFieldValue('termMonths') || 0;
          
          if (amount && rate && months) {
            // Calculate monthly payment using formula
            const monthlyRate = rate / 100 / 12;
            const monthlyPayment = amount * (monthlyRate * Math.pow(1 + monthlyRate, months)) / (Math.pow(1 + monthlyRate, months) - 1);
            const totalPayment = monthlyPayment * months;
            const totalInterest = totalPayment - amount;
            
            // Update display values
            setDescriptionValue('monthly-payment', '$' + monthlyPayment.toFixed(2));
            setDescriptionValue('total-payment', '$' + totalPayment.toFixed(2));
            setDescriptionValue('total-interest', '$' + totalInterest.toFixed(2));
            
            console.log('💰 Calculated:', {
              monthlyPayment: monthlyPayment.toFixed(2),
              totalPayment: totalPayment.toFixed(2),
              totalInterest: totalInterest.toFixed(2)
            });
          } else {
            setDescriptionValue('monthly-payment', '—');
            setDescriptionValue('total-payment', '—');
            setDescriptionValue('total-interest', '—');
          }
        };
        
        // ✅ Listen to field changes (like React useEffect dependencies!)
        addEventListenerTo('[name="loanAmount"]', 'change', calculateLoan);
        addEventListenerTo('[name="interestRate"]', 'change', calculateLoan);
        addEventListenerTo('[name="termMonths"]', 'change', calculateLoan);
        
        // Initial calculation if values exist
        calculateLoan();
        
        console.log('✅ Real-time calculation listeners attached');
        
        // ========================================
        // ✅ CONDITIONAL FIELD VISIBILITY
        // ========================================
        
        // Show/hide fields based on context permissions
        if (!context.userPermissions.canViewExternalLinks) {
          hideField('link-calculator');
          console.log('🔒 External calculator hidden (no permission)');
        }
        
        if (!context.processVariables.applicationId) {
          hideField('link-application');
          console.log('ℹ️ Application link hidden (no application ID)');
        }
        
        // Handle approve button
        addEventListenerTo('[data-action="approve"]', 'click', async (e) => {
          e.preventDefault();
          
          try {
            await form.validateFields();
          } catch (err) {
            A.message.error('Please complete all required fields');
            return;
          }
          
          const formData = form.getFieldsValue();
          
          // Get calculated values
          const monthlyPayment = parseFloat(container.querySelector('#monthly-payment div:last-child').textContent.replace('$', '').replace(',', ''));
          
          if (!monthlyPayment || monthlyPayment === 0) {
            A.message.error('Please enter valid loan parameters');
            return;
          }
          
          A.Modal.confirm({
            title: 'Approve Loan',
            icon: null,
            content: 'Approve loan with monthly payment of $' + monthlyPayment.toFixed(2) + '?',
            okText: 'Approve',
            okType: 'primary',
            okButtonProps: {
              style: { backgroundColor: '#059669', borderColor: '#059669', height: 40 }
            },
            cancelButtonProps: {
              style: { height: 40 }
            },
            onOk: async () => {
              const hide = A.message.loading('Processing approval...', 0);
              
              try {
                const response = await executeCommand('ReturnCallbackCommand', {
                  correlationKey: context.correlationId,
                  results: {
                    approved: true,
                    decidedBy: context.currentUser || 'analyst@bank.com',
                    decidedAt: new Date().toISOString(),
                    formData: formData,
                    calculations: {
                      monthlyPayment: monthlyPayment,
                      totalPayment: parseFloat(container.querySelector('#total-payment div:last-child').textContent.replace('$', '').replace(',', '')),
                      totalInterest: parseFloat(container.querySelector('#total-interest div:last-child').textContent.replace('$', '').replace(',', ''))
                    },
                    action: 'approve'
                  },
                  isFailed: false
                });
                
                hide();
                
                if (response?.outData?.isSuccessful) {
                  A.message.success('Loan approved successfully!');
                  console.log('✅ Approval response:', response.outData);
                  setTimeout(() => window.location.href = '/dashboard', 1500);
                } else {
                  A.message.error('Approval failed: ' + (response?.outData?.message || 'Unknown error'));
                }
              } catch (error) {
                hide();
                console.error('❌ Approval error:', error);
                A.message.error('Failed to approve: ' + error.message);
              }
            }
          });
        });

        // Handle reject button
        addEventListenerTo('[data-action="reject"]', 'click', async (e) => {
          e.preventDefault();
          
          try {
            await form.validateFields(['reviewNotes']);
          } catch (err) {
            A.message.error('Please enter review notes');
            return;
          }
          
          const formData = form.getFieldsValue();
          
          A.Modal.confirm({
            title: 'Reject Loan',
            icon: null,
            content: 'Reject loan application?',
            okText: 'Reject',
            okType: 'danger',
            okButtonProps: {
              style: { height: 40 }
            },
            cancelButtonProps: {
              style: { height: 40 }
            },
            onOk: async () => {
              const hide = A.message.loading('Processing rejection...', 0);
              
              try {
                const response = await executeCommand('ReturnCallbackCommand', {
                  correlationKey: context.correlationId,
                  results: {
                    approved: false,
                    decidedBy: context.currentUser || 'analyst@bank.com',
                    decidedAt: new Date().toISOString(),
                    formData: formData,
                    action: 'reject'
                  },
                  isFailed: false
                });
                
                hide();
                
                if (response?.outData?.isSuccessful) {
                  A.message.success('Loan rejected');
                  console.log('✅ Rejection response:', response.outData);
                  setTimeout(() => window.location.href = '/dashboard', 1500);
                } else {
                  A.message.error('Rejection failed: ' + (response?.outData?.message || 'Unknown error'));
                }
              } catch (error) {
                hide();
                console.error('❌ Rejection error:', error);
                A.message.error('Failed to reject: ' + error.message);
              }
            }
          });
        });
        
        console.log('✅ React-like script loaded successfully!');
      `,

      // Process Info
      processInfo: {
        processName: "Advanced Form with React Hooks",
        taskName: "Calculate and Review",
        initiator: "Sarah Williams",
        status: "Pending"
      },

      // Context (Backend Data)
      context: {
        correlationId: "CORR-66666",
        taskId: "task-007",
        processVariables: {
          applicantName: "Sarah Williams",
          loanType: "Personal Loan",
          applicationId: "APP-2026-001"
        },
        entityData: {
          creditScore: 720,
          monthlyIncome: 6500
        },
        userPermissions: {
          canApprove: true,
          canReject: true,
          canViewExternalLinks: true,
          maxApprovalAmount: 100000
        }
      }
    },

    /**
     * ============================================================================
     * 📋 TEMPLATE 008: Review with Document Upload & Comments
     * ============================================================================
     * Use Case: Request additional information, resubmission, or clarification
     * Features:
     * - Display original request details
     * - File upload field for supporting documents
     * - Comment/feedback text area
     * - Action buttons (Submit, Request Info, Reject)
     * - Auto-populate user info and timestamp
     * ============================================================================
     */
    "FORM-TEST-008": {
      // Form Definition
      formJson: {
        fields: [
          // Header Section
          {
            id: "header",
            type: "divider",
            config: {
              text: "📄 Review Request - Additional Information Required",
              fontSize: "20px",
              fontWeight: "600",
              color: "#1890ff",
              marginBottom: "24px"
            }
          },

          // Original Request Information
          {
            id: "section-request-info",
            type: "divider",
            config: {
              text: "Original Request Information",
              fontSize: "16px",
              fontWeight: "500",
              marginTop: "0px",
              marginBottom: "16px"
            }
          },

          {
            id: "request-id",
            type: "description-item",
            config: {
              label: "Request ID",
              value: "REQ-2026-789",
              labelStyle: { fontWeight: 500, color: "#666" },
              valueStyle: { color: "#1890ff", fontWeight: 600 }
            }
          },

          {
            id: "applicant-name",
            type: "description-item",
            config: {
              label: "Applicant Name",
              value: "Michael Chen",
              labelStyle: { fontWeight: 500 },
              valueStyle: { fontWeight: 600 }
            }
          },

          {
            id: "request-type",
            type: "description-item",
            config: {
              label: "Request Type",
              value: "Business Loan Application",
              labelStyle: { fontWeight: 500 },
              valueStyle: { fontWeight: 600 }
            }
          },

          {
            id: "amount",
            type: "description-item",
            config: {
              label: "Requested Amount",
              value: "$50,000.00",
              labelStyle: { fontWeight: 500 },
              valueStyle: { fontWeight: 600, fontSize: "16px", color: "#52c41a" }
            }
          },

          {
            id: "submission-date",
            type: "description-item",
            config: {
              label: "Submission Date",
              value: "January 10, 2026",
              labelStyle: { fontWeight: 500 },
              valueStyle: { color: "#666" }
            }
          },

          // Reason for Review
          {
            id: "divider-reason",
            type: "divider",
            config: {
              text: "Reason for Review",
              fontSize: "16px",
              fontWeight: "500",
              marginTop: "24px",
              marginBottom: "16px"
            }
          },

          {
            id: "review-reason",
            type: "text",
            config: {
              text: "⚠️ Missing Documents: Business plan and financial projections for the last 2 years are required to proceed with the application review.",
              fontSize: "14px",
              color: "#d46b08",
              backgroundColor: "#fff7e6",
              padding: "12px",
              borderRadius: "4px",
              borderLeft: "4px solid #fa8c16",
              marginBottom: "24px"
            }
          },

          // Upload Section
          {
            id: "divider-upload",
            type: "divider",
            config: {
              text: "📎 Upload Required Documents",
              fontSize: "16px",
              fontWeight: "500",
              marginTop: "24px",
              marginBottom: "16px"
            }
          },

          {
            id: "upload-documents",
            type: "upload",
            name: "supportingDocuments",
            config: {
              label: "Supporting Documents",
              required: true,
              multiple: true,
              maxCount: 5,
              accept: ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.png",
              listType: "text",
              dragger: true, // ✅ Enable drag-and-drop
              hint: "Drag and drop files here, or click to browse. Max 10MB per file.",
              rules: [
                { required: true, message: "Please upload at least one document" }
              ]
            }
          },

          // Comments Section
          {
            id: "divider-comments",
            type: "divider",
            config: {
              text: "💬 Your Comments",
              fontSize: "16px",
              fontWeight: "500",
              marginTop: "24px",
              marginBottom: "16px"
            }
          },

          {
            id: "reviewer-comments",
            type: "textarea",
            name: "comments",
            config: {
              label: "Comments / Additional Information",
              placeholder: "Provide any additional context, explanations, or clarifications...",
              required: true,
              rows: 6,
              maxLength: 1000,
              showCount: true,
              rules: [
                { required: true, message: "Please provide your comments" },
                { min: 10, message: "Comments must be at least 10 characters" }
              ]
            }
          },

          // Reviewer Info (Auto-populated)
          {
            id: "divider-reviewer-info",
            type: "divider",
            config: {
              text: "Reviewer Information",
              fontSize: "16px",
              fontWeight: "500",
              marginTop: "24px",
              marginBottom: "16px"
            }
          },

          {
            id: "reviewer-name",
            type: "description-item",
            config: {
              label: "Reviewed By",
              value: "Loading...",
              labelStyle: { fontWeight: 500 },
              valueStyle: { fontWeight: 600 }
            }
          },

          {
            id: "review-timestamp",
            type: "description-item",
            config: {
              label: "Review Date/Time",
              value: "Loading...",
              labelStyle: { fontWeight: 500 },
              valueStyle: { color: "#666" }
            }
          },

          // Action Buttons
          {
            id: "divider-actions",
            type: "divider",
            config: {
              text: "",
              marginTop: "32px",
              marginBottom: "16px"
            }
          },

          // Action Buttons in a Row
          {
            id: "btn-submit-response",
            type: "button",
            display: { span: 8 },
            config: {
              text: "✓ Submit Response",
              htmlType: "button",
              dataAction: "submit",
              type: "primary",
              size: "large",
              block: true,
              style: { backgroundColor: "#52c41a", borderColor: "#52c41a" }
            }
          },

          {
            id: "btn-request-more-info",
            type: "button",
            display: { span: 8 },
            config: {
              text: "❓ Request More Information",
              htmlType: "button",
              dataAction: "request-info",
              type: "default",
              size: "large",
              block: true
            }
          },

          {
            id: "btn-reject",
            type: "button",
            display: { span: 8 },
            config: {
              text: "✗ Reject Request",
              htmlType: "button",
              dataAction: "reject",
              type: "default",
              danger: true,
              size: "large",
              block: true
            }
          }
        ]
      },

      // Client Script
      script: `
        // ========================================
        // 🎯 TEMPLATE 008: Review with Upload & Comments
        // ========================================
        
        // Auto-populate reviewer information
        const currentUser = context.entityData?.reviewerName || "Unknown Reviewer";
        const currentTimestamp = new Date().toLocaleString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        });
        
        setDescriptionValue('reviewer-name', currentUser);
        setDescriptionValue('review-timestamp', currentTimestamp);
        
        // Update request details from context
        if (context.processVariables) {
          const { requestId, applicantName, requestType, amount, submissionDate } = context.processVariables;
          
          if (requestId) setDescriptionValue('request-id', requestId);
          if (applicantName) setDescriptionValue('applicant-name', applicantName);
          if (requestType) setDescriptionValue('request-type', requestType);
          if (amount) setDescriptionValue('amount', \`$\${Number(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}\`);
          if (submissionDate) setDescriptionValue('submission-date', submissionDate);
        }
        
        // Update review reason from context
        if (context.processVariables?.reviewReason) {
          const reasonElement = document.querySelector('#review-reason');
          if (reasonElement) {
            reasonElement.textContent = '⚠️ ' + context.processVariables.reviewReason;
          }
        }
        
        // ========================================
        // 📤 Handle Submit Response
        // ========================================
        addEventListenerTo('[data-action="submit"]', 'click', async () => {
          try {
            // Validate form
            const values = await form.validateFields();
            
            // Check if documents are uploaded
            if (!values.supportingDocuments || values.supportingDocuments.length === 0) {
              A.message.warning('Please upload at least one document');
              return;
            }
            
            // Confirmation modal
            A.Modal.confirm({
              title: 'Submit Response?',
              content: \`You are about to submit your response with \${values.supportingDocuments.length} document(s). This action cannot be undone.\`,
              okText: 'Yes, Submit',
              cancelText: 'Cancel',
              okButtonProps: { 
                style: { backgroundColor: '#52c41a', borderColor: '#52c41a' }
              },
              onOk: async () => {
                const hide = A.message.loading('Submitting response...', 0);
                
                try {
                  // Prepare submission data
                  const submissionData = {
                    correlationId: context.correlationId,
                    action: 'SUBMIT_RESPONSE',
                    documents: values.supportingDocuments.map(file => ({
                      name: file.name,
                      size: file.size,
                      type: file.type,
                      url: file.url || file.response?.url
                    })),
                    comments: values.comments,
                    reviewer: currentUser,
                    reviewTimestamp: new Date().toISOString(),
                    metadata: {
                      requestId: context.processVariables?.requestId,
                      applicantName: context.processVariables?.applicantName
                    }
                  };
                  
                  // Execute backend command
                  await executeCommand('SubmitReviewResponseCommand', submissionData);
                  
                  hide();
                  A.message.success('Response submitted successfully!');
                  
                  // Reset form
                  form.resetFields();
                  
                  // Optional: Navigate away or refresh
                  // window.location.href = '/approvals';
                  
                } catch (error) {
                  hide();
                  A.message.error('Failed to submit: ' + (error.message || 'Unknown error'));
                }
              }
            });
            
          } catch (error) {
            console.error('Validation failed:', error);
            A.message.error('Please fill in all required fields');
          }
        });
        
        // ========================================
        // ❓ Handle Request More Info
        // ========================================
        addEventListenerTo('[data-action="request-info"]', 'click', async () => {
          try {
            const values = await form.validateFields(['comments']);
            
            A.Modal.confirm({
              title: 'Request More Information?',
              content: 'This will send a notification to the applicant requesting additional information.',
              okText: 'Yes, Send Request',
              cancelText: 'Cancel',
              onOk: async () => {
                const hide = A.message.loading('Sending request...', 0);
                
                try {
                  const requestData = {
                    correlationId: context.correlationId,
                    action: 'REQUEST_MORE_INFO',
                    comments: values.comments,
                    reviewer: currentUser,
                    reviewTimestamp: new Date().toISOString(),
                    metadata: {
                      requestId: context.processVariables?.requestId,
                      applicantName: context.processVariables?.applicantName
                    }
                  };
                  
                  await executeCommand('RequestMoreInfoCommand', requestData);
                  
                  hide();
                  A.message.success('Information request sent successfully!');
                  
                  form.resetFields();
                  
                } catch (error) {
                  hide();
                  A.message.error('Failed to send request: ' + (error.message || 'Unknown error'));
                }
              }
            });
            
          } catch (error) {
            A.message.error('Please provide comments before requesting more information');
          }
        });
        
        // ========================================
        // ✗ Handle Reject
        // ========================================
        addEventListenerTo('[data-action="reject"]', 'click', async () => {
          try {
            const values = await form.validateFields(['comments']);
            
            A.Modal.confirm({
              title: 'Reject Request?',
              content: 'Are you sure you want to reject this request? This action cannot be undone.',
              okText: 'Yes, Reject',
              cancelText: 'Cancel',
              okButtonProps: { danger: true },
              onOk: async () => {
                const hide = A.message.loading('Processing rejection...', 0);
                
                try {
                  const rejectData = {
                    correlationId: context.correlationId,
                    action: 'REJECT',
                    comments: values.comments,
                    reviewer: currentUser,
                    reviewTimestamp: new Date().toISOString(),
                    metadata: {
                      requestId: context.processVariables?.requestId,
                      applicantName: context.processVariables?.applicantName
                    }
                  };
                  
                  await executeCommand('RejectRequestCommand', rejectData);
                  
                  hide();
                  A.message.success('Request rejected successfully');
                  
                  form.resetFields();
                  
                  // Optional: Navigate away
                  // window.location.href = '/approvals';
                  
                } catch (error) {
                  hide();
                  A.message.error('Failed to reject: ' + (error.message || 'Unknown error'));
                }
              }
            });
            
          } catch (error) {
            A.message.error('Please provide rejection reason in comments');
          }
        });
        
        console.log('✅ Template 008 (Review with Upload) loaded successfully!');
      `,

      // Process Info
      processInfo: {
        processName: "Document Resubmission Review",
        taskName: "Review Additional Information",
        initiator: "Michael Chen",
        status: "Pending Additional Info"
      },

      // Context (Backend Data)
      context: {
        correlationId: "CORR-77777",
        taskId: "task-008",
        processVariables: {
          requestId: "REQ-2026-789",
          applicantName: "Michael Chen",
          requestType: "Business Loan Application",
          amount: "50000",
          submissionDate: "January 10, 2026",
          reviewReason: "Missing Documents: Business plan and financial projections for the last 2 years are required to proceed with the application review."
        },
        entityData: {
          reviewerName: "Jennifer Martinez",
          reviewerRole: "Senior Loan Officer",
          reviewerDepartment: "Commercial Lending"
        },
        userPermissions: {
          canSubmit: true,
          canRequestMoreInfo: true,
          canReject: true,
          canUploadDocuments: true,
          maxFileSize: 10485760 // 10MB
        }
      }
    },

    /**
     * ============================================================================
     * � TEMPLATE 009: Permission Denied / Access Restricted
     * ============================================================================
     * Use Case: Simulate authorization/permission errors
     * Purpose: Test error handling when user lacks permission to view form
     * Features:
     * - Triggers a 403 Forbidden error
     * - Tests error boundary and retry functionality
     * - Demonstrates graceful degradation
     * - Shows helpful error messages
     * 
     * This template intentionally returns null to trigger an error that simulates
     * a backend returning "Permission Denied" or "Access Forbidden".
     * ============================================================================
     */
    "FORM-TEST-009": {
      // ⚠️ Form intentionally has no definition to simulate permission denied
      // In a real scenario, the backend API would return a 403 error
      formJson: null,  // ← This will trigger an error
      clientScript: null,
      context: null,

      // ✅ Process info IS provided - users should see what they're trying to access
      processInfo: {
        processName: "High-Value Transaction Approval",
        taskName: "Senior Manager Approval Required",
        initiator: "Sarah Johnson",
        status: "Pending Approval",
        startTime: "2026-01-15T09:30:00Z",
        priority: "High",
        amount: "$250,000.00",
        transactionType: "Wire Transfer - International"
      },

      // Metadata explaining why access is denied
      errorInfo: {
        code: "PERMISSION_DENIED",
        message: "You do not have permission to access this form",
        reason: "Your user role does not include approval rights for high-value transactions above $100,000",
        suggestedAction: "Contact your administrator to request 'Senior Approver' role access",
        requiredPermissions: [
          "workflow.approve",
          "form.high_value_transactions.view",
          "transactions.approve.over_100k"
        ],
        requiredRole: "Senior Approver",
        currentRole: "Junior Approver",
        approvalLimit: "$50,000.00"
      }
    },

    /**
     * ============================================================================
     * 📤 TEMPLATE 009-ALT: Document Upload Showcase (Drag & Drop)
     * ============================================================================
     * Use Case: Bulk document submission with drag-and-drop
     * Features:
     * - Large drag-and-drop upload area
     * - Visual file preview
     * - Multiple file types support
     * - Bulk upload capability
     * - File validation and feedback
     * - Progress indicators
     * 
     * NOTE: This is the original template 009, preserved as 009-ALT
     * ============================================================================
     */
    "FORM-TEST-009-ALT": {
      // Form Definition
      formJson: {
        fields: [
          // Header Section
          {
            id: "header",
            type: "divider",
            config: {
              text: "📤 Document Submission Portal",
              fontSize: "24px",
              fontWeight: "600",
              color: "#1890ff",
              marginBottom: "24px"
            }
          },

          {
            id: "intro-text",
            type: "text",
            config: {
              text: "Upload multiple documents at once using our drag-and-drop interface. You can drag files directly from your computer or click to browse.",
              fontSize: "14px",
              color: "#595959",
              marginBottom: "32px"
            }
          },

          // Application Info
          {
            id: "section-info",
            type: "divider",
            config: {
              text: "Application Information",
              fontSize: "16px",
              fontWeight: "500",
              marginBottom: "16px"
            }
          },

          {
            id: "application-id",
            type: "description-item",
            config: {
              label: "Application ID",
              value: "APP-2026-1234",
              labelStyle: { fontWeight: 500 },
              valueStyle: { fontWeight: 600, color: "#1890ff" }
            }
          },

          {
            id: "applicant-name",
            type: "description-item",
            config: {
              label: "Applicant",
              value: "Robert Anderson",
              labelStyle: { fontWeight: 500 },
              valueStyle: { fontWeight: 600 }
            }
          },

          {
            id: "submission-deadline",
            type: "description-item",
            config: {
              label: "Deadline",
              value: "January 20, 2026",
              labelStyle: { fontWeight: 500 },
              valueStyle: { fontWeight: 600, color: "#fa8c16" }
            }
          },

          // Required Documents Checklist
          {
            id: "section-required",
            type: "divider",
            config: {
              text: "📋 Required Documents",
              fontSize: "16px",
              fontWeight: "500",
              marginTop: "24px",
              marginBottom: "16px"
            }
          },

          {
            id: "required-docs-list",
            type: "text",
            config: {
              text: `
                <ul style="margin: 0; padding-left: 24px; line-height: 2;">
                  <li>✓ Government-issued ID (PDF or Image)</li>
                  <li>✓ Proof of Income (Last 3 months)</li>
                  <li>✓ Bank Statements (Last 6 months)</li>
                  <li>✓ Business Registration Certificate</li>
                  <li>✓ Tax Returns (Last 2 years)</li>
                  <li>✓ Business Plan (PDF)</li>
                </ul>
              `,
              fontSize: "14px",
              backgroundColor: "#f0f5ff",
              padding: "16px",
              borderRadius: "8px",
              border: "1px solid #d6e4ff",
              marginBottom: "24px"
            }
          },

          // Drag & Drop Upload Area
          {
            id: "section-upload",
            type: "divider",
            config: {
              text: "📁 Upload Documents",
              fontSize: "16px",
              fontWeight: "500",
              marginTop: "24px",
              marginBottom: "16px"
            }
          },

          {
            id: "document-upload",
            type: "upload",
            name: "documents",
            config: {
              label: "Drag and drop your documents here",
              required: true,
              multiple: true,
              maxCount: 10,
              accept: ".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png",
              listType: "picture",
              dragger: true, // ✅ Drag-and-drop enabled
              hint: "Accepted formats: PDF, Word, Excel, Images (JPG, PNG). Max 10MB per file. Upload up to 10 files.",
              maxSize: 10485760,
              rules: [
                { required: true, message: "Please upload at least one document" }
              ]
            }
          },

          // Additional Notes
          {
            id: "section-notes",
            type: "divider",
            config: {
              text: "📝 Additional Notes (Optional)",
              fontSize: "16px",
              fontWeight: "500",
              marginTop: "24px",
              marginBottom: "16px"
            }
          },

          {
            id: "notes",
            type: "textarea",
            name: "notes",
            config: {
              label: "Notes",
              placeholder: "Add any additional notes or comments about your submission...",
              required: false,
              rows: 4,
              maxLength: 500,
              showCount: true
            }
          },

          // Confirmation Checkbox
          {
            id: "confirm-accuracy",
            type: "checkbox",
            name: "confirmAccuracy",
            config: {
              label: "I confirm that all uploaded documents are accurate and complete",
              required: true,
              rules: [
                { required: true, message: "Please confirm document accuracy" }
              ]
            }
          },

          // Submit Button
          {
            id: "divider-submit",
            type: "divider",
            config: {
              text: "",
              marginTop: "32px",
              marginBottom: "16px"
            }
          },

          {
            id: "btn-submit",
            type: "button",
            config: {
              text: "📤 Submit Documents",
              htmlType: "button",
              dataAction: "submit",
              type: "primary",
              size: "large",
              backgroundColor: "#52c41a",
              hoverColor: "#73d13d"
            }
          }
        ]
      },

      // Client Script
      script: `
        // ========================================
        // 🎯 TEMPLATE 009: Drag & Drop Upload
        // ========================================
        
        // Track upload status
        const [uploadStatus, setUploadStatus] = useState('idle'); // idle, uploading, success, error
        const [uploadedCount, setUploadedCount] = useState(0);
        
        // Monitor file upload changes
        const documentUpload = document.querySelector('#document-upload');
        if (documentUpload) {
          documentUpload.addEventListener('change', () => {
            const fileList = form.getFieldValue('documents');
            if (fileList && fileList.length > 0) {
              setUploadedCount(fileList.length);
              console.log('Files uploaded:', fileList.length);
            }
          });
        }
        
        // ========================================
        // 📤 Handle Document Submission
        // ========================================
        addEventListenerTo('[data-action="submit"]', 'click', async () => {
          try {
            // Validate form
            const values = await form.validateFields();
            
            // Check documents
            if (!values.documents || values.documents.length === 0) {
              A.message.warning('Please upload at least one document');
              return;
            }
            
            // Check confirmation
            if (!values.confirmAccuracy) {
              A.message.warning('Please confirm document accuracy');
              return;
            }
            
            // Show summary modal
            A.Modal.confirm({
              title: '📤 Submit Documents?',
              content: (
                '<div style="line-height: 1.8">' +
                  '<p><strong>You are about to submit:</strong></p>' +
                  '<ul style="margin: 8px 0; padding-left: 24px;">' +
                    \`<li>\${values.documents.length} document(s)</li>\` +
                    '<li>Application ID: APP-2026-1234</li>' +
                    '<li>Applicant: Robert Anderson</li>' +
                  '</ul>' +
                  '<p style="margin-top: 16px; color: #8c8c8c;">This action cannot be undone.</p>' +
                '</div>'
              ),
              okText: 'Yes, Submit',
              cancelText: 'Cancel',
              okButtonProps: {
                style: { backgroundColor: '#52c41a', borderColor: '#52c41a' }
              },
              width: 500,
              onOk: async () => {
                const hide = A.message.loading('Uploading documents...', 0);
                setUploadStatus('uploading');
                
                try {
                  // Prepare submission data
                  const submissionData = {
                    correlationId: context.correlationId,
                    applicationId: 'APP-2026-1234',
                    applicant: 'Robert Anderson',
                    documents: values.documents.map((file, index) => ({
                      id: \`doc-\${index + 1}\`,
                      name: file.name,
                      size: file.size,
                      type: file.type,
                      url: file.url || file.response?.url,
                      uploadedAt: new Date().toISOString()
                    })),
                    notes: values.notes || '',
                    confirmAccuracy: values.confirmAccuracy,
                    submittedBy: context.entityData?.submitterName || 'Unknown',
                    submittedAt: new Date().toISOString()
                  };
                  
                  // Execute backend command
                  await executeCommand('SubmitDocumentsCommand', submissionData);
                  
                  hide();
                  setUploadStatus('success');
                  
                  // Success modal
                  A.Modal.success({
                    title: '✅ Documents Submitted Successfully!',
                    content: (
                      '<div style="line-height: 1.8">' +
                        \`<p><strong>\${values.documents.length} documents</strong> have been uploaded and submitted.</p>\` +
                        '<p>Reference Number: <strong style="color: #1890ff">SUB-2026-' + Math.floor(Math.random() * 10000) + '</strong></p>' +
                        '<p style="margin-top: 16px; color: #52c41a;">Your submission will be reviewed within 2-3 business days.</p>' +
                      '</div>'
                    ),
                    okText: 'Done',
                    onOk: () => {
                      // Reset form
                      form.resetFields();
                      setUploadedCount(0);
                      setUploadStatus('idle');
                    }
                  });
                  
                } catch (error) {
                  hide();
                  setUploadStatus('error');
                  A.message.error('Failed to submit: ' + (error.message || 'Unknown error'));
                }
              }
            });
            
          } catch (error) {
            console.error('Validation failed:', error);
            A.message.error('Please complete all required fields');
          }
        });
        
        // ========================================
        // 📊 Show upload statistics
        // ========================================
        useEffect(() => {
          if (uploadedCount > 0) {
            console.log(\`📊 Current status: \${uploadedCount} file(s) uploaded\`);
          }
        }, [uploadedCount]);
        
        console.log('✅ Template 009 (Drag & Drop Upload) loaded successfully!');
      `,

      // Process Info
      processInfo: {
        processName: "Document Submission",
        taskName: "Upload Required Documents",
        initiator: "Robert Anderson",
        status: "Pending Upload"
      },

      // Context (Backend Data)
      context: {
        correlationId: "CORR-88888",
        taskId: "task-009",
        processVariables: {
          applicationId: "APP-2026-1234",
          applicantName: "Robert Anderson",
          applicationType: "Business Loan",
          deadline: "January 20, 2026"
        },
        entityData: {
          submitterName: "Robert Anderson",
          submitterEmail: "robert.anderson@example.com",
          submitterPhone: "+1-555-0123"
        },
        userPermissions: {
          canUpload: true,
          canSubmit: true,
          maxFileSize: 10485760,
          maxFileCount: 10
        }
      }
    },

    // ========================================
    // 📊 TEMPLATE 010: Review with Table & Actions
    // ========================================
    "FORM-TEST-010": {
      formId: "FORM-TEST-010",
      formName: "Payment Review with Transaction Table",

      // Form Definition (from FormBuilder)
      formJson: {
        formular: [
          // Header
          {
            id: "header-title",
            type: "html",
            config: {
              html: `
              <div style="text-align: center; padding: 24px 0; border-bottom: 2px solid #1890ff; margin-bottom: 24px;">
                <h1 style="margin: 0; font-size: 28px; color: #1890ff; font-weight: 600;">
                  📊 Payment Batch Review
                </h1>
                <p style="margin: 8px 0 0 0; font-size: 14px; color: #8c8c8c;">
                  Review transactions and take action on this payment batch
                </p>
              </div>
            `
            }
          },

          // Batch Information
          {
            id: "batch-info",
            type: "description",
            config: {
              label: "Batch Information",
              items: [
                { label: "Batch ID", content: "BATCH-2026-0115" },
                { label: "Submitted By", content: "John Smith" },
                { label: "Submission Date", content: "January 15, 2026 10:30 AM" },
                { label: "Total Amount", content: "$125,450.00" },
                { label: "Transaction Count", content: "15 transactions" },
                { label: "Status", content: "Pending Review" }
              ],
              bordered: true,
              column: 2
            }
          },

          // Section Header
          {
            id: "transactions-header",
            type: "html",
            config: {
              html: `
              <div style="margin: 32px 0 16px 0;">
                <h3 style="margin: 0; font-size: 18px; color: #262626; font-weight: 600;">
                  💳 Transactions in This Batch
                </h3>
                <p style="margin: 4px 0 0 0; font-size: 14px; color: #8c8c8c;">
                  Review each transaction below. Click actions to approve, reject, or flag for review.
                </p>
              </div>
            `
            }
          },

          // Transaction Table
          {
            id: "transactions-table",
            type: "table",
            config: {
              tableId: "transactionsTable",
              dataSource: "tableData",
              rowKey: "id",
              size: "middle",
              bordered: true,
              pagination: true,
              columns: [
                {
                  title: "ID",
                  dataIndex: "transactionId",
                  key: "transactionId",
                  width: 120,
                  align: "center"
                },
                {
                  title: "Beneficiary",
                  dataIndex: "beneficiary",
                  key: "beneficiary",
                  width: 200
                },
                {
                  title: "Account Number",
                  dataIndex: "accountNumber",
                  key: "accountNumber",
                  width: 150
                },
                {
                  title: "Amount",
                  dataIndex: "amount",
                  key: "amount",
                  width: 120,
                  align: "right",
                  render: "(text, record) => <span style={{ fontWeight: 600, color: '#262626' }}>${text}</span>"
                },
                {
                  title: "Status",
                  dataIndex: "status",
                  key: "status",
                  width: 120,
                  align: "center",
                  render: `(text, record) => {
                  const statusConfig = {
                    'Pending': { color: '#faad14', bg: '#fffbe6', border: '#ffe58f' },
                    'Approved': { color: '#52c41a', bg: '#f6ffed', border: '#b7eb8f' },
                    'Rejected': { color: '#ff4d4f', bg: '#fff1f0', border: '#ffccc7' },
                    'Flagged': { color: '#fa8c16', bg: '#fff7e6', border: '#ffd591' }
                  };
                  const style = statusConfig[text] || statusConfig['Pending'];
                  return (
                    <span style={{
                      padding: '4px 12px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      fontWeight: 500,
                      color: style.color,
                      backgroundColor: style.bg,
                      border: '1px solid ' + style.border
                    }}>
                      {text}
                    </span>
                  );
                }`
                },
                {
                  title: "Actions",
                  key: "actions",
                  width: 220,
                  align: "center",
                  render: `(text, record) => (
                  <A.Space size="small">
                    <A.Button 
                      size="small" 
                      type="primary"
                      data-action="approve"
                      data-id={record.id}
                      disabled={record.status !== 'Pending'}
                      style={{ fontSize: '12px' }}
                    >
                      ✓ Approve
                    </A.Button>
                    <A.Button 
                      size="small" 
                      danger
                      data-action="reject"
                      data-id={record.id}
                      disabled={record.status !== 'Pending'}
                      style={{ fontSize: '12px' }}
                    >
                      ✗ Reject
                    </A.Button>
                    <A.Button 
                      size="small"
                      data-action="flag"
                      data-id={record.id}
                      disabled={record.status !== 'Pending'}
                      style={{ fontSize: '12px' }}
                    >
                      🚩 Flag
                    </A.Button>
                  </A.Space>
                )`
                }
              ]
            }
          },

          // Comments Section
          {
            id: "divider-comments",
            type: "divider",
            config: {
              text: "Comments",
              marginTop: "32px",
              marginBottom: "16px"
            }
          },

          {
            id: "reviewer-comments",
            type: "textarea",
            name: "comments",
            config: {
              label: "Reviewer Comments / Additional Information",
              placeholder: "Provide any comments about this batch or specific transactions...",
              rows: 4
            }
          },

          // Batch Actions
          {
            id: "divider-batch-actions",
            type: "divider",
            config: {
              text: "",
              marginTop: "32px",
              marginBottom: "16px"
            }
          },

          // Action Buttons in a Row
          {
            id: "btn-approve-all",
            type: "button",
            display: { span: 8 },
            config: {
              text: "✓ Approve All Pending",
              htmlType: "button",
              dataAction: "approve-all",
              type: "primary",
              size: "large",
              block: true,
              style: { backgroundColor: "#52c41a", borderColor: "#52c41a" }
            }
          },

          {
            id: "btn-review-flagged",
            type: "button",
            display: { span: 8 },
            config: {
              text: "🔍 Review Flagged Items",
              htmlType: "button",
              dataAction: "review-flagged",
              type: "default",
              size: "large",
              block: true
            }
          },

          {
            id: "btn-reject-all",
            type: "button",
            display: { span: 8 },
            config: {
              text: "✗ Reject Entire Batch",
              htmlType: "button",
              dataAction: "reject-all",
              type: "default",
              danger: true,
              size: "large",
              block: true
            }
          }
        ]
      },

      // Client Script
      clientScript: `
        // ========================================
        // 🎯 TEMPLATE 010: Table with Actions
        // ========================================
        // NOTE: This demonstrates how tables should work in Form Builder
        // The table data comes from CONTEXT, not from React hooks
        
        console.log('✅ Template 010 (Payment Review with Table) initializing...');
        console.log('📊 Table data available from context:', context.tableData);
        
        // Log table statistics
        if (context.tableData && context.tableData.length > 0) {
          const stats = {
            total: context.tableData.length,
            pending: context.tableData.filter(t => t.status === 'Pending').length,
            approved: context.tableData.filter(t => t.status === 'Approved').length,
            rejected: context.tableData.filter(t => t.status === 'Rejected').length
          };
          console.log('📊 Transaction stats:', stats);
        }
        
        // ========================================
        // ✓ Handle Individual Approve
        // ========================================
        addEventListenerTo('[data-action="approve"]', 'click', (e) => {
          const transactionId = e.currentTarget.getAttribute('data-id');
          
          A.Modal.confirm({
            title: '✓ Approve Transaction?',
            content: \`Are you sure you want to approve transaction ID \${transactionId}?\`,
            okText: 'Yes, Approve',
            okType: 'primary',
            cancelText: 'Cancel',
            onOk: () => {
              A.message.success(\`Transaction \${transactionId} approved successfully!\`);
              console.log(\`✓ Transaction \${transactionId} approved\`);
            }
          });
        });

        // ========================================
        // ✗ Handle Individual Reject
        // ========================================
        addEventListenerTo('[data-action="reject"]', 'click', (e) => {
          const transactionId = e.currentTarget.getAttribute('data-id');
          
          A.Modal.confirm({
            title: '✗ Reject Transaction?',
            content: \`Are you sure you want to reject transaction ID \${transactionId}?\`,
            okText: 'Yes, Reject',
            okType: 'danger',
            cancelText: 'Cancel',
            onOk: () => {
              A.message.warning(\`Transaction \${transactionId} rejected\`);
              console.log(\`✗ Transaction \${transactionId} rejected\`);
            }
          });
        });

        // ========================================
        // 🚩 Handle Flag Transaction
        // ========================================
        addEventListenerTo('[data-action="flag"]', 'click', (e) => {
          const transactionId = e.currentTarget.getAttribute('data-id');
          
          A.Modal.confirm({
            title: '🚩 Flag Transaction for Review?',
            content: \`Flag transaction ID \${transactionId} for further investigation?\`,
            okText: 'Yes, Flag',
            cancelText: 'Cancel',
            onOk: () => {
              A.message.warning(\`Transaction \${transactionId} flagged for review\`);
              console.log(\`🚩 Transaction \${transactionId} flagged\`);
            }
          });
        });

        // ========================================
        // ✓ Handle Approve All Pending
        // ========================================
        addEventListenerTo('[data-action="approve-all"]', 'click', async () => {
          const pendingCount = stats.pending;
          
          if (pendingCount === 0) {
            A.message.info('No pending transactions to approve');
            return;
          }

          A.Modal.confirm({
            title: '✓ Approve All Pending Transactions?',
            content: (
              '<div style="line-height: 1.8">' +
                \`<p>You are about to approve <strong>\${pendingCount} pending transaction(s)</strong>.</p>\` +
                '<p>This action will mark all pending transactions as approved.</p>' +
                '<p style="margin-top: 16px; color: #8c8c8c;">Do you want to proceed?</p>' +
              '</div>'
            ),
            okText: 'Yes, Approve All',
            okType: 'primary',
            cancelText: 'Cancel',
            onOk: async () => {
              const hide = A.message.loading('Approving transactions...', 0);
              
              // Simulate API call
              await new Promise(resolve => setTimeout(resolve, 1000));
              
              const updatedData = tableData.map(item => 
                item.status === 'Pending' 
                  ? { ...item, status: 'Approved' }
                  : item
              );
              setTableData(updatedData);
              updateStats(updatedData);
              
              hide();
              
              A.Modal.success({
                title: '✅ Batch Approved!',
                content: \`Successfully approved \${pendingCount} transaction(s). The batch is now ready for processing.\`,
                okText: 'Done'
              });
            }
          });
        });

        // ========================================
        // 🔍 Handle Review Flagged Items
        // ========================================
        addEventListenerTo('[data-action="review-flagged"]', 'click', () => {
          const flaggedCount = stats.flagged;
          
          if (flaggedCount === 0) {
            A.message.info('No flagged transactions to review');
            return;
          }

          const flaggedItems = tableData.filter(t => t.status === 'Flagged');
          
          A.Modal.info({
            title: '🚩 Flagged Transactions',
            width: 600,
            content: (
              '<div>' +
                \`<p>There are <strong>\${flaggedCount} flagged transaction(s)</strong> that require review:</p>\` +
                '<ul style="margin: 16px 0; padding-left: 24px;">' +
                  flaggedItems.map(item => \`<li>\${item.transactionId} - \${item.beneficiary} - \${item.amount}</li>\`).join('') +
                '</ul>' +
                '<p style="color: #8c8c8c;">Please review these items individually before proceeding.</p>' +
              '</div>'
            ),
            okText: 'Understood'
          });
        });

        // ========================================
        // ✗ Handle Reject Entire Batch
        // ========================================
        addEventListenerTo('[data-action="reject-all"]', 'click', async () => {
          try {
            const values = await form.validateFields(['comments']);
            
            if (!values.comments || values.comments.trim() === '') {
              A.message.warning('Please provide a reason for rejecting the entire batch');
              return;
            }

            A.Modal.confirm({
              title: '⚠️ Reject Entire Batch?',
              content: (
                '<div style="line-height: 1.8">' +
                  '<p><strong style="color: #ff4d4f;">Warning:</strong> This will reject all transactions in this batch.</p>' +
                  '<p>Reason: ' + values.comments + '</p>' +
                  '<p style="margin-top: 16px; color: #8c8c8c;">This action cannot be undone.</p>' +
                '</div>'
              ),
              okText: 'Yes, Reject Batch',
              okType: 'danger',
              cancelText: 'Cancel',
              onOk: async () => {
                const hide = A.message.loading('Rejecting batch...', 0);
                
                // Simulate API call
                await new Promise(resolve => setTimeout(resolve, 1000));
                
                const updatedData = tableData.map(item => ({ ...item, status: 'Rejected' }));
                setTableData(updatedData);
                updateStats(updatedData);
                
                hide();
                
                A.Modal.error({
                  title: '✗ Batch Rejected',
                  content: 'The entire batch has been rejected. The submitter will be notified.',
                  okText: 'Done'
                });
              }
            });
          } catch (error) {
            // Validation failed
          }
        });

        console.log('✅ Template 010 (Table with Actions) loaded successfully!');
      `,

      // Process Info
      processInfo: {
        processName: "Payment Processing",
        taskName: "Review Payment Batch",
        initiator: "John Smith",
        status: "Pending Review"
      },

      // Context (Backend Data)
      context: {
        correlationId: "CORR-99999",
        taskId: "task-010",
        processVariables: {
          batchId: "BATCH-2026-0115",
          submittedBy: "John Smith",
          totalAmount: 125450.00,
          transactionCount: 15
        },
        entityData: {
          reviewerName: "Admin User",
          reviewerEmail: "admin@example.com"
        },
        userPermissions: {
          canApprove: true,
          canReject: true,
          canFlag: true,
          canApproveAll: true,
          canRejectBatch: true
        },
        // 📊 Table data - this is what the table will display
        tableData: [
          { id: 1, transactionId: 'TXN-001', beneficiary: 'ABC Corporation', accountNumber: '1234567890', amount: '$12,500.00', status: 'Pending' },
          { id: 2, transactionId: 'TXN-002', beneficiary: 'XYZ Suppliers Ltd', accountNumber: '2345678901', amount: '$8,750.00', status: 'Pending' },
          { id: 3, transactionId: 'TXN-003', beneficiary: 'Global Tech Solutions', accountNumber: '3456789012', amount: '$15,200.00', status: 'Pending' },
          { id: 4, transactionId: 'TXN-004', beneficiary: 'Premier Services Inc', accountNumber: '4567890123', amount: '$6,300.00', status: 'Pending' },
          { id: 5, transactionId: 'TXN-005', beneficiary: 'Elite Manufacturing', accountNumber: '5678901234', amount: '$22,100.00', status: 'Pending' },
          { id: 6, transactionId: 'TXN-006', beneficiary: 'Mega Retail Group', accountNumber: '6789012345', amount: '$9,450.00', status: 'Pending' },
          { id: 7, transactionId: 'TXN-007', beneficiary: 'Quality Imports Co', accountNumber: '7890123456', amount: '$11,800.00', status: 'Pending' },
          { id: 8, transactionId: 'TXN-008', beneficiary: 'Superior Logistics', accountNumber: '8901234567', amount: '$7,650.00', status: 'Pending' },
          { id: 9, transactionId: 'TXN-009', beneficiary: 'Dynamic Systems Ltd', accountNumber: '9012345678', amount: '$13,200.00', status: 'Pending' },
          { id: 10, transactionId: 'TXN-010', beneficiary: 'Innovative Solutions', accountNumber: '0123456789', amount: '$5,900.00', status: 'Pending' },
          { id: 11, transactionId: 'TXN-011', beneficiary: 'TechCorp Industries', accountNumber: '1230987654', amount: '$4,200.00', status: 'Pending' },
          { id: 12, transactionId: 'TXN-012', beneficiary: 'Metro Services Inc', accountNumber: '2341098765', amount: '$3,100.00', status: 'Pending' },
          { id: 13, transactionId: 'TXN-013', beneficiary: 'Atlas Trading Co', accountNumber: '3452109876', amount: '$2,500.00', status: 'Pending' },
          { id: 14, transactionId: 'TXN-014', beneficiary: 'Zenith Enterprises', accountNumber: '4563210987', amount: '$1,850.00', status: 'Pending' },
          { id: 15, transactionId: 'TXN-015', beneficiary: 'Apex Distribution', accountNumber: '5674321098', amount: '$950.00', status: 'Pending' }
        ]
      }
    },

    /**
     * ============================================================================
     * 🏦 TEMPLATE 011: Credit Provider Selection Form
     * ============================================================================
     * Use Case: Select credit provider for customer credit check/inquiry
     * Features:
     * - Customer information display (read-only review section)
     * - Credit provider selection (CRC, First Central, Credit Registry)
     * - Clean, professional layout
     * - Customer context at top of form
     * ============================================================================
     */
    "FORM-TEST-011": {
      formId: "FORM-TEST-011",

      // Form Definition
      formJson: {
        fields: [
          // ========================================
          // Customer Information Review Section
          // ========================================
          {
            id: "customer_info_divider",
            type: "divider",
            config: {
              text: "📋 Customer Information",
              fontSize: "18px",
              fontWeight: "600",
              color: "#1890ff",
              marginBottom: "16px"
            }
          },

          {
            id: "customer_name_label",
            type: "description-item",
            config: {
              label: "Customer Name",
              value: "{{customerName}}"
            },
            display: {
              span: 12
            }
          },

          {
            id: "bvn_label",
            type: "description-item",
            config: {
              label: "BVN",
              value: "{{bvn}}"
            },
            display: {
              span: 12
            }
          },

          {
            id: "loan_id_label",
            type: "description-item",
            config: {
              label: "Loan ID",
              value: "{{loanId}}"
            },
            display: {
              span: 12
            }
          },

          // ========================================
          // Credit Provider Selection Section
          // ========================================
          {
            id: "provider_selection_divider",
            type: "divider",
            config: {
              text: "🏢 Credit Provider Selection",
              fontSize: "18px",
              fontWeight: "600",
              color: "#1890ff",
              marginTop: "32px",
              marginBottom: "16px"
            }
          },

          {
            id: "info_text",
            type: "text",
            config: {
              text: "Select a credit provider to query customer credit history and risk assessment.",
              fontSize: "14px",
              color: "#595959",
              marginBottom: "24px"
            }
          },

          {
            id: "credit_provider",
            type: "select",
            config: {
              label: "Credit Provider",
              name: "credit_provider",
              placeholder: "Select a credit provider",
              required: true,
              rules: [
                { required: true, message: "Please select a credit provider" }
              ],
              options: [
                { value: "crc", label: "CRC (Credit Reference Company)" },
                { value: "first_central", label: "First Central" },
                { value: "credit_registry", label: "Credit Registry" }
              ]
            }
          },

          {
            id: "inquiry_reason",
            type: "textarea",
            config: {
              label: "Reason for Inquiry",
              name: "inquiry_reason",
              placeholder: "Please provide a brief reason for this credit inquiry...",
              required: true,
              rows: 4,
              rules: [
                { required: true, message: "Please provide a reason for the inquiry" },
                { min: 10, message: "Reason must be at least 10 characters" }
              ]
            }
          },

          // ========================================
          // Action Buttons
          // ========================================
          {
            id: "submit_button",
            type: "button",
            config: {
              text: "Submit Credit Inquiry",
              action: "submit-inquiry",
              type: "primary",
              size: "large",
              block: true,
              icon: "check-circle"
            }
          }
        ]
      },

      // Client-side Script
      clientScript: `
        try {
          // ========================================
          // 🎯 Initialize Credit Provider Selection Form
          // ========================================
          console.log('🏦 Credit Provider Selection Form - Initializing...');
          console.log('📦 Context data:', context);

          // ========================================
          // 🎨 Add custom styling for provider options
          // ========================================
        const style = document.createElement('style');
        style.textContent = \`
          /* Provider Options */
          .ant-select-item-option {
            padding: 12px 16px !important;
          }
          
          .ant-select-item-option-content {
            font-size: 14px;
            font-weight: 500;
          }
        \`;
        document.head.appendChild(style);

        // ========================================
        // 📝 Handle Provider Selection Change
        // ========================================
        const providerField = form.getFieldInstance('credit_provider');
        
        if (providerField) {
          // Listen for provider change
          form.setFieldValue('credit_provider', form.getFieldValue('credit_provider'));
          
          // Add info message about selected provider
          const originalOnChange = providerField.props?.onChange;
          
          // Note: In production, you'd properly override the onChange
          console.log('✅ Credit provider field initialized');
        }

        // ========================================
        // 🚀 Handle Form Submission
        // ========================================
        addEventListenerTo('[data-action="submit-inquiry"]', 'click', async () => {
          try {
            // Validate all fields
            const values = await form.validateFields();
            
            console.log('📤 Submitting credit inquiry:', values);
            
            // Show loading
            const hide = A.message.loading('Submitting credit inquiry...', 0);
            
            // Simulate API call
            await new Promise(resolve => setTimeout(resolve, 1500));
            
            hide();
            
            // Get provider label
            const providerLabels = {
              crc: 'CRC (Credit Reference Company)',
              first_central: 'First Central',
              credit_registry: 'Credit Registry'
            };
            
            const providerLabel = providerLabels[values.credit_provider] || values.credit_provider;
            
            // Show success modal
            A.Modal.success({
              title: '✅ Credit Inquiry Submitted',
              width: 600,
              content: (
                '<div style="line-height: 1.8">' +
                  '<p>Your credit inquiry has been successfully submitted to <strong>' + providerLabel + '</strong>.</p>' +
                  '<div style="background: #f6ffed; border: 1px solid #b7eb8f; border-radius: 8px; padding: 16px; margin-top: 16px;">' +
                    '<p style="margin: 0; color: #52c41a; font-weight: 600;">📋 Inquiry Details</p>' +
                    '<ul style="margin: 12px 0 0 0; padding-left: 20px; color: #595959;">' +
                      '<li><strong>Customer:</strong> ' + customerName + '</li>' +
                      '<li><strong>BVN:</strong> ' + bvn + '</li>' +
                      '<li><strong>Loan ID:</strong> ' + loanId + '</li>' +
                      '<li><strong>Provider:</strong> ' + providerLabel + '</li>' +
                    '</ul>' +
                  '</div>' +
                  '<p style="margin-top: 16px; color: #8c8c8c;">Reference Number: <strong style="color: #1890ff;">CRI-' + Date.now() + '</strong></p>' +
                  '<p style="color: #8c8c8c;">Estimated response time: 2-4 hours</p>' +
                '</div>'
              ),
              okText: 'Done',
              onOk: () => {
                // Reset form
                form.resetFields(['credit_provider', 'inquiry_reason']);
                A.message.success('Form reset for next inquiry');
              }
            });
            
          } catch (error) {
            console.error('❌ Validation failed:', error);
            A.message.error('Please complete all required fields');
          }
        });

        console.log('✅ Credit Provider Selection Form loaded successfully!');
        
        } catch (scriptError) {
          // ========================================
          // ❌ Global Script Error Handler
          // ========================================
          console.error('❌ Form script error:', scriptError);
          
          // Show user-friendly error message
          A.message.error({
            content: 'Form initialization failed. Please contact support.',
            duration: 5
          });
          
          // Re-throw to let DynamicJSX show detailed error panel
          throw new Error(\`Form script error: \${scriptError.message || scriptError}\`);
        }
      `,

      // Process Info
      processInfo: {
        processName: "Credit Verification Process",
        taskName: "Credit Provider Selection",
        initiator: "Loan Officer - Sarah Williams",
        status: "Pending Selection"
      },

      // Context (Backend Data)
      context: {
        correlationId: "CORR-CREDIT-2026-0115",
        taskId: "task-credit-011",

        // Customer Information
        customerName: "Michael Johnson",
        bvn: "22234567890",
        loanId: "LN-2026-00587",

        // Additional context
        processVariables: {
          loanAmount: 5000000,
          loanPurpose: "Business Expansion",
          applicationType: "Individual Loan",
          applicationDate: "2026-01-10"
        },

        entityData: {
          customerPhone: "+234 803 456 7890",
          customerEmail: "michael.johnson@example.com",
          loanOfficer: "Sarah Williams",
          branch: "Victoria Island Branch"
        },

        userPermissions: {
          canSubmitInquiry: true,
          canViewCreditReport: true,
          canSelectProvider: true
        }
      }
    }
  };
